<template>
    <section  class="configurator__wrapper" :class="getConfiguratorClass()">
        <div v-if="!readOnlyMode && !orderedMode" class="configurator__wrapper--left box--layout box--layout_1">
            <div class="box--headline">
                {{$t('symbol_library')}}
                <svg tabindex="0" width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 8C0 12.381 3.61905 16 8 16C12.381 16 16 12.381 16 8C16 3.61905 12.3748 0 7.99386 0C3.6129 0 0 3.61905 0 8ZM15 8C15.0063 11.8763 11.8749 15 7.99685 15C4.1125 15 1 11.8763 1 8C1 4.12366 4.10623 1 7.99058 1C11.8687 1 14.9937 4.12366 15 8ZM7.94931 5.31336C7.47619 5.31336 7.09319 4.936 7.09319 4.46288C7.09319 3.98413 7.47619 3.60676 7.94931 3.60676C8.42806 3.60676 8.7998 3.98413 8.7998 4.46288C8.7998 4.936 8.42806 5.31336 7.94931 5.31336ZM6.24834 11.5315C6.24834 11.7849 6.4511 11.9764 6.71019 11.9764H9.67844C9.93753 11.9764 10.1347 11.7849 10.1347 11.5315C10.1347 11.2837 9.93753 11.0922 9.67844 11.0922H8.68715V7.14951C8.68715 6.82284 8.51818 6.59754 8.20277 6.59754H6.81157C6.55812 6.59754 6.35535 6.79467 6.35535 7.03687C6.35535 7.29032 6.55812 7.48182 6.81157 7.48182H7.70149V11.0922H6.71019C6.4511 11.0922 6.24834 11.2837 6.24834 11.5315Z" fill="black"/>
                </svg>
                <div href="#" id="target1" class="box__headline--info">
                    <img src="../assets/images/symbol_library.png" />
                    <h3>{{$t('symbol_library')}}</h3>
                    <p>{{$t('symbol_library_info')}}</p>
                </div>
            </div>
            <div class="box--search">
                <svg width="14" height="14" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9578 11.2347C8.09499 11.2347 5.7653 8.90543 5.7653 6.04174C5.7653 3.1789 8.09499 0.849634 10.9578 0.849634C13.8207 0.849634 16.1504 3.1789 16.1504 6.04174C16.1504 8.90543 13.8207 11.2347 10.9578 11.2347ZM10.9578 0C7.62599 0 4.91566 2.71033 4.91566 6.04174C4.91566 7.55537 5.47897 8.93687 6.40125 9.99806L0.124578 16.2743C-0.0415258 16.4404 -0.0415258 16.7093 0.124578 16.875C0.207417 16.9583 0.31617 16.9995 0.424923 16.9995C0.533676 16.9995 0.642429 16.9583 0.725268 16.875L7.00194 10.5988C8.06355 11.5215 9.44421 12.0843 10.9578 12.0843C14.2897 12.0843 17 9.37358 17 6.04174C17 2.71033 14.2897 0 10.9578 0Z" fill="black"/>
                </svg>
                <input spellcheck="false" type="text" v-model="iconSearchTerm" placeholder="Search" />
                <div @click="iconSearchTerm = '';" class="icon--remove">
                    <svg v-if="iconSearchTerm.length > 0" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4143 11.9999L20.4854 19.0709C20.8759 19.4614 20.8759 20.0946 20.4854 20.4851C20.0949 20.8757 19.4617 20.8757 19.0712 20.4851L12.0001 13.4141L4.92903 20.4851C4.53851 20.8757 3.90534 20.8757 3.51482 20.4851C3.12429 20.0946 3.12429 19.4614 3.51482 19.0709L10.5859 11.9999L3.51482 4.92879C3.12429 4.53826 3.12429 3.9051 3.51482 3.51457C3.90534 3.12405 4.53851 3.12405 4.92903 3.51457L12.0001 10.5856L19.0712 3.51457C19.4617 3.12405 20.0949 3.12405 20.4854 3.51457C20.8759 3.9051 20.8759 4.53826 20.4854 4.92879L13.4143 11.9999Z" fill="black"></path>
                    </svg>
                </div>
            </div>
            <div class="box--navigation">
                <span @click="currentLibrary = 'symbols'" :class="{'active': currentLibrary == 'symbols'}">{{$t('symbols')}}</span>
                <span @click="currentLibrary = 'groups'" :class="{'active': currentLibrary == 'groups'}">{{$t('symbol_groups')}}</span>
            </div>
            <div class="box--content">
                <div v-show="currentLibrary == 'symbols'" class="symbol__library--wrapper">
                    <div v-if="foundIconsLeft > 0" class="symbol__library--grid">
                        <div v-show="!icon.hidden" :key="icon.id" v-for="icon in filteredIconsLeft" class="symbol__library--entry symbol__library--draggable" :data-tags="icon.tags.join(',')" :data-icon="icon.name" :style="'background-image: url(https://configurator.loxone.com/files/translations/Icons/' + icon.name + ')'">&nbsp;</div>
                    </div>
                    <div v-else class="symbol__library--grid symbol__library--empty">
                        <div>
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="40" height="40" fill="#F5F5F5"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M24.9163 23.5336C26.1196 22.0293 26.8391 20.1212 26.8391 18.0451C26.8391 13.1888 22.9023 9.25195 18.046 9.25195C13.1897 9.25195 9.25293 13.1888 9.25293 18.0451C9.25293 22.9014 13.1897 26.8382 18.046 26.8382C20.1222 26.8382 22.0303 26.1186 23.5346 24.9153L29.0793 30.46C29.4609 30.8416 30.0795 30.8416 30.461 30.46C30.8426 30.0785 30.8426 29.4599 30.461 29.0783L24.9163 23.5336ZM18.046 24.8841C14.2689 24.8841 11.207 21.8222 11.207 18.0451C11.207 14.2679 14.2689 11.206 18.046 11.206C21.8232 11.206 24.8851 14.2679 24.8851 18.0451C24.8851 21.8222 21.8232 24.8841 18.046 24.8841Z" fill="black"/>
                            </svg>
                            <div>{{$t('no_search_results')}}</div>
                        </div>
                    </div>
                </div>
                <div v-show="currentLibrary == 'groups'" class="symbol__groups--wrapper">
                    <div class="symbol__groups--grid" v-if="foundGroupsLeft > 0">
                        <div v-show="!group.hidden" :key="group.id" v-for="group in filteredGroupsLeft" class="symbol__group--entry" :data-group="group.id" >
                            <div v-for="icon in JSON.parse(group.icons)" :key="icon" class="symbol__group--icon" :style="'background-image: url(https://configurator.loxone.com/files/translations/Icons/' + icon + ')'">&nbsp;</div>
                        </div>
                    </div>
                    <div v-else class="symbol__library--grid symbol__library--empty">
                        <div>
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="40" height="40" fill="#F5F5F5"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M24.9163 23.5336C26.1196 22.0293 26.8391 20.1212 26.8391 18.0451C26.8391 13.1888 22.9023 9.25195 18.046 9.25195C13.1897 9.25195 9.25293 13.1888 9.25293 18.0451C9.25293 22.9014 13.1897 26.8382 18.046 26.8382C20.1222 26.8382 22.0303 26.1186 23.5346 24.9153L29.0793 30.46C29.4609 30.8416 30.0795 30.8416 30.461 30.46C30.8426 30.0785 30.8426 29.4599 30.461 29.0783L24.9163 23.5336ZM18.046 24.8841C14.2689 24.8841 11.207 21.8222 11.207 18.0451C11.207 14.2679 14.2689 11.206 18.046 11.206C21.8232 11.206 24.8851 14.2679 24.8851 18.0451C24.8851 21.8222 21.8232 24.8841 18.046 24.8841Z" fill="black"/>
                            </svg>
                            <div>{{$t('no_search_results')}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="configuratorReady" class="configurator__main" :class="configuration.color">
            <div v-if="!readOnlyMode && !orderedMode && configuration.saved_buttons && Object.values(configuration.saved_buttons).length > 0" class="additional__buttons--wrapper">
                <div class="additional__buttons--list">
                    <div :data-id="button.id" v-for="button in configuration.saved_buttons" :key="button" class="additional__buttons--entry">
                        <div>
                            <div>
                                <img v-if="button.data.icon" draggable="false" class="button__entry--image" :src="'https://configurator.loxone.com/files/translations/Icons/' + button.data.icon" />
                                <div v-if="button.data.text" class="button__entry--text">{{button.data.text}}</div>
                            </div>
                        </div>
                        <svg @click="deleteSavedButton(button.id)" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="12" fill="#DEDEDE"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L10.5858 12L7.29289 15.2929C6.90237 15.6834 6.90237 16.3166 7.29289 16.7071C7.68342 17.0976 8.31658 17.0976 8.70711 16.7071L12 13.4142L15.2929 16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071C17.0976 16.3166 17.0976 15.6834 16.7071 15.2929L13.4142 12L16.7071 8.70711C17.0976 8.31658 17.0976 7.68342 16.7071 7.29289C16.3166 6.90237 15.6834 6.90237 15.2929 7.29289L12 10.5858L8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289Z" fill="black"/>
                            <path d="M7.29289 8.70711L7.46967 8.53033L7.29289 8.70711ZM7.29289 7.29289L7.46967 7.46967L7.29289 7.29289ZM10.5858 12L10.7626 12.1768L10.9393 12L10.7626 11.8232L10.5858 12ZM7.29289 15.2929L7.46967 15.4697H7.46967L7.29289 15.2929ZM7.29289 16.7071L7.46967 16.5303H7.46967L7.29289 16.7071ZM8.70711 16.7071L8.88388 16.8839L8.70711 16.7071ZM12 13.4142L12.1768 13.2374L12 13.0607L11.8232 13.2374L12 13.4142ZM13.4142 12L13.2374 11.8232L13.0607 12L13.2374 12.1768L13.4142 12ZM16.7071 8.70711L16.5303 8.53033V8.53033L16.7071 8.70711ZM16.7071 7.29289L16.5303 7.46967V7.46967L16.7071 7.29289ZM15.2929 7.29289L15.4697 7.46967V7.46967L15.2929 7.29289ZM12 10.5858L11.8232 10.7626L12 10.9393L12.1768 10.7626L12 10.5858ZM8.70711 7.29289L8.53033 7.46967L8.70711 7.29289ZM7.46967 8.53033C7.17678 8.23744 7.17678 7.76256 7.46967 7.46967L7.11612 7.11612C6.62796 7.60427 6.62796 8.39573 7.11612 8.88388L7.46967 8.53033ZM10.7626 11.8232L7.46967 8.53033L7.11612 8.88388L10.409 12.1768L10.7626 11.8232ZM10.409 11.8232L7.11612 15.1161L7.46967 15.4697L10.7626 12.1768L10.409 11.8232ZM7.11612 15.1161C6.62796 15.6043 6.62796 16.3957 7.11612 16.8839L7.46967 16.5303C7.17678 16.2374 7.17678 15.7626 7.46967 15.4697L7.11612 15.1161ZM7.11612 16.8839C7.60427 17.372 8.39573 17.372 8.88388 16.8839L8.53033 16.5303C8.23744 16.8232 7.76256 16.8232 7.46967 16.5303L7.11612 16.8839ZM8.88388 16.8839L12.1768 13.591L11.8232 13.2374L8.53033 16.5303L8.88388 16.8839ZM15.4697 16.5303L12.1768 13.2374L11.8232 13.591L15.1161 16.8839L15.4697 16.5303ZM16.5303 16.5303C16.2374 16.8232 15.7626 16.8232 15.4697 16.5303L15.1161 16.8839C15.6043 17.372 16.3957 17.372 16.8839 16.8839L16.5303 16.5303ZM16.5303 15.4697C16.8232 15.7626 16.8232 16.2374 16.5303 16.5303L16.8839 16.8839C17.372 16.3957 17.372 15.6043 16.8839 15.1161L16.5303 15.4697ZM13.2374 12.1768L16.5303 15.4697L16.8839 15.1161L13.591 11.8232L13.2374 12.1768ZM13.591 12.1768L16.8839 8.88388L16.5303 8.53033L13.2374 11.8232L13.591 12.1768ZM16.8839 8.88388C17.372 8.39573 17.372 7.60427 16.8839 7.11612L16.5303 7.46967C16.8232 7.76256 16.8232 8.23744 16.5303 8.53033L16.8839 8.88388ZM16.8839 7.11612C16.3957 6.62796 15.6043 6.62796 15.1161 7.11612L15.4697 7.46967C15.7626 7.17678 16.2374 7.17678 16.5303 7.46967L16.8839 7.11612ZM15.1161 7.11612L11.8232 10.409L12.1768 10.7626L15.4697 7.46967L15.1161 7.11612ZM8.53033 7.46967L11.8232 10.7626L12.1768 10.409L8.88388 7.11612L8.53033 7.46967ZM7.46967 7.46967C7.76256 7.17678 8.23744 7.17678 8.53033 7.46967L8.88388 7.11612C8.39573 6.62796 7.60427 6.62796 7.11612 7.11612L7.46967 7.46967Z" fill="#DEDEDE"/>
                        </svg>
                    </div>
                </div>
            </div>
            <div id="workSurface" style="" class="configurator__inner" :class="{'grid--visible': gridVisible}">
                <touch-flex :backlightActive="backlightActive" :orientationLightVisible="!readOnlyMode && !orderedMode" :currentZoom="scaleFactor" :activeVal="current_touch_area.id" :key="touchFlexLiveVersion+'_'+configuration.sku" @mousedown="openTouchAreaInterface" :interactive="true" :configuration="configuration" :style="handleConfiguratorEntryStyle()"></touch-flex>
            </div>
            <template v-if="[100608, 100609, 100610, 100611, 100612, 100613, 100614, 100615, 100673, 100674, 100675, 100676].includes(configuration.sku)">
                <div class="interactive__buttons interactive__buttons--v2">
                    <div class="zoom__wrapper">
                        <span @click="zoom('out')" class="zoom--out">-</span>
                        <span class="zoom--data">{{Math.round(50 * (scaleFactor+0.5))}}%</span>
                        <span @click="zoom('in')" class="zoom--in">+</span>
                    </div>
                    <div class="toogle__buttons--wrapper toogle__buttons--wrapperv2">
                        <!-- EDITMODE -->
                        <div @click="showGrid(true);activateBacklight(false)" :class="'grid_wrapper' + (gridVisible ? ' active' : '')">
                            <div class="grid--show">{{$t('edit_mode')}}</div>
                        </div>
                        <div @click="showGrid(false);activateBacklight(true)" :class="'grid_wrapper' + (backlightActive ? ' active' : '')">
                            <div class="grid--show">Backlight</div>
                        </div>
                        <div @click="showGrid(false);activateBacklight(false)" :class="'grid_wrapper' + (!gridVisible && !backlightActive ? ' active' : '')">
                            <div class="grid--show">Daylight</div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="interactive__buttons">
                    <div class="zoom__wrapper">
                        <span @click="zoom('out')" class="zoom--out">-</span>
                        <span class="zoom--data">{{Math.round(50 * (scaleFactor+0.5))}}%</span>
                        <span @click="zoom('in')" class="zoom--in">+</span>
                    </div>
                    <div @click="toggleGrid()" class="grid__wrapper">
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 1.5H13.5V13.5H1.5V1.5Z" stroke="black" stroke-linejoin="round"/>
                            <path d="M6 1V14H5V1H6Z" fill="black"/>
                            <path d="M10 1V14H9V1H10Z" fill="black"/>
                            <path d="M14 9V10H1V9H14Z" fill="black"/>
                            <path d="M14 5V6H1V5H14Z" fill="black"/>
                        </svg>
                        <div v-if="gridVisible" class="grid--show">{{$t('preview_mode')}}</div>
                        <div v-else class="grid--show">{{$t('edit_mode')}}</div>
                    </div>
                </div>
            </template>
        </div>
        <div v-else class="configuration__loader">
            <div class="configuration__loader--inner">
                <div class="configuration__inner--bar">
                    <div :style="'width:' + Math.round(100 / Object.entries(this.loadingData.data).length * loadingInfo.progress) + '%;'" class="configuration__bar--progress">&nbsp;</div>
                </div>
            </div>
        </div>
        <div class="overlay__floater--wrapper">
            <div v-if="layoutsVisible" class="dropdown__group--list" style="padding-bottom: 10px;">
                <div @click="toggleLayouts()" class="dropdown__group--headline">
                    {{$t('layouts')}}
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4143 11.9999L20.4854 19.0709C20.8759 19.4614 20.8759 20.0946 20.4854 20.4851C20.0949 20.8757 19.4617 20.8757 19.0712 20.4851L12.0001 13.4141L4.92903 20.4851C4.53851 20.8757 3.90534 20.8757 3.51482 20.4851C3.12429 20.0946 3.12429 19.4614 3.51482 19.0709L10.5859 11.9999L3.51482 4.92879C3.12429 4.53826 3.12429 3.9051 3.51482 3.51457C3.90534 3.12405 4.53851 3.12405 4.92903 3.51457L12.0001 10.5856L19.0712 3.51457C19.4617 3.12405 20.0949 3.12405 20.4854 3.51457C20.8759 3.9051 20.8759 4.53826 20.4854 4.92879L13.4143 11.9999Z" fill="black"/>
                    </svg>
                </div>
                <div class="dropdown__group--content dropdown__type--touchflex">
                    <div @click="changeLayout(template)" v-for="template in availableLayouts" :key="template.id">
                        <touch-flex :configuration="template"></touch-flex>
                    </div>
                </div>
            </div>
            <div v-show="symbolsVisible" class="dropdown__group--list">
                <div @click="toggleSymbols()" class="dropdown__group--headline">
                    {{$t('symbols')}}
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4143 11.9999L20.4854 19.0709C20.8759 19.4614 20.8759 20.0946 20.4854 20.4851C20.0949 20.8757 19.4617 20.8757 19.0712 20.4851L12.0001 13.4141L4.92903 20.4851C4.53851 20.8757 3.90534 20.8757 3.51482 20.4851C3.12429 20.0946 3.12429 19.4614 3.51482 19.0709L10.5859 11.9999L3.51482 4.92879C3.12429 4.53826 3.12429 3.9051 3.51482 3.51457C3.90534 3.12405 4.53851 3.12405 4.92903 3.51457L12.0001 10.5856L19.0712 3.51457C19.4617 3.12405 20.0949 3.12405 20.4854 3.51457C20.8759 3.9051 20.8759 4.53826 20.4854 4.92879L13.4143 11.9999Z" fill="black"/>
                    </svg>
                </div>
                <div class="box--search">
                    <svg width="14" height="14" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9578 11.2347C8.09499 11.2347 5.7653 8.90543 5.7653 6.04174C5.7653 3.1789 8.09499 0.849634 10.9578 0.849634C13.8207 0.849634 16.1504 3.1789 16.1504 6.04174C16.1504 8.90543 13.8207 11.2347 10.9578 11.2347ZM10.9578 0C7.62599 0 4.91566 2.71033 4.91566 6.04174C4.91566 7.55537 5.47897 8.93687 6.40125 9.99806L0.124578 16.2743C-0.0415258 16.4404 -0.0415258 16.7093 0.124578 16.875C0.207417 16.9583 0.31617 16.9995 0.424923 16.9995C0.533676 16.9995 0.642429 16.9583 0.725268 16.875L7.00194 10.5988C8.06355 11.5215 9.44421 12.0843 10.9578 12.0843C14.2897 12.0843 17 9.37358 17 6.04174C17 2.71033 14.2897 0 10.9578 0Z" fill="black"/>
                    </svg>
                    <input spellcheck="false" type="text" ref="symbolSearchInput" v-model="symbolSearchTerm" placeholder="Search" />
                    <div @click="symbolSearchTerm = '';" class="icon--remove">
                        <svg v-if="symbolSearchTerm.length > 0" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4143 11.9999L20.4854 19.0709C20.8759 19.4614 20.8759 20.0946 20.4854 20.4851C20.0949 20.8757 19.4617 20.8757 19.0712 20.4851L12.0001 13.4141L4.92903 20.4851C4.53851 20.8757 3.90534 20.8757 3.51482 20.4851C3.12429 20.0946 3.12429 19.4614 3.51482 19.0709L10.5859 11.9999L3.51482 4.92879C3.12429 4.53826 3.12429 3.9051 3.51482 3.51457C3.90534 3.12405 4.53851 3.12405 4.92903 3.51457L12.0001 10.5856L19.0712 3.51457C19.4617 3.12405 20.0949 3.12405 20.4854 3.51457C20.8759 3.9051 20.8759 4.53826 20.4854 4.92879L13.4143 11.9999Z" fill="black"></path>
                        </svg>
                    </div>
                </div>
                <div class="dropdown__group--content icon--wrapper">
                    <div class="symbol__library--wrapper">
                        <div v-if="foundIconsRight > 0" class="symbol__library--grid">
                            <div @click="current_touch_area.data.icon = icon.name;getCurrentSuggestions();updateTouchArea();this.symbolsVisible = false;" v-show="!icon.hidden" :key="icon.id" v-for="icon in filteredIconsRight" class="symbol__library--entry" :style="'background-image: url(https://configurator.loxone.com/files/translations/Icons/' + icon.name + ')'">&nbsp;</div>
                        </div>
                        <div v-else class="symbol__library--grid symbol__library--empty">
                            <div>
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="40" height="40" fill="#F5F5F5"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M24.9163 23.5336C26.1196 22.0293 26.8391 20.1212 26.8391 18.0451C26.8391 13.1888 22.9023 9.25195 18.046 9.25195C13.1897 9.25195 9.25293 13.1888 9.25293 18.0451C9.25293 22.9014 13.1897 26.8382 18.046 26.8382C20.1222 26.8382 22.0303 26.1186 23.5346 24.9153L29.0793 30.46C29.4609 30.8416 30.0795 30.8416 30.461 30.46C30.8426 30.0785 30.8426 29.4599 30.461 29.0783L24.9163 23.5336ZM18.046 24.8841C14.2689 24.8841 11.207 21.8222 11.207 18.0451C11.207 14.2679 14.2689 11.206 18.046 11.206C21.8232 11.206 24.8851 14.2679 24.8851 18.0451C24.8851 21.8222 21.8232 24.8841 18.046 24.8841Z" fill="black"/>
                                </svg>
                                <div>{{$t('no_search_results')}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="suggestionsVisible" class="dropdown__group--list">
                <div @click="toggleSuggestions()" class="dropdown__group--headline">
                    {{$t('function_library')}}
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4143 11.9999L20.4854 19.0709C20.8759 19.4614 20.8759 20.0946 20.4854 20.4851C20.0949 20.8757 19.4617 20.8757 19.0712 20.4851L12.0001 13.4141L4.92903 20.4851C4.53851 20.8757 3.90534 20.8757 3.51482 20.4851C3.12429 20.0946 3.12429 19.4614 3.51482 19.0709L10.5859 11.9999L3.51482 4.92879C3.12429 4.53826 3.12429 3.9051 3.51482 3.51457C3.90534 3.12405 4.53851 3.12405 4.92903 3.51457L12.0001 10.5856L19.0712 3.51457C19.4617 3.12405 20.0949 3.12405 20.4854 3.51457C20.8759 3.9051 20.8759 4.53826 20.4854 4.92879L13.4143 11.9999Z" fill="black"/>
                    </svg>
                </div>
                <div v-if="Object.values(currentGroup).length == 0" class="box--search">
                    <svg width="14" height="14" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9578 11.2347C8.09499 11.2347 5.7653 8.90543 5.7653 6.04174C5.7653 3.1789 8.09499 0.849634 10.9578 0.849634C13.8207 0.849634 16.1504 3.1789 16.1504 6.04174C16.1504 8.90543 13.8207 11.2347 10.9578 11.2347ZM10.9578 0C7.62599 0 4.91566 2.71033 4.91566 6.04174C4.91566 7.55537 5.47897 8.93687 6.40125 9.99806L0.124578 16.2743C-0.0415258 16.4404 -0.0415258 16.7093 0.124578 16.875C0.207417 16.9583 0.31617 16.9995 0.424923 16.9995C0.533676 16.9995 0.642429 16.9583 0.725268 16.875L7.00194 10.5988C8.06355 11.5215 9.44421 12.0843 10.9578 12.0843C14.2897 12.0843 17 9.37358 17 6.04174C17 2.71033 14.2897 0 10.9578 0Z" fill="black"/>
                    </svg>
                    <input spellcheck="false" type="text" ref="symbolSearchInput" v-model="suggestionSearchTerm" placeholder="Search" />
                    <div @click="suggestionSearchTerm = '';" class="icon--remove">
                        <svg v-if="suggestionSearchTerm.length > 0" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4143 11.9999L20.4854 19.0709C20.8759 19.4614 20.8759 20.0946 20.4854 20.4851C20.0949 20.8757 19.4617 20.8757 19.0712 20.4851L12.0001 13.4141L4.92903 20.4851C4.53851 20.8757 3.90534 20.8757 3.51482 20.4851C3.12429 20.0946 3.12429 19.4614 3.51482 19.0709L10.5859 11.9999L3.51482 4.92879C3.12429 4.53826 3.12429 3.9051 3.51482 3.51457C3.90534 3.12405 4.53851 3.12405 4.92903 3.51457L12.0001 10.5856L19.0712 3.51457C19.4617 3.12405 20.0949 3.12405 20.4854 3.51457C20.8759 3.9051 20.8759 4.53826 20.4854 4.92879L13.4143 11.9999Z" fill="black"></path>
                        </svg>
                    </div>
                </div>
                <div class="dropdown__group--content dropdown__type--functions icon--wrapper group--scrollable">
                    <div class="box__content--scroller">
                        <div v-if="foundGroups == 0 && foundSuggestions == 0" class="symbol__library--grid symbol__library--empty" style="padding:50px 0">
                            <div>
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="40" height="40" fill="#F5F5F5"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M24.9163 23.5336C26.1196 22.0293 26.8391 20.1212 26.8391 18.0451C26.8391 13.1888 22.9023 9.25195 18.046 9.25195C13.1897 9.25195 9.25293 13.1888 9.25293 18.0451C9.25293 22.9014 13.1897 26.8382 18.046 26.8382C20.1222 26.8382 22.0303 26.1186 23.5346 24.9153L29.0793 30.46C29.4609 30.8416 30.0795 30.8416 30.461 30.46C30.8426 30.0785 30.8426 29.4599 30.461 29.0783L24.9163 23.5336ZM18.046 24.8841C14.2689 24.8841 11.207 21.8222 11.207 18.0451C11.207 14.2679 14.2689 11.206 18.046 11.206C21.8232 11.206 24.8851 14.2679 24.8851 18.0451C24.8851 21.8222 21.8232 24.8841 18.046 24.8841Z" fill="black"/>
                                </svg>
                                <div>{{$t('no_search_results')}}</div>
                            </div>
                        </div>
                        <template v-else>
                            <template v-if="Object.values(currentGroup).length == 0 ">
                                <div v-if="foundSuggestions > 0" class="dropdown__suggestion--wrapper">
                                    <template v-for="suggestion in currentSuggestions.suggestions" :key="suggestion">
                                        <div v-if="!suggestion.hidden" class="dropdown__suggestion" @click="fillTouchArea(suggestion);updateTouchArea();">
                                            <div class="dropdown__suggestion--info">
                                                <template v-if="suggestion.function">{{suggestion.function}}: </template>
                                                {{suggestion.text}}
                                            </div>
                                            <div class="dropdown__suggestion--abbrevation">
                                                <template v-if="suggestion.function_block && suggestion.function_block != 'others'">
                                                    {{$t('config.' + suggestion.function_block + '.name')}}
                                                </template>
                                                <template v-else>
                                                    {{$t('others')}}
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div v-if="foundGroups > 0" class="dropdown__function--wrapper">
                                    <template v-for="group in currentSuggestions.groups" :key="group">
                                        <div v-if="!group.hidden" @click="openGroup(group)" class="dropdown__function--group">
                                            <div>{{group.title}}</div>
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.6109 7.87336L10.3162 4.04072C10.2836 4.01172 10.2413 3.99739 10.1986 4.00039C10.1556 4.00406 10.1158 4.02439 10.0877 4.05839L9.37243 4.91905C9.34463 4.95238 9.33073 4.99638 9.33396 5.04038C9.33752 5.08472 9.35788 5.12572 9.39053 5.15438L12.6392 7.99936L9.39053 10.8457C9.35756 10.8743 9.33752 10.9153 9.33396 10.9597C9.33073 11.0037 9.34431 11.0477 9.37243 11.081L10.0877 11.9417C10.1158 11.9757 10.1556 11.996 10.1986 11.9997C10.2025 12 10.2067 12 10.2105 12C10.2493 12 10.2868 11.9857 10.3162 11.9593L14.6109 8.12536C14.6465 8.0937 14.6668 8.04803 14.6668 7.99936C14.6668 7.9507 14.6465 7.90503 14.6109 7.87336Z" fill="black"/>
                                            </svg>
                                        </div>
                                    </template>
                                </div>
                            </template>
                            <template v-else>
                                <div class="function__group--wrapper">
                                    <div @click="closeGroup()" class="function__group--title">
                                        <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.389088 3.87336L4.68376 0.0407242C4.7164 0.0117244 4.75875 -0.00260881 4.80141 0.000391166C4.8444 0.00405781 4.88416 0.024391 4.91228 0.0583907L5.62757 0.919051C5.65537 0.952384 5.66927 0.996384 5.66604 1.04038C5.66248 1.08472 5.64212 1.12572 5.60947 1.15438L2.36075 3.99936L5.60947 6.84568C5.64244 6.87434 5.66248 6.91534 5.66604 6.95967C5.66927 7.00367 5.65569 7.04767 5.62757 7.08101L4.91228 7.94167C4.88416 7.97567 4.8444 7.996 4.80141 7.99967C4.79753 8 4.79333 8 4.78945 8C4.75067 8 4.71317 7.98567 4.68376 7.95933L0.389088 4.12536C0.353533 4.0937 0.33317 4.04803 0.33317 3.99936C0.33317 3.9507 0.353533 3.90503 0.389088 3.87336Z" fill="black"/>
                                        </svg>
                                        <span>{{currentGroup.title}}</span>
                                    </div>
                                    <div @click="fillTouchArea(entry);updateTouchArea();" v-for="entry in currentGroup.entries" :key="entry.id" class="function__group--entry">
                                        <template v-if="entry.function">{{entry.function}}: </template>
                                        {{entry.text}}
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="configurator__wrapper--right configurator__wrapper--right_top">
            <div class="box--layout" :class="{'closed' :(settings == 'touch_area' && !readOnlyMode && !orderedMode)}">
                <div class="box--headline box--clickable" @click="closeOverlays();closeTouchAreaInterface();settings = 'global'" >{{$t('touch_flex_settings')}}</div>
                <div class="box--content" v-if="settings != 'touch_area' || readOnlyMode || orderedMode">
                    <div class="box__content--scroller">
                        <div class="box__content--scroll-inner">
                            <div class="box--group">
                                <div class="box__group--input">
                                    <label>{{$t('description')}}<span class="required">*</span>
                                        <div class="box__group--icon">
                                            <svg tabindex="1234" width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="9.00065" cy="8.50065" r="7.66667" stroke="black"/>
                                                <path d="M7.33398 8.16602H9.00065V11.8327" stroke="black" stroke-linecap="round"/>
                                                <ellipse cx="8.66602" cy="5.5" rx="1" ry="1" fill="black"/>
                                                <path d="M7.33398 12.1673H10.6673" stroke="black" stroke-linecap="round"/>
                                            </svg>
                                            <div class="box__headline--info">
                                                <img src="../assets/images/description.png" />
                                                <h3>{{$t('description')}}</h3>
                                                <p>{{$t('description_info')}}</p>
                                            </div>
                                        </div>
                                    </label>
                                    <textarea :placeholder="$t('application_purpose')" :disabled="readOnlyMode || orderedMode" rows="2" v-model="configuration.description" @change="updateConfiguration();"></textarea>
                                </div>
                            </div>
                            <div class="box--group">
                                <h5>{{$t('settings')}}</h5>
                                <div class="box__group--input">
                                    <label>{{$t('variant')}}</label>
                                    <div class="dropdown__group--wrapper">
                                        <div>
                                            <div @click="toggleVariants()" class="dropdown__group--selected">
                                                <div class="name">{{$t('products.touch_flex.' + configuration.sku)}}</div>
                                                <div class="desc">{{$t('article_no')}}
                                                    {{configuration.sku}}
                                                </div>
                                                <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1.5 1L5.5 5L9.5 1" stroke="#808080" stroke-width="1.5"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="box__group--input">
                                    <label>Layout</label>
                                    <div class="dropdown__group--wrapper">
                                        <div>
                                            <div @click="toggleLayouts()" class="dropdown__group--selected dropdown__group--single">
                                                <div class="name">{{$t('templates.' + configuration.layout)}}</div>
                                                <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1.5 1L5.5 5L9.5 1" stroke="#808080" stroke-width="1.5"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="box__group--input">
                                    <label>{{$t('up_down_buttons')}}
                                        <div class="box__group--icon">
                                            <svg tabindex="812" width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="9.00065" cy="8.50065" r="7.66667" stroke="black"/>
                                                <path d="M7.33398 8.16602H9.00065V11.8327" stroke="black" stroke-linecap="round"/>
                                                <ellipse cx="8.66602" cy="5.5" rx="1" ry="1" fill="black"/>
                                                <path d="M7.33398 12.1673H10.6673" stroke="black" stroke-linecap="round"/>
                                            </svg>
                                            <div class="box__headline--info">
                                                <img src="../assets/images/up_down_buttons.png" />
                                                <h3>{{$t('up_down_buttons')}}</h3>
                                                <p>{{$t('up_down_buttons_info')}}</p>
                                                <p>{{$t('up_down_buttons_info_2')}}</p>
                                                <p class="red">{{$t('up_down_buttons_info_3')}}</p>
                                                <p class="red">{{$t('up_down_buttons_info_4')}}</p>
                                            </div>
                                        </div>
                                    </label>
                                    <div class="boolean__toggle--wrapper">
                                        <div v-if="((!readOnlyMode && !orderedMode) || !configuration.up_down_arrows)" @click="configuration.up_down_arrows = false;updateConfiguration()" class="bollean__toggle--off" :class="{active : !configuration.up_down_arrows}">
                                            {{$t('hide')}}
                                        </div>
                                        <div v-if="((!readOnlyMode && !orderedMode) || configuration.up_down_arrows)" @click="configuration.up_down_arrows = true;updateConfiguration()" class="bollean__toggle--on" :class="{active : configuration.up_down_arrows}">
                                            {{$t('show_all')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="box--group">
                                <h5>{{$t('default_values')}}</h5>
                                <div class="box__group--input">
                                    <label>{{$t('symbol_size')}}</label>
                                    <div class="site__toggle--wrapper">
                                        <div v-if="!readOnlyMode && !orderedMode" class="site__toggle--switcher">
                                            <div @click="configuration.icon_size = parseInt(configuration.icon_size)-1;updateConfiguration()">-</div>
                                            <div @click="configuration.icon_size = parseInt(configuration.icon_size)+1;updateConfiguration()">+</div>
                                        </div>
                                        <div>
                                            <select :disabled="readOnlyMode || orderedMode" :value="configuration.icon_size" v-model="configuration.icon_size" @change="validateConfiguration()">
                                                    <option v-for="i in [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]" :value="i" :key="i">{{i}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="box__group--input">
                                    <label>{{$t('text_size')}}</label>
                                    <div class="site__toggle--wrapper">
                                        <div v-if="!readOnlyMode && !orderedMode" class="site__toggle--switcher">
                                            <div @click="configuration.text_size = parseInt(configuration.text_size)-1;updateConfiguration()">-</div>
                                            <div @click="configuration.text_size = parseInt(configuration.text_size)+1;updateConfiguration()">+</div>
                                        </div>
                                        <div>
                                            <select :disabled="readOnlyMode || orderedMode" :value="configuration.text_size" v-model="configuration.text_size" @change="validateConfiguration()">
                                                    <option v-for="i in [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]" :value="i" :key="i">{{i}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="box__group--input">
                                    <label>{{$t('text_weight')}}</label>
                                    <div class="boolean__toggle--wrapper tripple">
                                        <div v-if="((!readOnlyMode && !orderedMode) || configuration.text_style == 'light')" @click="configuration.text_style = 'light';updateConfiguration()" class="bollean__toggle--off" :class="{active : configuration.text_style == 'light'}">
                                            {{$t('light')}}
                                        </div>
                                        <div v-if="((!readOnlyMode && !orderedMode) || configuration.text_style == 'regular')" @click="configuration.text_style = 'regular';updateConfiguration()" class="bollean__toggle--on" :class="{active : configuration.text_style == 'regular'}">
                                            {{$t('regular')}}
                                        </div>
                                        <div v-if="((!readOnlyMode && !orderedMode) || configuration.text_style == 'medium')" @click="configuration.text_style = 'medium';updateConfiguration()" class="bollean__toggle--on" :class="{active : configuration.text_style == 'medium'}">
                                            {{$t('medium')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!readOnlyMode && !orderedMode || (current_touch_area.id)" class="configurator__wrapper--right configurator__wrapper--right_bottom">
            <div class="box--layout" :class="{'closed' :(settings == 'global' && !readOnlyMode && !orderedMode)}">
                <div @click="closeOverlays();triggerSuggestionUpdate();" class="box--headline box--clickable" :class="{'disabled' : settings == 'global'}">Button Settings</div>
                <div class="box--content" v-if="settings == 'touch_area'">
                    <div class="box__content--scroller" id="touch__area--scroller">
                        <div class="box__content--scroll-inner">
                            <div class="box--group">
                                <template v-if="!readOnlyMode && !orderedMode || (readOnlyMode && current_touch_area.data.icon || orderedMode && current_touch_area.data.icon)">
                                    <div class="box__group--input">
                                        <label>
                                            {{$t('symbol')}}
                                            <div class="box__group--icon">
                                                <svg v-if="current_touch_area.data.icon && !readOnlyMode && !orderedMode" @click="current_touch_area.data.icon = null;updateTouchArea();this.symbolsVisible = false;" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M2.40039 3.69922V15.6992H13.6004V3.69922" stroke="black" stroke-linejoin="round"/>
                                                    <path d="M5.19922 2.90039C5.19922 1.79582 6.09465 0.900391 7.19922 0.900391H8.79922C9.90379 0.900391 10.7992 1.79582 10.7992 2.90039V3.30039H5.19922V2.90039Z" stroke="black"/>
                                                    <path d="M0.800781 3.30039H15.2008" stroke="black" stroke-linecap="round"/>
                                                    <path d="M5.99961 6.90039V12.5004" stroke="black" stroke-linecap="round"/>
                                                    <path d="M9.99961 6.90039V12.5004" stroke="black" stroke-linecap="round"/>
                                                </svg>
                                            </div>
                                        </label>
                                        <div class="dropdown__group--wrapper">
                                            <div>
                                                <div @click="toggleSymbols()" class="dropdown__group--selected">
                                                    <div class="icon" v-if="current_touch_area.data && current_touch_area.data.icon">
                                                        <img v-if="current_touch_area.data.icon" width="24" height="24" class="icon--image" :src="'https://configurator.loxone.com/files/translations/Icons/' + current_touch_area.data.icon" />
                                                        <span>{{current_touch_area.data.icon.replace('.svg', '')}}</span>
                                                    </div>
                                                    <div v-else>
                                                        <span>{{$t('no_icon')}}</span>
                                                    </div>
                                                    <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M1.5 1L5.5 5L9.5 1" stroke="#808080" stroke-width="1.5"/>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div v-if="current_touch_area.data && current_touch_area.data.icon && !readOnlyMode && !orderedMode">
                                                <div @click="current_touch_area.data.icon_custom = !current_touch_area.data.icon_custom;updateTouchArea();" class="input__checkbox--wrapper">
                                                    <input v-model="current_touch_area.data.icon_custom" type="checkbox">
                                                    <span>{{$t('custom_size')}}</span>
                                                </div>
                                                <div v-if="current_touch_area.data.icon_custom" class="site__toggle--wrapper">
                                                    <div class="site__toggle--switcher">
                                                        <div @click="current_touch_area.data.icon_size = parseInt(current_touch_area.data.icon_size)-1;updateTouchArea();">-</div>
                                                        <div @click="current_touch_area.data.icon_size = parseInt(current_touch_area.data.icon_size)+1;updateTouchArea();">+</div>
                                                    </div>
                                                    <div>
                                                        <select :value="current_touch_area.data.icon_size" v-model="current_touch_area.data.icon_size" @change="updateTouchArea()">
                                                            <option v-for="i in [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]" :value="i" :key="i">{{i}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="readOnlyMode || orderedMode">
                                                <div class="preview--wrapper" style="margin-top: 20px;">
                                                    <div class="preview--title">{{$t('symbol_size')}}</div>
                                                    <div class="site__toggle--wrapper">
                                                        <div>
                                                            <input spellcheck="false" type="text" readonly="true" class="preview--input" :value="(current_touch_area.data.icon_custom == true ? current_touch_area.data.icon_size : configuration.icon_size)" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-if="!readOnlyMode && !orderedMode || (readOnlyMode && current_touch_area.data.text || orderedMode && current_touch_area.data.text)">
                                    <div class="box__group--input">
                                        <label>
                                            {{$t('text')}}
                                            <div class="box__group--icon">
                                                <svg v-if="current_touch_area.data.text && !readOnlyMode && !orderedMode" @click="current_touch_area.data.text = null;updateTouchArea();" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M2.40039 3.69922V15.6992H13.6004V3.69922" stroke="black" stroke-linejoin="round"/>
                                                    <path d="M5.19922 2.90039C5.19922 1.79582 6.09465 0.900391 7.19922 0.900391H8.79922C9.90379 0.900391 10.7992 1.79582 10.7992 2.90039V3.30039H5.19922V2.90039Z" stroke="black"/>
                                                    <path d="M0.800781 3.30039H15.2008" stroke="black" stroke-linecap="round"/>
                                                    <path d="M5.99961 6.90039V12.5004" stroke="black" stroke-linecap="round"/>
                                                    <path d="M9.99961 6.90039V12.5004" stroke="black" stroke-linecap="round"/>
                                                </svg>
                                            </div>
                                        </label>
                                        <textarea :disabled="readOnlyMode || orderedMode" ref="textInput" id="textInput" rows="3" v-model="current_touch_area.data.text" @input="updateTouchArea()"></textarea>
                                    </div>
                                    <br/>
                                    <template v-if="current_touch_area.data.text">
                                    <template v-if="!readOnlyMode && !orderedMode">
                                        <template v-if="!current_touch_area.data.icon">
                                            <div class="boolean__toggle--wrapper tripple">
                                                <div @click="current_touch_area.data.text_align = 'left';updateTouchArea()" class="bollean__toggle--off" :class="{'active': current_touch_area.data.text_align == 'left'}">
                                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 1C0.5 0.723858 0.723858 0.5 1 0.5H15C15.2761 0.5 15.5 0.723858 15.5 1C15.5 1.27614 15.2761 1.5 15 1.5H1C0.723858 1.5 0.5 1.27614 0.5 1ZM0.5 5C0.5 4.72386 0.723858 4.5 1 4.5H7C7.27614 4.5 7.5 4.72386 7.5 5C7.5 5.27614 7.27614 5.5 7 5.5H1C0.723858 5.5 0.5 5.27614 0.5 5ZM1 8.5C0.723858 8.5 0.5 8.72386 0.5 9C0.5 9.27614 0.723858 9.5 1 9.5H11C11.2761 9.5 11.5 9.27614 11.5 9C11.5 8.72386 11.2761 8.5 11 8.5H1Z" fill="#000000"/>
                                                    </svg>
                                                </div>
                                                <div @click="current_touch_area.data.text_align = 'center';updateTouchArea()" class="bollean__toggle--on" :class="{'active': (current_touch_area.data.text_align != 'left' && current_touch_area.data.text_align != 'right')}">
                                                    <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.333252 0.5C0.333252 0.223858 0.55711 0 0.833252 0H14.8333C15.1094 0 15.3333 0.223858 15.3333 0.5C15.3333 0.776142 15.1094 1 14.8333 1H0.833252C0.55711 1 0.333252 0.776142 0.333252 0.5ZM4.33325 4.5C4.33325 4.22386 4.55711 4 4.83325 4H10.8333C11.1094 4 11.3333 4.22386 11.3333 4.5C11.3333 4.77614 11.1094 5 10.8333 5H4.83325C4.55711 5 4.33325 4.77614 4.33325 4.5ZM2.83325 8C2.55711 8 2.33325 8.22386 2.33325 8.5C2.33325 8.77614 2.55711 9 2.83325 9H12.8333C13.1094 9 13.3333 8.77614 13.3333 8.5C13.3333 8.22386 13.1094 8 12.8333 8H2.83325Z" fill="black"/>
                                                    </svg>
                                                </div>
                                                <div @click="current_touch_area.data.text_align = 'right';updateTouchArea()" class="bollean__toggle--on" :class="{'active': current_touch_area.data.text_align == 'right'}">
                                                    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.666748 3.5C0.666748 3.22386 0.890606 3 1.16675 3H15.1667C15.4429 3 15.6667 3.22386 15.6667 3.5C15.6667 3.77614 15.4429 4 15.1667 4H1.16675C0.890606 4 0.666748 3.77614 0.666748 3.5ZM8.66675 7.5C8.66675 7.22386 8.89061 7 9.16675 7H15.1667C15.4429 7 15.6667 7.22386 15.6667 7.5C15.6667 7.77614 15.4429 8 15.1667 8H9.16675C8.89061 8 8.66675 7.77614 8.66675 7.5ZM5.16675 11C4.89061 11 4.66675 11.2239 4.66675 11.5C4.66675 11.7761 4.89061 12 5.16675 12H15.1667C15.4429 12 15.6667 11.7761 15.6667 11.5C15.6667 11.2239 15.4429 11 15.1667 11H5.16675Z" fill="black"/>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div class="boolean__toggle--wrapper tripple">
                                                <div @click="current_touch_area.data.text_valign = 'flex-start';updateTouchArea()" class="bollean__toggle--off" :class="{'active': current_touch_area.data.text_valign == 'flex-start'}">
                                                    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 1C0.5 0.723858 0.723858 0.5 1 0.5H15C15.2761 0.5 15.5 0.723858 15.5 1C15.5 1.27614 15.2761 1.5 15 1.5H1C0.723858 1.5 0.5 1.27614 0.5 1ZM7.5 4.58711V14.5C7.5 14.7761 7.72386 15 8 15C8.27614 15 8.5 14.7761 8.5 14.5V4.58711L11.1746 6.87963C11.3843 7.05934 11.6999 7.03506 11.8796 6.8254C12.0593 6.61573 12.0351 6.30008 11.8254 6.12037L8.32754 3.12221C8.2398 3.04608 8.12528 3 8 3C7.87472 3 7.7602 3.04608 7.67246 3.12221L4.1746 6.12037C3.96494 6.30008 3.94066 6.61573 4.12037 6.8254C4.30008 7.03506 4.61573 7.05934 4.8254 6.87963L7.5 4.58711Z" fill="#000000"/>
                                                    </svg>
                                                </div>
                                                <div @click="current_touch_area.data.text_valign = 'center';updateTouchArea()" class="bollean__toggle--on" :class="{'active': (current_touch_area.data.text_valign != 'flex-start' && current_touch_area.data.text_valign != 'flex-end')}">
                                                    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.83325 0.5C8.10939 0.5 8.33325 0.723858 8.33325 1V3.91289L11.0079 1.62037C11.2175 1.44066 11.5332 1.46494 11.7129 1.6746C11.8926 1.88427 11.8683 2.19992 11.6586 2.37963L8.1608 5.37778C8.07306 5.45392 7.95854 5.5 7.83325 5.5C7.70797 5.5 7.59344 5.45392 7.50571 5.37778L4.00786 2.37963C3.79819 2.19992 3.77391 1.88427 3.95362 1.6746C4.13333 1.46494 4.44898 1.44066 4.65865 1.62037L7.33325 3.91289V1C7.33325 0.723858 7.55711 0.5 7.83325 0.5ZM0.333252 7.5C0.333252 7.22386 0.55711 7 0.833252 7H14.8333C15.1094 7 15.3333 7.22386 15.3333 7.5C15.3333 7.77614 15.1094 8 14.8333 8H0.833252C0.55711 8 0.333252 7.77614 0.333252 7.5ZM7.33325 11.0871V14C7.33325 14.2761 7.55711 14.5 7.83325 14.5C8.10939 14.5 8.33325 14.2761 8.33325 14V11.0871L11.0079 13.3796C11.2175 13.5593 11.5332 13.5351 11.7129 13.3254C11.8926 13.1157 11.8683 12.8001 11.6586 12.6204L8.16078 9.6222C8.07305 9.54607 7.95853 9.5 7.83325 9.5C7.70797 9.5 7.59346 9.54607 7.50572 9.6222L4.00786 12.6204C3.79819 12.8001 3.77391 13.1157 3.95362 13.3254C4.13333 13.5351 4.44898 13.5593 4.65865 13.3796L7.33325 11.0871Z" fill="black"/>
                                                    </svg>
                                                </div>
                                                <div @click="current_touch_area.data.text_valign = 'flex-end';updateTouchArea()" class="bollean__toggle--on" :class="{'active': current_touch_area.data.text_valign == 'flex-end'}">
                                                    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.16675 0.5C8.44289 0.5 8.66675 0.723858 8.66675 1V10.9129L11.3414 8.62037C11.551 8.44066 11.8667 8.46494 12.0464 8.6746C12.2261 8.88427 12.2018 9.19992 11.9921 9.37963L8.49428 12.3778C8.40654 12.4539 8.29203 12.5 8.16675 12.5C8.04147 12.5 7.92695 12.4539 7.83922 12.3778L4.34135 9.37963C4.13169 9.19992 4.10741 8.88427 4.28712 8.6746C4.46683 8.46494 4.78248 8.44066 4.99214 8.62037L7.66675 10.9129V1C7.66675 0.723858 7.89061 0.5 8.16675 0.5ZM0.666748 14.5C0.666748 14.2239 0.890606 14 1.16675 14H15.1667C15.4429 14 15.6667 14.2239 15.6667 14.5C15.6667 14.7761 15.4429 15 15.1667 15H1.16675C0.890606 15 0.666748 14.7761 0.666748 14.5Z" fill="black"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        </template>
                                        <div v-if="current_touch_area.data.text">
                                            <div @click="current_touch_area.data.text_custom = !current_touch_area.data.text_custom;updateTouchArea();updateConfiguration();" class="input__checkbox--wrapper">
                                                <input v-model="current_touch_area.data.text_custom" type="checkbox">
                                                <span>{{$t('custom_weight_size')}}</span>
                                            </div>
                                            <div v-if="current_touch_area.data.text_custom" class="site__toggle--wrapper">
                                                <div class="site__toggle--switcher">
                                                    <div @click="current_touch_area.data.text_size = parseInt(current_touch_area.data.text_size)-1;updateTouchArea();">-</div>
                                                    <div @click="current_touch_area.data.text_size = parseInt(current_touch_area.data.text_size)+1;updateTouchArea();">+</div>
                                                </div>
                                                <div>
                                                    <select :value="current_touch_area.data.text_size" v-model="current_touch_area.data.text_size" @change="updateTouchArea();">
                                                        <option v-for="i in [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]" :value="i" :key="i">{{i}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div v-if="current_touch_area.data.text_custom" class="box__group--input">
                                                <div class="boolean__toggle--wrapper tripple">
                                                    <div @click="current_touch_area.data.text_weight = 'light';updateTouchArea()" class="bollean__toggle--off" :class="{active : current_touch_area.data.text_weight == 'light'}">
                                                        {{$t('light')}}
                                                    </div>
                                                    <div @click="current_touch_area.data.text_weight = 'regular';updateTouchArea()" class="bollean__toggle--on" :class="{active : (current_touch_area.data.text_weight != 'light' && current_touch_area.data.text_weight != 'medium')}">
                                                        {{$t('regular')}}
                                                    </div>
                                                    <div @click="current_touch_area.data.text_weight = 'medium';updateTouchArea()" class="bollean__toggle--on" :class="{active : current_touch_area.data.text_weight == 'medium'}">
                                                        {{$t('medium')}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <div v-else>
                                        <div class="preview--wrapper">
                                            <div class="preview--title">{{$t('font_size')}}</div>
                                            <div class="site__toggle--wrapper">
                                                <div>
                                                    <input spellcheck="false" type="text" readonly="true" class="preview--input" :value="(current_touch_area.data.text_custom == true ? current_touch_area.data.text_size : configuration.text_size)" />
                                                </div>
                                            </div>
                                            <div class="preview--title">{{$t('text_weight')}}</div>
                                            <div class="site__toggle--wrapper">
                                                <div>
                                                    <input spellcheck="false" type="text" readonly="true" class="preview--input" style="text-transform: capitalize;" :value="(current_touch_area.data.text_custom == true ? current_touch_area.data.text_weight ? current_touch_area.data.text_weight : 'Regular' : configuration.text_style ? configuration.text_style : 'Regular')" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </template>
                                </template>
                            </div>
                            <div class="box--group" :class="{'box--enabled': !readOnlyMode}">
                                <div class="box__group--input" v-if="!readOnlyMode">
                                    <label style="font-family:'averta-bold', Arial;font-size:17px;">Function:
                                        <div class="box__group--icon">
                                            <svg tabindex="233" width="17" height="17" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 8C0 12.381 3.61905 16 8 16C12.381 16 16 12.381 16 8C16 3.61905 12.3748 0 7.99386 0C3.6129 0 0 3.61905 0 8ZM15 8C15.0063 11.8763 11.8749 15 7.99685 15C4.1125 15 1 11.8763 1 8C1 4.12366 4.10623 1 7.99058 1C11.8687 1 14.9937 4.12366 15 8ZM7.94931 5.31336C7.47619 5.31336 7.09319 4.936 7.09319 4.46288C7.09319 3.98413 7.47619 3.60676 7.94931 3.60676C8.42806 3.60676 8.7998 3.98413 8.7998 4.46288C8.7998 4.936 8.42806 5.31336 7.94931 5.31336ZM6.24834 11.5315C6.24834 11.7849 6.4511 11.9764 6.71019 11.9764H9.67844C9.93753 11.9764 10.1347 11.7849 10.1347 11.5315C10.1347 11.2837 9.93753 11.0922 9.67844 11.0922H8.68715V7.14951C8.68715 6.82284 8.51818 6.59754 8.20277 6.59754H6.81157C6.55812 6.59754 6.35535 6.79467 6.35535 7.03687C6.35535 7.29032 6.55812 7.48182 6.81157 7.48182H7.70149V11.0922H6.71019C6.4511 11.0922 6.24834 11.2837 6.24834 11.5315Z" fill="black"/>
                                            </svg>
                                            <div class="box__headline--info">
                                                <img src="../assets/images/button_function.png" />
                                                <h3>{{$t('button_function')}}</h3>
                                                <p v-if="configuration.sku == '100509' || configuration.sku == '100510'">{{$t('button_function_info1')}} <a href="https://www.loxone.com/help/touch-pure-flex-air" target="_blank">www.loxone.com</a>.</p>
                                                <p v-else>{{$t('button_function_info1')}} <a href="https://www.loxone.com/help/touch-pure-flex-tree" target="_blank">www.loxone.com</a>.</p>
                                                <p class="red">{{$t('button_function_info2')}}</p>
                                            </div>
                                        </div>
                                    </label>
                                    <div class="dropdown__group--wrapper">
                                        <div>
                                            <div @click="toggleSuggestions()" class="dropdown__group--selected">
                                                <div class="icon">
                                                    <img class="icon--image" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjY2OTYgMi44NDY5QzE1Ljg2OTQgMi42MzI0OCAxNS4wNDY5IDMuMTA3MzYgMTQuODMyNSAzLjkwNzU2TDEzLjcxNzkgOC4wNjczMkwxNS45MTM0IDguMDY3MjJDMTYuMTg5NSA4LjA2NzIxIDE2LjQxMzQgOC4yOTEwNSAxNi40MTM0IDguNTY3MkMxNi40MTM0IDguODQzMzQgMTYuMTg5NiA5LjA2NzIxIDE1LjkxMzQgOS4wNjcyMkwxMy40NDk5IDkuMDY3MzNMMTAuNDMyNiAyMC4zMjgzQzEwLjA3NTIgMjEuNjYyIDguNzA0MzggMjIuNDUzNCA3LjM3MDcxIDIyLjA5NjFDNy4xMDM5OCAyMi4wMjQ2IDYuOTQ1NjkgMjEuNzUwNCA3LjAxNzE2IDIxLjQ4MzdDNy4wODg2MyAyMS4yMTcgNy4zNjI4IDIxLjA1ODcgNy42Mjk1MyAyMS4xMzAxQzguNDI5NzMgMjEuMzQ0NiA5LjI1MjI0IDIwLjg2OTcgOS40NjY2NSAyMC4wNjk1TDEyLjQxNDcgOS4wNjczN0wxMC40MTMzIDkuMDY3NDZDMTAuMTM3MiA5LjA2NzQ4IDkuOTEzMzIgOC44NDM2MyA5LjkxMzMgOC41Njc0OEM5LjkxMzI5IDguMjkxMzQgMTAuMTM3MSA4LjA2NzQ4IDEwLjQxMzMgOC4wNjc0NkwxMi42ODI2IDguMDY3MzZMMTMuODY2NiAzLjY0ODc0QzE0LjIyMzkgMi4zMTUwNyAxNS41OTQ4IDEuNTIzNjIgMTYuOTI4NCAxLjg4MDk3QzE3LjE5NTIgMS45NTI0NCAxNy4zNTM1IDIuMjI2NjEgMTcuMjgyIDIuNDkzMzRDMTcuMjEwNSAyLjc2MDA4IDE2LjkzNjQgMi45MTgzNyAxNi42Njk2IDIuODQ2OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=" />
                                                    <span>{{$t('predefined_buttons')}}</span>
                                                </div>
                                                <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1.5 1L5.5 5L9.5 1" stroke="#808080" stroke-width="1.5"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="box__group--input" v-if="!readOnlyMode">
                                    <label>{{$t('name')}}</label>
                                    <textarea spellcheck="false" :readonly="readOnlyMode" rows="1" v-model="current_touch_area.data.name" @change="updateTouchArea();"></textarea>
                                    <br/>
                                    <br/>
                                </div>
                                <div class="box__group--input">
                                    <label>
                                        {{$t('button_api')}}
                                        <div v-if="!readOnlyMode" @click="apiCommandGeneratorType = 'button_cmd';openApiCommandGenerator(current_touch_area.data.button_cmd)" class="box__group--icon">
                                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.93206 5.78516C7.433 5.78516 6.21777 7.00038 6.21777 8.49944C6.21777 9.9985 7.433 11.2137 8.93206 11.2137C10.4311 11.2137 11.6463 9.9985 11.6463 8.49944C11.6463 7.00038 10.4311 5.78516 8.93206 5.78516V5.78516Z" stroke="black"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7796 7.31805L16.4636 6.34525L14.5636 3.05445L12.8807 4.02616C12.2825 3.49851 11.5866 3.09353 10.8309 2.83948V0.900391H7.0309V2.84816C6.25462 3.10765 5.56628 3.51371 4.98433 4.02725L3.30039 3.05445L1.40039 6.34525L3.08216 7.31696C2.9269 8.07913 2.92148 8.8793 3.08433 9.68165L1.40039 10.6544L3.30039 13.9452L4.98325 12.9735C5.58148 13.5001 6.27633 13.904 7.0309 14.1591V16.1004H10.8309V14.1537C11.6072 13.8931 12.2977 13.4882 12.8786 12.9746L14.5625 13.9474L16.4625 10.6566L14.7807 9.68491C14.9371 8.92165 14.9425 8.12039 14.7796 7.31805V7.31805Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                    </label>
                                    <textarea spellcheck="false" class="auto_grow" @input="auto_grow" :readonly="readOnlyMode" v-model="current_touch_area.data.button_cmd" @change="updateTouchArea();"></textarea>
                                </div>
                                <div class="box__group--input" :class="{'disabled': functionValidator()}">
                                    <label>
                                        {{$t('button_text')}}
                                        <div v-if="!functionValidator() && !readOnlyMode" @click="apiCommandGeneratorType = 'button_text';openApiCommandGenerator(current_touch_area.data.button_text)" class="box__group--icon">
                                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.93206 5.78516C7.433 5.78516 6.21777 7.00038 6.21777 8.49944C6.21777 9.9985 7.433 11.2137 8.93206 11.2137C10.4311 11.2137 11.6463 9.9985 11.6463 8.49944C11.6463 7.00038 10.4311 5.78516 8.93206 5.78516V5.78516Z" stroke="black"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7796 7.31805L16.4636 6.34525L14.5636 3.05445L12.8807 4.02616C12.2825 3.49851 11.5866 3.09353 10.8309 2.83948V0.900391H7.0309V2.84816C6.25462 3.10765 5.56628 3.51371 4.98433 4.02725L3.30039 3.05445L1.40039 6.34525L3.08216 7.31696C2.9269 8.07913 2.92148 8.8793 3.08433 9.68165L1.40039 10.6544L3.30039 13.9452L4.98325 12.9735C5.58148 13.5001 6.27633 13.904 7.0309 14.1591V16.1004H10.8309V14.1537C11.6072 13.8931 12.2977 13.4882 12.8786 12.9746L14.5625 13.9474L16.4625 10.6566L14.7807 9.68491C14.9371 8.92165 14.9425 8.12039 14.7796 7.31805V7.31805Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                    </label>
                                    <textarea spellcheck="false" v-if="!functionValidator()" class="auto_grow" @input="auto_grow" :readonly="functionValidator() || readOnlyMode" :placeholder="functionPlaceholderValidator()" v-model="current_touch_area.data.button_text" @change="updateTouchArea();"></textarea>
                                    <textarea spellcheck="false" v-else class="auto_grow" :readonly="functionValidator() || readOnlyMode" :placeholder="functionPlaceholderValidator()" value=""></textarea>
                                </div>
                            </div>
                            <div class="box--group" :class="{'box--enabled': !readOnlyMode}">
                                <div class="box__group--input" :class="{'disabled': functionValidator()}">
                                    <label>
                                        {{$t('button_down_api')}}
                                        <div v-if="!functionValidator() && !readOnlyMode" @click="apiCommandGeneratorType = 'arrow_down_cmd';openApiCommandGenerator(current_touch_area.data.arrow_down_cmd)" class="box__group--icon">
                                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.93206 5.78516C7.433 5.78516 6.21777 7.00038 6.21777 8.49944C6.21777 9.9985 7.433 11.2137 8.93206 11.2137C10.4311 11.2137 11.6463 9.9985 11.6463 8.49944C11.6463 7.00038 10.4311 5.78516 8.93206 5.78516V5.78516Z" stroke="black"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7796 7.31805L16.4636 6.34525L14.5636 3.05445L12.8807 4.02616C12.2825 3.49851 11.5866 3.09353 10.8309 2.83948V0.900391H7.0309V2.84816C6.25462 3.10765 5.56628 3.51371 4.98433 4.02725L3.30039 3.05445L1.40039 6.34525L3.08216 7.31696C2.9269 8.07913 2.92148 8.8793 3.08433 9.68165L1.40039 10.6544L3.30039 13.9452L4.98325 12.9735C5.58148 13.5001 6.27633 13.904 7.0309 14.1591V16.1004H10.8309V14.1537C11.6072 13.8931 12.2977 13.4882 12.8786 12.9746L14.5625 13.9474L16.4625 10.6566L14.7807 9.68491C14.9371 8.92165 14.9425 8.12039 14.7796 7.31805V7.31805Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                    </label>
                                    <textarea spellcheck="false" v-if="!functionValidator()" class="auto_grow" @input="auto_grow" :readonly="functionValidator() || readOnlyMode" :placeholder="functionPlaceholderValidator()" v-model="current_touch_area.data.arrow_down_cmd" @change="updateTouchArea();"></textarea>
                                    <textarea spellcheck="false" v-else class="auto_grow" :readonly="functionValidator() || readOnlyMode" :placeholder="functionPlaceholderValidator()" value=""></textarea>
                                </div>
                                <div class="box__group--input" :class="{'disabled': functionValidator()}">
                                    <label>
                                        {{$t('button_down_text')}}
                                        <div v-if="!functionValidator() && !readOnlyMode" :placeholder="functionPlaceholderValidator()" @click="apiCommandGeneratorType = 'arrow_down_text';openApiCommandGenerator(current_touch_area.data.arrow_down_text)" class="box__group--icon">
                                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.93206 5.78516C7.433 5.78516 6.21777 7.00038 6.21777 8.49944C6.21777 9.9985 7.433 11.2137 8.93206 11.2137C10.4311 11.2137 11.6463 9.9985 11.6463 8.49944C11.6463 7.00038 10.4311 5.78516 8.93206 5.78516V5.78516Z" stroke="black"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7796 7.31805L16.4636 6.34525L14.5636 3.05445L12.8807 4.02616C12.2825 3.49851 11.5866 3.09353 10.8309 2.83948V0.900391H7.0309V2.84816C6.25462 3.10765 5.56628 3.51371 4.98433 4.02725L3.30039 3.05445L1.40039 6.34525L3.08216 7.31696C2.9269 8.07913 2.92148 8.8793 3.08433 9.68165L1.40039 10.6544L3.30039 13.9452L4.98325 12.9735C5.58148 13.5001 6.27633 13.904 7.0309 14.1591V16.1004H10.8309V14.1537C11.6072 13.8931 12.2977 13.4882 12.8786 12.9746L14.5625 13.9474L16.4625 10.6566L14.7807 9.68491C14.9371 8.92165 14.9425 8.12039 14.7796 7.31805V7.31805Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                    </label>
                                    <textarea spellcheck="false" v-if="!functionValidator()" class="auto_grow" @input="auto_grow" :readonly="functionValidator() || readOnlyMode" :placeholder="functionPlaceholderValidator()" v-model="current_touch_area.data.arrow_down_text" @change="updateTouchArea();"></textarea>
                                    <textarea spellcheck="false" v-else class="auto_grow" :readonly="functionValidator() || readOnlyMode" :placeholder="functionPlaceholderValidator()" value=""></textarea>
                                </div>
                            </div>
                            <div class="box--group" :class="{'box--enabled': !readOnlyMode}">
                                <div class="box__group--input" :class="{'disabled': functionValidator()}">
                                    <label>
                                        {{$t('button_up_api')}}
                                        <div v-if="!functionValidator() && !readOnlyMode" @click="apiCommandGeneratorType = 'arrow_up_cmd';openApiCommandGenerator(current_touch_area.data.arrow_up_cmd)" class="box__group--icon">
                                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.93206 5.78516C7.433 5.78516 6.21777 7.00038 6.21777 8.49944C6.21777 9.9985 7.433 11.2137 8.93206 11.2137C10.4311 11.2137 11.6463 9.9985 11.6463 8.49944C11.6463 7.00038 10.4311 5.78516 8.93206 5.78516V5.78516Z" stroke="black"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7796 7.31805L16.4636 6.34525L14.5636 3.05445L12.8807 4.02616C12.2825 3.49851 11.5866 3.09353 10.8309 2.83948V0.900391H7.0309V2.84816C6.25462 3.10765 5.56628 3.51371 4.98433 4.02725L3.30039 3.05445L1.40039 6.34525L3.08216 7.31696C2.9269 8.07913 2.92148 8.8793 3.08433 9.68165L1.40039 10.6544L3.30039 13.9452L4.98325 12.9735C5.58148 13.5001 6.27633 13.904 7.0309 14.1591V16.1004H10.8309V14.1537C11.6072 13.8931 12.2977 13.4882 12.8786 12.9746L14.5625 13.9474L16.4625 10.6566L14.7807 9.68491C14.9371 8.92165 14.9425 8.12039 14.7796 7.31805V7.31805Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                    </label>
                                    <textarea spellcheck="false" v-if="!functionValidator()" class="auto_grow" @input="auto_grow" :readonly="functionValidator() || readOnlyMode" :placeholder="functionPlaceholderValidator()" v-model="current_touch_area.data.arrow_up_cmd" @change="updateTouchArea();"></textarea>
                                    <textarea spellcheck="false" v-else class="auto_grow" :readonly="functionValidator() || readOnlyMode" :placeholder="functionPlaceholderValidator()" value=""></textarea>
                                </div>
                                <div class="box__group--input" :class="{'disabled': functionValidator()}">
                                    <label>
                                        {{$t('button_up_text')}}
                                        <div v-if="!functionValidator() && !readOnlyMode" @click="apiCommandGeneratorType = 'arrow_up_text';openApiCommandGenerator(current_touch_area.data.arrow_up_text)" class="box__group--icon">
                                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.93206 5.78516C7.433 5.78516 6.21777 7.00038 6.21777 8.49944C6.21777 9.9985 7.433 11.2137 8.93206 11.2137C10.4311 11.2137 11.6463 9.9985 11.6463 8.49944C11.6463 7.00038 10.4311 5.78516 8.93206 5.78516V5.78516Z" stroke="black"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7796 7.31805L16.4636 6.34525L14.5636 3.05445L12.8807 4.02616C12.2825 3.49851 11.5866 3.09353 10.8309 2.83948V0.900391H7.0309V2.84816C6.25462 3.10765 5.56628 3.51371 4.98433 4.02725L3.30039 3.05445L1.40039 6.34525L3.08216 7.31696C2.9269 8.07913 2.92148 8.8793 3.08433 9.68165L1.40039 10.6544L3.30039 13.9452L4.98325 12.9735C5.58148 13.5001 6.27633 13.904 7.0309 14.1591V16.1004H10.8309V14.1537C11.6072 13.8931 12.2977 13.4882 12.8786 12.9746L14.5625 13.9474L16.4625 10.6566L14.7807 9.68491C14.9371 8.92165 14.9425 8.12039 14.7796 7.31805V7.31805Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                    </label>
                                    <textarea spellcheck="false" v-if="!functionValidator()" class="auto_grow" @input="auto_grow" :readonly="functionValidator() || readOnlyMode" :placeholder="functionPlaceholderValidator()" v-model="current_touch_area.data.arrow_up_text" @change="updateTouchArea();"></textarea>
                                    <textarea spellcheck="false" v-else class="auto_grow" :readonly="functionValidator() || readOnlyMode" :placeholder="functionPlaceholderValidator()" value=""></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>&nbsp;</div>
        <div class="icon__float--wrapper">
            <div v-if="floatingElementVisible" id="floater">
                <svg v-if="floatingElementData.text" width="48" height="48" style="opacity: 0.5;" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 0.5C2 0.223858 2.22386 0 2.5 0H20.5C20.7761 0 21 0.223858 21 0.5V3.5C21 3.77614 20.7761 4 20.5 4C20.2239 4 20 3.77614 20 3.5V1H12V23H15C15.2761 23 15.5 23.2239 15.5 23.5C15.5 23.7761 15.2761 24 15 24H8C7.72386 24 7.5 23.7761 7.5 23.5C7.5 23.2239 7.72386 23 8 23H11V1H3V3.5C3 3.77614 2.77614 4 2.5 4C2.22386 4 2 3.77614 2 3.5V0.5Z" fill="black"/>
                </svg>
                <template v-else>
                    <img v-if="floatingElementData.icon" :src="'https://configurator.loxone.com/files/translations/Icons/' + floatingElementData.icon" />
                </template>
            </div>
            <div v-if="floatingGroupVisible" id="floater__group">
                <div class="floater__group--wrapper">
                    <div class="floater__group--inner" v-for="icon in floatingGroupData" :key="icon" :style="'background-image: url(https://configurator.loxone.com/files/translations/Icons/' + icon + ')'">&nbsp;</div>
                </div>
            </div>
        </div>
        <div class="overlay__wrapper overlay__wrapper--generator" @click="closeApiCommandGenerator" v-if="apiCommandGeneratorVisible">
            <div class="overlay__content">
                <div class="overlay__content--left">
                    <div>
                        <h3>{{$t('api_command_generator')}}</h3>
                        <table class="command__generator--table">
                            <tbody>
                                <tr v-if="commandGeneratorCommand != 'WAIT'">
                                    <td>{{$t('function_block')}}</td>
                                    <td>
                                        <select :value="commandGeneratorAbbrevation" v-model="commandGeneratorAbbrevation">
                                            <option value="" selected disabled>{{$t('plase_choose')}}</option>
                                            <template v-for="functionBlock in functionBlocks" :key="functionBlock.Abbrevation">
                                                <option v-if="functionBlock.abbrevation" :value="functionBlock.abbrevation">{{functionBlock.name}} ({{functionBlock.abbrevation}})</option>
                                            </template>
                                        </select>
                                    </td>
                                </tr>
                                <tr v-if="commandGeneratorCommand != 'ECHO' && commandGeneratorCommand != 'WAIT'">
                                    <td>{{$t('input')}}</td>
                                    <td>
                                        <select :value="commandGeneratorAction" v-model="commandGeneratorAction">
                                            <option selected disabled>Please choose</option>
                                            <option v-for="action in getAvailableActions(commandGeneratorAbbrevation, commandGeneratorCommand)" :key="action" :value="action.ShortName">{{action.ShortName}} ({{action.ShortDescription}})</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr v-else>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>{{$t('command')}}</td>
                                    <td>
                                        <select :value="commandGeneratorCommand" v-model="commandGeneratorCommand">
                                            <option selected disabled>{{$t('plase_choose')}}</option>
                                            <template v-if="apiCommandGeneratorType == 'button_cmd' || apiCommandGeneratorType == 'arrow_down_cmd' || apiCommandGeneratorType == 'arrow_up_cmd'">
                                                <option value="MENU">MENU</option>
                                                <option value="SET">SET</option>
                                                <option value="SETT5">SETT5</option>
                                                <option value="TIMESELECT">TIMESELECT</option>
                                                <option value="VALUESELECT">VALUESELECT</option>
                                                <option value="WAIT">WAIT</option>
                                            </template>
                                            <template v-else>
                                                <option value="ECHO">ECHO</option>
                                                <option value="GETINPUT">GETINPUT</option>
                                                <option value="GETOUTPUT">GETOUTPUT</option>
                                                <option value="WAIT">WAIT</option>
                                            </template>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody class="spacer">
                                <tr>
                                    <td colspan="2">&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colspan="2">&nbsp;</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="command__generator--scroller">
                        <div class="command__generator--scroll-inner">
                            <table class="command__generator--table">
                                <tbody v-if="commandGeneratorCommand == 'MENU'">
                                    <tr>
                                        <td>{{$t('start_value')}}</td>
                                        <td>
                                            <input spellcheck="false" type="text" v-model="commandGeneratorData.value">
                                        </td>
                                    </tr>
                                    <tr class="command__menu--row" v-for="i in Object.keys(commandGeneratorData.menues).length" :key="i">
                                        <td>Value{{i}}:Text{{i}}</td>
                                        <td class="">
                                            <svg @click="deleteMenueItem(i)" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="#C0C0C0" stroke="#C0C0C0"/>
                                                <rect x="4" y="7.5" width="8" height="1" fill="#F3F3F3"/>
                                            </svg>
                                            <input spellcheck="false" type="text" v-model="commandGeneratorData.menues[i-1]">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            &nbsp;
                                        </td>
                                        <td>
                                            <svg @click="commandGeneratorData.menues.push([]);" style="cursor:pointer;" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="21" height="21" fill="#E73246"/>
                                                <rect x="10" y="4" width="1" height="13" fill="white"/>
                                                <rect x="4" y="10" width="13" height="1" fill="white"/>
                                            </svg>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="commandGeneratorCommand == 'SET'">
                                    <tr>
                                        <td>{{$t('value')}}</td>
                                        <td>
                                            <input spellcheck="false" type="text" v-model="commandGeneratorData.value">
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="commandGeneratorCommand == 'SETT5'">
                                    <tr>
                                        <td>{{$t('t5button')}}</td>
                                        <td>
                                            <input spellcheck="false" type="text" v-model="commandGeneratorData.t5">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('value')}}</td>
                                        <td>
                                            <input spellcheck="false" type="text" v-model="commandGeneratorData.value">
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="commandGeneratorCommand == 'TIMESELECT'">
                                    <tr>
                                        <td>{{$t('starttime')}}</td>
                                        <td>
                                            <input spellcheck="false" type="text" v-model="commandGeneratorData.startTime">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('stepsize')}}</td>
                                        <td>
                                            <input spellcheck="false" type="text" v-model="commandGeneratorData.stepSize">
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="commandGeneratorCommand == 'VALUESELECT'">
                                    <tr>
                                        <td>{{$t('value')}}</td>
                                        <td>
                                            <input spellcheck="false" type="text" v-model="commandGeneratorData.value">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('min_value')}}</td>
                                        <td>
                                            <input spellcheck="false" type="text" v-model="commandGeneratorData.minValue">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('max_value')}}</td>
                                        <td>
                                            <input spellcheck="false" type="text" v-model="commandGeneratorData.maxValue">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('stepsize')}}</td>
                                        <td>
                                            <input spellcheck="false" type="text" v-model="commandGeneratorData.stepSize">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('unit')}}</td>
                                        <td>
                                            <input spellcheck="false" type="text" v-model="commandGeneratorData.unit">
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="commandGeneratorCommand == 'WAIT'">
                                    <tr>
                                        <td>{{$t('milliseconds')}}</td>
                                        <td>
                                            <input spellcheck="false" placeholder="500" type="text" v-model="commandGeneratorData.milliseconds">
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="commandGeneratorCommand == 'GET'">
                                    <tr>
                                        <td>Value</td>
                                        <td>4B</td>
                                    </tr>
                                </tbody>
                                <tbody v-if="commandGeneratorCommand == 'GETINPUT' || commandGeneratorCommand == 'GETOUTPUT'">
                                    <tr class="command__menu--row" v-for="i in Object.keys(commandGeneratorData.menues).length" :key="i">
                                        <td>Value{{i}}:Text{{i}}</td>
                                        <td class="">
                                            <svg @click="deleteMenueItem(i)" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="#C0C0C0" stroke="#C0C0C0"/>
                                                <rect x="4" y="7.5" width="8" height="1" fill="#F3F3F3"/>
                                            </svg>
                                            <input spellcheck="false" type="text" v-model="commandGeneratorData.menues[i-1]">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            &nbsp;
                                        </td>
                                        <td>
                                            <svg @click="commandGeneratorData.menues.push([]);" style="cursor:pointer;" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="21" height="21" fill="#E73246"/>
                                                <rect x="10" y="4" width="1" height="13" fill="white"/>
                                                <rect x="4" y="10" width="13" height="1" fill="white"/>
                                            </svg>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="command__generator--footer">
                        <div>
                            <div class="api__command--preview">
                                {{getCurrentApiCommand()}}
                            </div>
                            <div>
                                <a class="btn" @click="current_touch_area.data[apiCommandGeneratorType] = getCurrentApiCommand();apiCommandGeneratorVisible = false;resetApiCommandGenerator();updateTouchArea();">Save</a>
                                <a class="btn btn--ghost" @click="apiCommandGeneratorVisible = false;resetApiCommandGenerator();">Cancel</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="overlay__content--right">
                    <div v-if="commandGeneratorCommand == 'MENU'" v-html="$t('config.commands.MENU')"></div>
                    <div v-else-if="commandGeneratorCommand == 'SET'" v-html="$t('config.commands.SET')"></div>
                    <div v-else-if="commandGeneratorCommand == 'SETT5'" v-html="$t('config.commands.SETT5')"></div>
                    <div v-else-if="commandGeneratorCommand == 'TIMESELECT'" v-html="$t('config.commands.TIMESELECT')"></div>
                    <div v-else-if="commandGeneratorCommand == 'VALUESELECT'" v-html="$t('config.commands.VALUESELECT')"></div>
                    <div v-else-if="commandGeneratorCommand == 'WAIT'" v-html="$t('config.commands.WAIT')"></div>
                    <div v-else-if="commandGeneratorCommand == 'ECHO'" v-html="$t('config.commands.ECHO')"></div>
                    <div v-else-if="commandGeneratorCommand == 'GETINPUT'" v-html="$t('config.commands.GETINPUT')"></div>
                    <div v-else-if="commandGeneratorCommand == 'GETOUTPUT'" v-html="$t('config.commands.GETOUTPUT')"></div>
                </div>
                <div @click="this.apiCommandGeneratorVisible = false;" class="overlay--close">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="12" fill="#DEDEDE"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L10.5858 12L7.29289 15.2929C6.90237 15.6834 6.90237 16.3166 7.29289 16.7071C7.68342 17.0976 8.31658 17.0976 8.70711 16.7071L12 13.4142L15.2929 16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071C17.0976 16.3166 17.0976 15.6834 16.7071 15.2929L13.4142 12L16.7071 8.70711C17.0976 8.31658 17.0976 7.68342 16.7071 7.29289C16.3166 6.90237 15.6834 6.90237 15.2929 7.29289L12 10.5858L8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289Z" fill="black"/>
                        <path d="M7.29289 8.70711L7.46967 8.53033L7.29289 8.70711ZM7.29289 7.29289L7.46967 7.46967L7.29289 7.29289ZM10.5858 12L10.7626 12.1768L10.9393 12L10.7626 11.8232L10.5858 12ZM7.29289 15.2929L7.46967 15.4697H7.46967L7.29289 15.2929ZM7.29289 16.7071L7.46967 16.5303H7.46967L7.29289 16.7071ZM8.70711 16.7071L8.88388 16.8839L8.70711 16.7071ZM12 13.4142L12.1768 13.2374L12 13.0607L11.8232 13.2374L12 13.4142ZM13.4142 12L13.2374 11.8232L13.0607 12L13.2374 12.1768L13.4142 12ZM16.7071 8.70711L16.5303 8.53033V8.53033L16.7071 8.70711ZM16.7071 7.29289L16.5303 7.46967V7.46967L16.7071 7.29289ZM15.2929 7.29289L15.4697 7.46967V7.46967L15.2929 7.29289ZM12 10.5858L11.8232 10.7626L12 10.9393L12.1768 10.7626L12 10.5858ZM8.70711 7.29289L8.53033 7.46967L8.70711 7.29289ZM7.46967 8.53033C7.17678 8.23744 7.17678 7.76256 7.46967 7.46967L7.11612 7.11612C6.62796 7.60427 6.62796 8.39573 7.11612 8.88388L7.46967 8.53033ZM10.7626 11.8232L7.46967 8.53033L7.11612 8.88388L10.409 12.1768L10.7626 11.8232ZM10.409 11.8232L7.11612 15.1161L7.46967 15.4697L10.7626 12.1768L10.409 11.8232ZM7.11612 15.1161C6.62796 15.6043 6.62796 16.3957 7.11612 16.8839L7.46967 16.5303C7.17678 16.2374 7.17678 15.7626 7.46967 15.4697L7.11612 15.1161ZM7.11612 16.8839C7.60427 17.372 8.39573 17.372 8.88388 16.8839L8.53033 16.5303C8.23744 16.8232 7.76256 16.8232 7.46967 16.5303L7.11612 16.8839ZM8.88388 16.8839L12.1768 13.591L11.8232 13.2374L8.53033 16.5303L8.88388 16.8839ZM15.4697 16.5303L12.1768 13.2374L11.8232 13.591L15.1161 16.8839L15.4697 16.5303ZM16.5303 16.5303C16.2374 16.8232 15.7626 16.8232 15.4697 16.5303L15.1161 16.8839C15.6043 17.372 16.3957 17.372 16.8839 16.8839L16.5303 16.5303ZM16.5303 15.4697C16.8232 15.7626 16.8232 16.2374 16.5303 16.5303L16.8839 16.8839C17.372 16.3957 17.372 15.6043 16.8839 15.1161L16.5303 15.4697ZM13.2374 12.1768L16.5303 15.4697L16.8839 15.1161L13.591 11.8232L13.2374 12.1768ZM13.591 12.1768L16.8839 8.88388L16.5303 8.53033L13.2374 11.8232L13.591 12.1768ZM16.8839 8.88388C17.372 8.39573 17.372 7.60427 16.8839 7.11612L16.5303 7.46967C16.8232 7.76256 16.8232 8.23744 16.5303 8.53033L16.8839 8.88388ZM16.8839 7.11612C16.3957 6.62796 15.6043 6.62796 15.1161 7.11612L15.4697 7.46967C15.7626 7.17678 16.2374 7.17678 16.5303 7.46967L16.8839 7.11612ZM15.1161 7.11612L11.8232 10.409L12.1768 10.7626L15.4697 7.46967L15.1161 7.11612ZM8.53033 7.46967L11.8232 10.7626L12.1768 10.409L8.88388 7.11612L8.53033 7.46967ZM7.46967 7.46967C7.76256 7.17678 8.23744 7.17678 8.53033 7.46967L8.88388 7.11612C8.39573 6.62796 7.60427 6.62796 7.11612 7.11612L7.46967 7.46967Z" fill="#DEDEDE"/>
                    </svg>
                </div>
            </div>
        </div>
        <div class="overlay__wrapper" v-if="$store.state.selectProductOverlayVisible">
            <div class="overlay__content overlay__content--v3">
                <div class="tpf__variants--selector">
                    <div class="tpf__variants--selector--header">
                        <div class="tpf__variants--selector--header-left">
                            <h3>{{ $t('choose_variant') }}</h3>
                        </div>
                    </div>
                    <div class="variant--info">
                        {{ Object.keys(filteredVariants).length }} {{ Object.keys(filteredVariants).length === 1 ? $t('variant_amount_singular') : $t('variant_amount') }}
                    </div>
                    <div class="tpf__variants--selector--content">
                        <div class="tpf__list--entry--v3" :class="{'tpf__list--entry--v3--active':selectedSku==value.sku}" v-for="(value, key) in filteredVariants" :key="value.sku" @click="selectedSku = value.sku;">
                            <div class="tpf__list--entry--v3--left">
                                <div style="display:flex;align-items: center;justify-content: flex-start;gap:6px">
                                    <span>{{ value.sku }}</span>
                                    <template v-if="value.isNew">
                                        <span class="ar-flag ar-flag--new">new</span>
                                    </template>
                                </div>
                                <h3>{{$t('products.touch_flex.' + value.sku)}}</h3>
                            </div>
                            <div class="tpf__list--entry--v3--right">
                                <div><!-- Technology -->
                                    <svg v-if="value.technology == 'tree'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path id="path" d="M10.5 16.286L10.126 16.7161L10.1291 16.7188L10.5 16.286ZM22.5729 12.0003C22.5729 17.8395 17.8393 22.5731 12 22.5731V23.7131C18.4689 23.7131 23.7129 18.4691 23.7129 12.0003H22.5729ZM12 22.5731C6.16081 22.5731 1.42718 17.8395 1.42718 12.0003H0.287178C0.287178 18.4691 5.5312 23.7131 12 23.7131V22.5731ZM1.42718 12.0003C1.42718 6.16105 6.16081 1.42742 12 1.42742V0.287422C5.5312 0.287422 0.287178 5.53145 0.287178 12.0003H1.42718ZM12 1.42742C17.8393 1.42742 22.5729 6.16105 22.5729 12.0003H23.7129C23.7129 5.53145 18.4689 0.287422 12 0.287422V1.42742ZM12.57 23.1431V4.71455H11.43V23.1431H12.57ZM12 4.57314C12.0781 4.57314 12.1415 4.63645 12.1415 4.71456H11.0015C11.0015 5.26606 11.4485 5.71314 12 5.71314V4.57314ZM12.1415 4.71456C12.1415 4.79267 12.0781 4.85599 12 4.85599V3.71599C11.4485 3.71599 11.0015 4.16307 11.0015 4.71456H12.1415ZM12 5.71314C12.5515 5.71314 12.9986 5.26606 12.9986 4.71456H11.8586C11.8586 4.63645 11.9219 4.57314 12 4.57314V5.71314ZM12.9986 4.71456C12.9986 4.16307 12.5515 3.71599 12 3.71599V4.85599C11.9219 4.85599 11.8586 4.79268 11.8586 4.71456H12.9986ZM6.85718 6.71599C6.93529 6.71599 6.99861 6.77931 6.99861 6.85742H5.85861C5.85861 7.40892 6.30569 7.85599 6.85718 7.85599V6.71599ZM6.99861 6.85742C6.99861 6.93553 6.93529 6.99885 6.85718 6.99885V5.85885C6.30568 5.85885 5.85861 6.30593 5.85861 6.85742H6.99861ZM6.85718 7.85599C7.40867 7.85599 7.85575 7.40892 7.85575 6.85742H6.71575C6.71575 6.77931 6.77907 6.71599 6.85718 6.71599V7.85599ZM7.85575 6.85742C7.85575 6.30593 7.40867 5.85885 6.85718 5.85885V6.99885C6.77907 6.99885 6.71575 6.93553 6.71575 6.85742H7.85575ZM16.2857 7.57314C16.3639 7.57314 16.4272 7.63645 16.4272 7.71456H15.2872C15.2872 8.26606 15.7343 8.71314 16.2857 8.71314V7.57314ZM16.4272 7.71456C16.4272 7.79267 16.3639 7.85599 16.2857 7.85599V6.71599C15.7343 6.71599 15.2872 7.16307 15.2872 7.71456H16.4272ZM16.2857 8.71314C16.8372 8.71314 17.2843 8.26606 17.2843 7.71456H16.1443C16.1443 7.63645 16.2076 7.57314 16.2857 7.57314V8.71314ZM17.2843 7.71456C17.2843 7.16307 16.8372 6.71599 16.2857 6.71599V7.85599C16.2076 7.85599 16.1443 7.79268 16.1443 7.71456H17.2843ZM15.4286 13.5731C15.5067 13.5731 15.57 13.6365 15.57 13.7146H14.43C14.43 14.2661 14.8771 14.7131 15.4286 14.7131V13.5731ZM15.57 13.7146C15.57 13.7927 15.5067 13.856 15.4286 13.856V12.716C14.8771 12.716 14.43 13.1631 14.43 13.7146H15.57ZM15.4286 14.7131C15.9801 14.7131 16.4272 14.2661 16.4272 13.7146H15.2872C15.2872 13.6365 15.3505 13.5731 15.4286 13.5731V14.7131ZM16.4272 13.7146C16.4272 13.1631 15.9801 12.716 15.4286 12.716V13.856C15.3505 13.856 15.2872 13.7927 15.2872 13.7146H16.4272ZM6.00004 16.5731C6.07815 16.5731 6.14146 16.6365 6.14146 16.7146H5.00146C5.00146 17.2661 5.44854 17.7131 6.00004 17.7131V16.5731ZM6.14146 16.7146C6.14146 16.7927 6.07814 16.856 6.00004 16.856V15.716C5.44854 15.716 5.00146 16.1631 5.00146 16.7146H6.14146ZM6.00004 17.7131C6.55153 17.7131 6.99861 17.2661 6.99861 16.7146H5.85861C5.85861 16.6365 5.92192 16.5731 6.00004 16.5731V17.7131ZM6.99861 16.7146C6.99861 16.1631 6.55153 15.716 6.00004 15.716V16.856C5.92193 16.856 5.85861 16.7927 5.85861 16.7146H6.99861ZM18.8572 15.2874C18.9353 15.2874 18.9986 15.3507 18.9986 15.4289H17.8586C17.8586 15.9803 18.3057 16.4274 18.8572 16.4274V15.2874ZM18.9986 15.4289C18.9986 15.507 18.9353 15.5703 18.8572 15.5703V14.4303C18.3057 14.4303 17.8586 14.8774 17.8586 15.4289H18.9986ZM18.8572 16.4274C19.4087 16.4274 19.8557 15.9803 19.8557 15.4289H18.7157C18.7157 15.3507 18.7791 15.2874 18.8572 15.2874V16.4274ZM19.8557 15.4289C19.8557 14.8774 19.4087 14.4303 18.8572 14.4303V15.5703C18.7791 15.5703 18.7157 15.507 18.7157 15.4289H19.8557ZM5.57146 11.8589C5.64957 11.8589 5.71289 11.9222 5.71289 12.0003H4.57289C4.57289 12.5518 5.01997 12.9988 5.57146 12.9988V11.8589ZM5.71289 12.0003C5.71289 12.0784 5.64957 12.1417 5.57146 12.1417V11.0017C5.01997 11.0017 4.57289 11.4488 4.57289 12.0003H5.71289ZM5.57146 12.9988C6.12296 12.9988 6.57004 12.5518 6.57004 12.0003H5.43004C5.43004 11.9222 5.49335 11.8589 5.57146 11.8589V12.9988ZM6.57004 12.0003C6.57004 11.4488 6.12296 11.0017 5.57146 11.0017V12.1417C5.49335 12.1417 5.43004 12.0784 5.43004 12.0003H6.57004ZM10.8741 15.8559L5.94549 11.5702L5.19744 12.4304L10.126 16.7161L10.8741 15.8559ZM12.371 17.1389L11.371 16.2818L10.6291 17.1473L11.6291 18.0045L12.371 17.1389ZM11.371 16.2818L10.871 15.8532L10.1291 16.7188L10.6291 17.1473L11.371 16.2818ZM6.00003 17.2846H11V16.1446L6.00003 16.1446V17.2846ZM12.4031 11.5972L7.26023 6.45437L6.45413 7.26047L11.597 12.4033L12.4031 11.5972ZM12.3561 11.5882L16.6418 8.15966L15.9297 7.26947L11.644 10.698L12.3561 11.5882ZM12.3754 21.8578L15.804 18.8578L15.0533 17.9999L11.6247 20.9999L12.3754 21.8578ZM15.804 18.8578L19.2325 15.8578L18.4818 14.9999L15.0533 17.9999L15.804 18.8578ZM15.9986 18.4289L15.9986 13.7146H14.8586L14.8586 18.4289H15.9986ZM11.5715 5.28456H12.4286V4.14456H11.5715V5.28456ZM6.42861 7.42742H7.28575V6.28742H6.42861V7.42742ZM15.8572 8.28456H16.7143V7.14456H15.8572V8.28456ZM5.14289 12.5703H6.00004V11.4303H5.14289V12.5703ZM5.57146 17.2846H6.42861V16.1446H5.57146V17.2846ZM15 14.2846H15.8572V13.1446H15V14.2846ZM18.4286 15.9988H19.2857V14.8589H18.4286V15.9988Z" fill="black"/>
                                    </svg>
                                    <svg v-else-if="value.technology == 'air'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path id="path" d="M10.3749 13.2165C10.8793 12.9822 11.4332 12.8574 12.0001 12.8574C12.5669 12.8574 13.1209 12.9822 13.6252 13.2165M8.79653 10.2232C9.77492 9.70622 10.8732 9.42885 12 9.42885C13.1269 9.42885 14.2252 9.70622 15.2035 10.2232M7.22192 7.23577C8.67133 6.43256 10.3134 6.00028 12.0001 6.00028C13.6868 6.00028 15.3288 6.43256 16.7782 7.23577M12 18.0003C11.7633 18.0003 11.5715 17.8084 11.5715 17.5717M12 18.0003C12.2367 18.0003 12.4286 17.8084 12.4286 17.5717M12 18.0003V17.1431M11.5715 17.5717C11.5715 17.335 11.7633 17.1431 12 17.1431M11.5715 17.5717H12.4286M12 17.1431C12.2367 17.1431 12.4286 17.335 12.4286 17.5717M23.1429 12.0003C23.1429 18.1543 18.1541 23.1431 12 23.1431C5.846 23.1431 0.857178 18.1543 0.857178 12.0003C0.857178 5.84625 5.846 0.857422 12 0.857422C18.1541 0.857422 23.1429 5.84625 23.1429 12.0003Z" stroke="black" stroke-width="1.14" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div class="tpf--attribute" :class="{'inactive': !value.has_backlight}"><!-- Backlight -->
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path id="path" d="M12.0001 0.857422V2.57171M9.42859 23.1431H14.5714M19.8792 4.12109L18.667 5.33328M23.1429 12.0003H21.4286M19.8792 19.8795L18.667 18.6673M4.12085 19.8795L5.33303 18.6673M0.857178 12.0003H2.57146M4.12085 4.12109L5.33303 5.33328M6.00006 12.0003C6.00006 8.68657 8.68635 6.00027 12.0001 6.00027C15.3138 6.00027 18.0001 8.68657 18.0001 12.0003C18.0001 14.3938 16.5986 16.4599 14.5715 17.4229V19.286H9.42863V17.4229C7.40154 16.4599 6.00006 14.3938 6.00006 12.0003Z" stroke="black" stroke-width="1.14" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div class="tpf--attribute" :class="{'inactive': !value.has_temperature}"><!-- Temp. Sensor -->
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path id="path" d="M1.71423 4.28599H6.85709M1.71423 9.42885H6.85709M1.71423 14.5717H6.85709M1.71423 19.7146H6.85709M16.2857 18.0003C16.2857 17.5334 16.6759 17.1431 17.1428 17.1431M16.2857 18.0003C16.2857 18.4671 16.6759 18.8574 17.1428 18.8574M16.2857 18.0003H17.9999M17.1428 18.8574C17.6097 18.8574 17.9999 18.4671 17.9999 18.0003M17.1428 18.8574V17.1431M17.9999 18.0003C17.9999 17.5334 17.6097 17.1431 17.1428 17.1431M17.1428 23.1431C19.9832 23.1431 22.2857 20.8407 22.2857 18.0003C22.2857 16.0967 21.2514 14.4347 19.7142 13.5455V3.42885C19.7142 2.00868 18.5629 0.857422 17.1428 0.857422C15.7226 0.857422 14.5714 2.00868 14.5714 3.42885V13.5455C13.0342 14.4347 11.9999 16.0967 11.9999 18.0003C11.9999 20.8407 14.3025 23.1431 17.1428 23.1431Z" stroke="black" stroke-width="1.14" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div class="tpf--attribute" :class="{'inactive': !value.has_humidity}"><!-- Humidity. Sensor -->
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path id="path" d="M14.5714 12.0003L9.42859 18.8574M9.85716 12.8574C9.85716 13.0941 9.66528 13.286 9.42859 13.286M9.85716 12.8574C9.85716 12.6207 9.66528 12.4289 9.42859 12.4289M9.85716 12.8574H9.00002M9.42859 13.286C9.1919 13.286 9.00002 13.0941 9.00002 12.8574M9.42859 13.286V12.4289M9.42859 12.4289C9.1919 12.4289 9.00002 12.6207 9.00002 12.8574M15 18.0003C15 18.237 14.8081 18.4289 14.5714 18.4289M15 18.0003C15 17.7636 14.8081 17.5717 14.5714 17.5717M15 18.0003H14.1429M14.5714 18.4289C14.3348 18.4289 14.1429 18.237 14.1429 18.0003M14.5714 18.4289V17.5717M14.5714 17.5717C14.3348 17.5717 14.1429 17.7636 14.1429 18.0003M20.5714 14.5717C20.5714 19.3055 16.7339 23.1431 12 23.1431C7.26615 23.1431 3.42859 19.3055 3.42859 14.5717C3.42859 9.42885 12 0.857422 12 0.857422C12 0.857422 20.5714 9.42885 20.5714 14.5717Z" stroke="black" stroke-width="1.14" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div class="tpf--attribute" :class="{'inactive': !value.has_co2}"><!-- CO2. Sensor -->
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path id="path" d="M9.08117 9.87638C8.8626 9.25799 8.27285 8.81494 7.57962 8.81494H6.5182C5.63887 8.81494 4.92606 9.52778 4.92606 10.4071V13.5914C4.92606 14.4707 5.63887 15.1835 6.5182 15.1835H7.57962C8.27285 15.1835 8.8626 14.7405 9.08117 14.1221M22.349 11.9993C22.349 6.28377 17.7157 1.65039 12.0001 1.65039C6.2845 1.65039 1.65112 6.28377 1.65112 11.9993C1.65112 17.715 6.2845 22.3482 12.0001 22.3482M21.5529 22.3481H17.3071V21.4434C17.3071 20.8109 17.6816 20.2383 18.2612 19.9847L20.6237 18.9511C21.1882 18.7041 21.5529 18.1464 21.5529 17.5304C21.5529 16.6738 20.8586 15.9795 20.0022 15.9795H18.8993C18.2061 15.9795 17.6163 16.4225 17.3977 17.041M11.4694 10.4071V13.5914C11.4694 14.4707 12.1822 15.1835 13.0615 15.1835H14.1229C15.0023 15.1835 15.7151 14.4707 15.7151 13.5914V10.4071C15.7151 9.52778 15.0023 8.81494 14.1229 8.81494H13.0615C12.1822 8.81494 11.4694 9.52778 11.4694 10.4071Z" stroke="black" stroke-width="1.14" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div v-if="value.color == 'anthracite'">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g id="Icon" clip-path="url(#clip0_3371_24875)">
                                            <path stroke-width="0" id="path" d="M12 24C18.6275 24 24 18.6275 24 12C24 5.37259 18.6275 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6275 5.37259 24 12 24Z" fill="url(#paint0_linear_3371_24875)"/>
                                        </g>
                                        <defs>
                                            <linearGradient id="paint0_linear_3371_24875" x1="16.5894" y1="24" x2="6.01761" y2="-2.1374e-07" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.0975336" stop-color="#394349"/>
                                                <stop offset="0.818805" stop-color="#717171"/>
                                            </linearGradient>
                                                <clipPath id="clip0_3371_24875">
                                                <rect width="24" height="24" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <div v-else-if="value.color == 'white'">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g id="Icon" clip-path="url(#clip0_3371_24062)">
                                            <g id="path">
                                                <path stroke-width="0" d="M12 24C18.6275 24 24 18.6275 24 12C24 5.37259 18.6275 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6275 5.37259 24 12 24Z" fill="url(#paint0_linear_3371_24062)"/>
                                                <path stroke-width="0" d="M12 24C18.6275 24 24 18.6275 24 12C24 5.37259 18.6275 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6275 5.37259 24 12 24Z" fill="url(#paint1_linear_3371_24062)"/>
                                            </g>
                                        </g>
                                        <defs>
                                            <linearGradient id="paint0_linear_3371_24062" x1="16.5894" y1="24" x2="6.01761" y2="-2.1374e-07" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.0975336" stop-color="#394349"/>
                                                <stop offset="0.818805" stop-color="#717171"/>
                                            </linearGradient>
                                            <linearGradient id="paint1_linear_3371_24062" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.220857" stop-color="#EDEDED"/>
                                                <stop offset="0.794138" stop-color="#C4C4C4"/>
                                            </linearGradient>
                                            <clipPath id="clip0_3371_24062">
                                                <rect width="24" height="24" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tpf__variants--filter">
                    <div class="tpf__variants--filter--header">
                        <h3>{{ $t('filter') }}</h3>
                        <span :class="{'configurations--filtered': Object.keys(availableVariants).length !== Object.keys(filteredVariants).length }" @click="resetFilter()">{{ $t('reset_filter') }}</span>
                    </div>
                    <div class="tpf__variants--filter--content">
                        <div class="tpf__variant--filter--item"> <!-- Technology -->
                            <span class="tpf__variant--filter--item-title">{{ $t('attributes.technology') }}</span>
                            <div class="tpf__variant--filter--item-group">
                                <button @click="toggleFilter('technology', 'tree')" class="tpf__variant--filter--item-selector" :class="getVariantSelectorClass('technology', 'tree')" :disabled="!filters.technology.available('tree')">{{ $t('attributes.technology_tree') }}</button>
                                <button @click="toggleFilter('technology', 'air')" class="tpf__variant--filter--item-selector" :class="getVariantSelectorClass('technology', 'air')" :disabled="!filters.technology.available('air')">{{ $t('attributes.technology_air') }}</button>
                            </div>
                        </div>
                        <div class="tpf__variant--filter--item"> <!-- Power Mode -->
                            <span class="tpf__variant--filter--item-title">{{ $t('attributes.power_mode') }}</span>
                            <div class="tpf__variant--filter--item-group">
                                <span @click="toggleFilter('power_mode', '24v')" class="tpf__variant--filter--item-selector" :class="getVariantSelectorClass('power_mode', '24v')" :disabled="!filters.power_mode.available('24v')">{{ $t('attributes.power_mode_24v') }}</span>
                                <span @click="toggleFilter('power_mode', 'battery')" class="tpf__variant--filter--item-selector" :class="getVariantSelectorClass('power_mode', 'battery')" :disabled="!filters.power_mode.available('battery')">{{ $t('attributes.power_mode_battery') }}</span>
                            </div>
                        </div>
                        <div class="tpf__variant--filter--item"> <!-- IP Rating -->
                            <span class="tpf__variant--filter--item-title">{{ $t('attributes.ip_rating') }}</span>
                            <div class="tpf__variant--filter--item-group">
                                <span @click="toggleFilter('ip_rating', 'ip20')" class="tpf__variant--filter--item-selector" :class="getVariantSelectorClass('ip_rating', 'ip20')" :disabled="!filters.ip_rating.available('ip20')">{{ $t('attributes.ip_rating_ip20') }}</span>
                                <span @click="toggleFilter('ip_rating', 'ip44')" class="tpf__variant--filter--item-selector" :class="getVariantSelectorClass('ip_rating', 'ip44')" :disabled="!filters.ip_rating.available('ip44')">{{ $t('attributes.ip_rating_ip44') }}</span>
                            </div>
                        </div>
                        <div class="tpf__variant--filter--item"> <!-- Features & Sensores -->
                            <span class="tpf__variant--filter--item-title">{{ $t('attributes.features') }}</span>
                            <div class="tpf__variant--filter--item-group">
                                <span @click="toggleFilter('temperature')" class="tpf__variant--filter--item-selector" :class="getVariantSelectorClass('temperature')" :disabled="!filters.temperature.available()">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path id="path" d="M1.71423 4.28599H6.85709M1.71423 9.42885H6.85709M1.71423 14.5717H6.85709M1.71423 19.7146H6.85709M16.2857 18.0003C16.2857 17.5334 16.6759 17.1431 17.1428 17.1431M16.2857 18.0003C16.2857 18.4671 16.6759 18.8574 17.1428 18.8574M16.2857 18.0003H17.9999M17.1428 18.8574C17.6097 18.8574 17.9999 18.4671 17.9999 18.0003M17.1428 18.8574V17.1431M17.9999 18.0003C17.9999 17.5334 17.6097 17.1431 17.1428 17.1431M17.1428 23.1431C19.9832 23.1431 22.2857 20.8407 22.2857 18.0003C22.2857 16.0967 21.2514 14.4347 19.7142 13.5455V3.42885C19.7142 2.00868 18.5629 0.857422 17.1428 0.857422C15.7226 0.857422 14.5714 2.00868 14.5714 3.42885V13.5455C13.0342 14.4347 11.9999 16.0967 11.9999 18.0003C11.9999 20.8407 14.3025 23.1431 17.1428 23.1431Z" stroke="black" stroke-width="1.14" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    {{ $t('attributes.feature_temperature') }}
                                </span>
                                <span @click="toggleFilter('humidity')" class="tpf__variant--filter--item-selector" :class="getVariantSelectorClass('humidity')" :disabled="!filters.humidity.available()">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path id="path" d="M14.5714 12.0003L9.42859 18.8574M9.85716 12.8574C9.85716 13.0941 9.66528 13.286 9.42859 13.286M9.85716 12.8574C9.85716 12.6207 9.66528 12.4289 9.42859 12.4289M9.85716 12.8574H9.00002M9.42859 13.286C9.1919 13.286 9.00002 13.0941 9.00002 12.8574M9.42859 13.286V12.4289M9.42859 12.4289C9.1919 12.4289 9.00002 12.6207 9.00002 12.8574M15 18.0003C15 18.237 14.8081 18.4289 14.5714 18.4289M15 18.0003C15 17.7636 14.8081 17.5717 14.5714 17.5717M15 18.0003H14.1429M14.5714 18.4289C14.3348 18.4289 14.1429 18.237 14.1429 18.0003M14.5714 18.4289V17.5717M14.5714 17.5717C14.3348 17.5717 14.1429 17.7636 14.1429 18.0003M20.5714 14.5717C20.5714 19.3055 16.7339 23.1431 12 23.1431C7.26615 23.1431 3.42859 19.3055 3.42859 14.5717C3.42859 9.42885 12 0.857422 12 0.857422C12 0.857422 20.5714 9.42885 20.5714 14.5717Z" stroke="black" stroke-width="1.14" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    {{ $t('attributes.feature_humidity') }}
                                </span>
                                <span @click="toggleFilter('co2')" class="tpf__variant--filter--item-selector" :class="getVariantSelectorClass('co2')" :disabled="!filters.co2.available()">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path id="path" d="M9.08117 9.87638C8.8626 9.25799 8.27285 8.81494 7.57962 8.81494H6.5182C5.63887 8.81494 4.92606 9.52778 4.92606 10.4071V13.5914C4.92606 14.4707 5.63887 15.1835 6.5182 15.1835H7.57962C8.27285 15.1835 8.8626 14.7405 9.08117 14.1221M22.349 11.9993C22.349 6.28377 17.7157 1.65039 12.0001 1.65039C6.2845 1.65039 1.65112 6.28377 1.65112 11.9993C1.65112 17.715 6.2845 22.3482 12.0001 22.3482M21.5529 22.3481H17.3071V21.4434C17.3071 20.8109 17.6816 20.2383 18.2612 19.9847L20.6237 18.9511C21.1882 18.7041 21.5529 18.1464 21.5529 17.5304C21.5529 16.6738 20.8586 15.9795 20.0022 15.9795H18.8993C18.2061 15.9795 17.6163 16.4225 17.3977 17.041M11.4694 10.4071V13.5914C11.4694 14.4707 12.1822 15.1835 13.0615 15.1835H14.1229C15.0023 15.1835 15.7151 14.4707 15.7151 13.5914V10.4071C15.7151 9.52778 15.0023 8.81494 14.1229 8.81494H13.0615C12.1822 8.81494 11.4694 9.52778 11.4694 10.4071Z" stroke="black" stroke-width="1.14" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    {{ $t('attributes.feature_co2') }}
                                </span>
                                <span @click="toggleFilter('backlight')" class="tpf__variant--filter--item-selector" :class="getVariantSelectorClass('backlight')" :disabled="!filters.backlight.available()">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path id="path" d="M12.0001 0.857422V2.57171M9.42859 23.1431H14.5714M19.8792 4.12109L18.667 5.33328M23.1429 12.0003H21.4286M19.8792 19.8795L18.667 18.6673M4.12085 19.8795L5.33303 18.6673M0.857178 12.0003H2.57146M4.12085 4.12109L5.33303 5.33328M6.00006 12.0003C6.00006 8.68657 8.68635 6.00027 12.0001 6.00027C15.3138 6.00027 18.0001 8.68657 18.0001 12.0003C18.0001 14.3938 16.5986 16.4599 14.5715 17.4229V19.286H9.42863V17.4229C7.40154 16.4599 6.00006 14.3938 6.00006 12.0003Z" stroke="black" stroke-width="1.14" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    {{ $t('attributes.feature_backlight') }}
                                </span>
                            </div>
                        </div>
                        <div class="tpf__variant--filter--item"> <!-- Color -->
                            <span class="tpf__variant--filter--item-title">{{ $t('attributes.color') }}</span>
                            <div class="tpf__variant--filter--item-group">
                                <span @click="toggleFilter('color', 'white')" class="tpf__variant--filter--item-selector" :class="getVariantSelectorClass('color', 'white')" :disabled="!filters.color.available('white')">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g id="Icon" clip-path="url(#clip0_3371_24062)">
                                            <g id="path">
                                                <path stroke-width="0" d="M12 24C18.6275 24 24 18.6275 24 12C24 5.37259 18.6275 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6275 5.37259 24 12 24Z" fill="url(#paint0_linear_3371_24062)"/>
                                                <path stroke-width="0" d="M12 24C18.6275 24 24 18.6275 24 12C24 5.37259 18.6275 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6275 5.37259 24 12 24Z" fill="url(#paint1_linear_3371_24062)"/>
                                            </g>
                                        </g>
                                        <defs>
                                            <linearGradient id="paint0_linear_3371_24062" x1="16.5894" y1="24" x2="6.01761" y2="-2.1374e-07" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.0975336" stop-color="#394349"/>
                                                <stop offset="0.818805" stop-color="#717171"/>
                                            </linearGradient>
                                            <linearGradient id="paint1_linear_3371_24062" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.220857" stop-color="#EDEDED"/>
                                                <stop offset="0.794138" stop-color="#C4C4C4"/>
                                            </linearGradient>
                                            <clipPath id="clip0_3371_24062">
                                                <rect width="24" height="24" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    {{ $t('attributes.color_white') }}
                                </span>
                                <span @click="toggleFilter('color', 'anthracite')" class="tpf__variant--filter--item-selector" :class="getVariantSelectorClass('color', 'anthracite')" :disabled="!filters.color.available('anthracite')">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g id="Icon" clip-path="url(#clip0_3371_24875)">
                                            <path stroke-width="0" id="path" d="M12 24C18.6275 24 24 18.6275 24 12C24 5.37259 18.6275 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6275 5.37259 24 12 24Z" fill="url(#paint0_linear_3371_24875)"/>
                                        </g>
                                        <defs>
                                            <linearGradient id="paint0_linear_3371_24875" x1="16.5894" y1="24" x2="6.01761" y2="-2.1374e-07" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.0975336" stop-color="#394349"/>
                                                <stop offset="0.818805" stop-color="#717171"/>
                                            </linearGradient>
                                                <clipPath id="clip0_3371_24875">
                                                <rect width="24" height="24" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    {{ $t('attributes.color_anthracite') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tpf__variants--button">
                    <a @click="this.$store.state.selectProductOverlayVisible=false;" class="btn btn--ghost">{{$t('cancel')}}</a>
                    <a v-if="selectedSku == null" style="margin: 0 !important;" class="btn btn--disabled">{{$t('choose_variant')}}</a>
                    <a v-else style="margin: 0 !important;" class="btn" @click="configuration.sku=selectedSku;updateConfiguration();this.$store.state.selectProductOverlayVisible=false;">{{$t('choose_variant')}}</a>
                </div>
            </div>
        </div>
        <div v-if="$store.state.shareOverlayVisible" class="overlay__wrapper overlay__wrapper--share">
            <div class="overlay__content">
                <div class="overlay__content--top">
                    <div style="width:162px;height:162px;margin: 20px auto 0 auto;">
                        <div style="transform: scale(0.3);transform-origin: left top;">
                            <touch-flex :activeVal="current_touch_area.id" :key="touchFlexLiveVersion" :configuration="configuration"></touch-flex>
                        </div>
                    </div>
                    <h3>{{$t('share')}}</h3>
                </div>
                <div class="overlay__content--bottom">
                    <label>{{$t('copy_link')}}</label>
                   <div class="dual__input--wrapper">
                        <input spellcheck="false" id="shareurl__input" readonly="readonly" type="text" :value="shareUrl">
                        <button id="shareurl__button" @click="copyShareUrl()" type="button" class="btn btn--dark">{{$t('copy')}}</button>
                    </div>
                    <label>{{$t('send_link_via_mail')}}</label>
                   <div class="dual__input--wrapper">
                        <input type="email" placeholder="your@email.com" v-model="shareUrlEmail">
                        <button id="sendurl_button" type="button" @click="sendShareUrl()" class="btn btn--dark">{{$t('send')}}</button>
                    </div>
                    <p v-if="!$store.state.loggedIn">{{$t('send_info_guest')}}</p>
                    <p v-else>{{$t('send_info_user')}}</p>
                </div>
                <div @click="$store.state.shareOverlayVisible = false;" class="overlay--close">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="12" fill="#DEDEDE"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L10.5858 12L7.29289 15.2929C6.90237 15.6834 6.90237 16.3166 7.29289 16.7071C7.68342 17.0976 8.31658 17.0976 8.70711 16.7071L12 13.4142L15.2929 16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071C17.0976 16.3166 17.0976 15.6834 16.7071 15.2929L13.4142 12L16.7071 8.70711C17.0976 8.31658 17.0976 7.68342 16.7071 7.29289C16.3166 6.90237 15.6834 6.90237 15.2929 7.29289L12 10.5858L8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289Z" fill="black"/>
                        <path d="M7.29289 8.70711L7.46967 8.53033L7.29289 8.70711ZM7.29289 7.29289L7.46967 7.46967L7.29289 7.29289ZM10.5858 12L10.7626 12.1768L10.9393 12L10.7626 11.8232L10.5858 12ZM7.29289 15.2929L7.46967 15.4697H7.46967L7.29289 15.2929ZM7.29289 16.7071L7.46967 16.5303H7.46967L7.29289 16.7071ZM8.70711 16.7071L8.88388 16.8839L8.70711 16.7071ZM12 13.4142L12.1768 13.2374L12 13.0607L11.8232 13.2374L12 13.4142ZM13.4142 12L13.2374 11.8232L13.0607 12L13.2374 12.1768L13.4142 12ZM16.7071 8.70711L16.5303 8.53033V8.53033L16.7071 8.70711ZM16.7071 7.29289L16.5303 7.46967V7.46967L16.7071 7.29289ZM15.2929 7.29289L15.4697 7.46967V7.46967L15.2929 7.29289ZM12 10.5858L11.8232 10.7626L12 10.9393L12.1768 10.7626L12 10.5858ZM8.70711 7.29289L8.53033 7.46967L8.70711 7.29289ZM7.46967 8.53033C7.17678 8.23744 7.17678 7.76256 7.46967 7.46967L7.11612 7.11612C6.62796 7.60427 6.62796 8.39573 7.11612 8.88388L7.46967 8.53033ZM10.7626 11.8232L7.46967 8.53033L7.11612 8.88388L10.409 12.1768L10.7626 11.8232ZM10.409 11.8232L7.11612 15.1161L7.46967 15.4697L10.7626 12.1768L10.409 11.8232ZM7.11612 15.1161C6.62796 15.6043 6.62796 16.3957 7.11612 16.8839L7.46967 16.5303C7.17678 16.2374 7.17678 15.7626 7.46967 15.4697L7.11612 15.1161ZM7.11612 16.8839C7.60427 17.372 8.39573 17.372 8.88388 16.8839L8.53033 16.5303C8.23744 16.8232 7.76256 16.8232 7.46967 16.5303L7.11612 16.8839ZM8.88388 16.8839L12.1768 13.591L11.8232 13.2374L8.53033 16.5303L8.88388 16.8839ZM15.4697 16.5303L12.1768 13.2374L11.8232 13.591L15.1161 16.8839L15.4697 16.5303ZM16.5303 16.5303C16.2374 16.8232 15.7626 16.8232 15.4697 16.5303L15.1161 16.8839C15.6043 17.372 16.3957 17.372 16.8839 16.8839L16.5303 16.5303ZM16.5303 15.4697C16.8232 15.7626 16.8232 16.2374 16.5303 16.5303L16.8839 16.8839C17.372 16.3957 17.372 15.6043 16.8839 15.1161L16.5303 15.4697ZM13.2374 12.1768L16.5303 15.4697L16.8839 15.1161L13.591 11.8232L13.2374 12.1768ZM13.591 12.1768L16.8839 8.88388L16.5303 8.53033L13.2374 11.8232L13.591 12.1768ZM16.8839 8.88388C17.372 8.39573 17.372 7.60427 16.8839 7.11612L16.5303 7.46967C16.8232 7.76256 16.8232 8.23744 16.5303 8.53033L16.8839 8.88388ZM16.8839 7.11612C16.3957 6.62796 15.6043 6.62796 15.1161 7.11612L15.4697 7.46967C15.7626 7.17678 16.2374 7.17678 16.5303 7.46967L16.8839 7.11612ZM15.1161 7.11612L11.8232 10.409L12.1768 10.7626L15.4697 7.46967L15.1161 7.11612ZM8.53033 7.46967L11.8232 10.7626L12.1768 10.409L8.88388 7.11612L8.53033 7.46967ZM7.46967 7.46967C7.76256 7.17678 8.23744 7.17678 8.53033 7.46967L8.88388 7.11612C8.39573 6.62796 7.60427 6.62796 7.11612 7.11612L7.46967 7.46967Z" fill="#DEDEDE"/>
                    </svg>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    #floater{
        position: fixed; /* Floating above */
        background-color: #F5F5F5;
        border: 1px solid #E73246;
        width: 58px;
        height: 58px;
        background-size: 34px;
        box-sizing: border-box;
        cursor: pointer;
        background-repeat: no-repeat;
        background-position: center center;
        pointer-events: none;
        text-align: center;
        padding: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        
        img{
            opacity: 0.5;
            width: 34px;
            height: 34px;
            display: block;
            margin: 0 auto;
        }
    }

    #floater__group{
        position: fixed; /* Floating above */
   
        .floater__group--wrapper{
            position: relative;

            .floater__group--inner{
                background-color: #F5F5F5;
                border: 1px solid #E73246;
                width: 58px;
                height: 58px;
                background-size: 34px;
                box-sizing: border-box;
                cursor: pointer;
                background-repeat: no-repeat;
                background-position: center center;
                pointer-events: none;
                position: absolute;
                top: 0;
                z-index: 40;
                left: 0;

                &:nth-child(2) {
                    top: 3px;
                    left: 3px;
                    z-index: 30;
                }
                &:nth-child(3) {
                    top: 6px;
                    left: 6px;
                    z-index: 20;
                }
                &:nth-child(4) {
                    top: 9px;
                    left: 9px;
                    z-index: 10;
                }
            }
        }
    }
</style>

<script>
    import axios from 'axios';
    import TouchFlex from '../components/TouchFlex.vue';
    import ConfiguratorFilterMixin from '@/mixins/ConfiguratorFilterMixin.js';
    import availableVariants from '@/constants/tpfconfig.js';


    export default {
        mixins: [ConfiguratorFilterMixin],
        components: {
            TouchFlex,
        },
        data() {
            return {
                updateTimeStamps: [],
                orderVariantsVisible: false,
                currentSuggestions: {},
                shareUrlEmail: '',
                eMailInputVisible: false,
                orderAmmount: 1,
                shareUrl: '',
                availableVariants,
                functionLibrarySetting: 'global',
                functionLibraryCurrentFunctionBlock: {},
                configuratorReady: false,
                readOnlyMode: false,
                orderedMode: false,
                apiCommandGeneratorVisible: false,
                apiCommandGeneratorType: '',
                commandGeneratorAbbrevation: '',
                backlightActive: false,
                commandGeneratorAction: '',
                commandGeneratorCommand: '',
                commandGeneratorData: {
                    value: '',
                    minValue: '',
                    maxValue: '',
                    stepSize: '',
                    unit: '',
                    t5: '',
                    startTime: '',
                    milliseconds: '',
                    menues: [
                        '',
                    ],
                },
                currentLibrary: 'symbols',
                suggestionSearchTerm: null,
                lastTouchAreaUpdateId: null,
                touchFlexLiveVersion: 1,
                layoutsVisible: false,
                symbolsVisible: false,
                configuration_id: window.location.href.split('/')[4],
                searchTerm: '',
                gridVisible: true,
                configurationLoaded: false, 
                iconSelectorVisible: false,
                iconSearchTerm: '',     
                symbolSearchTerm: '',     
                scaleFactor: 1,
                configuration: {},
                settings: 'global',
                settingDetail: 'appearance',
                current_touch_area: {},
                availableIcons: {},
                availableGroups: {},
                filteredIconsLeft: {},
                filteredSuggestions: {},
                foundSuggestions: 1,
                foundGroups: 1,
                foundIconsLeft: 1,
                foundIconsRight: 1,
                foundGroupsLeft: 1,
                filteredIconsRight: {},
                filteredGroupsLeft: {},
                currentGroup: {},
                currentDetail: {},
                suggestionsVisible: false,
                floatingElementVisible: false,
                floatingElementData: {},
                floatingGroupVisible: false,
                floatingGroupData: {},
                suggestions: {},
                draggable: {
                    touch_area_id_1: null,
                    touch_area_id_2: null,
                },
                availableLayouts: {},
                functionBlocks: {},
                loadingData: {
                    data: {
                        configuration: false,
                        symbols: false,
                        symbolGroups: false,
                        functionBlocks: false,
                        suggestions: false,
                        layouts: false,
                        header: false,
                    },
                },
                loadingInfo: {
                    progress:   0,
                    info:       ''
                },
                FIXED_TOUCH_AREA_OFFSET: 3, //Also found in "TouchFlex.vue"
                FIXED_FONT_SIZE_MULTIPLIER: 0.28125, //0.28125
            }
        },
        methods: {
            getProductPrice() {
                console.log(this.getShopInstance());
                switch(this.getShopInstance()) {
                    case 'dech':
                        return '285,00 Fr';
                    case 'enuk':
                        return '234,00 £';
                    case 'enus':
                        return '307,00 $';
                    case 'plpl':
                        return '1030,00 Zł';
                    case 'cscz':
                        return '5700,00 Kč';
                    default:
                        return '219,00 €';
                }
            }, 
            resetSuggestions() {
                this.currentGroup = {};
                this.suggestionSearchTerm = '';
                this.suggestionFilter();
            },
            auto_grow(element) {
                let e = element.target;
                e.style.height = "5px";
                e.style.height = (e.scrollHeight+5)+"px";
            },
            getConfiguratorClass() {
                let className = '';
                if(this.readOnlyMode) {
                    className += 'read-only';
                }
                if(this.orderedMode) {
                    className += ' ordered';
                }


                if(this.settings !== 'touch_area') {
                    className += ' layout--o-c';
                } else {
                    className += ' layout--c-o';
                }

                return className;
            },
            deleteSavedButton(id) {                
                var configData = new FormData();
                configData.append('configuration_id', this.configuration.id);
                configData.append("button_id", id);
                if(!this.readOnlyMode && !this.orderedMode) {
                    axios({
                        method: 'post',
                        crossDomain: true,
                        withCredentials: true,
                        data: configData,
                        url: 'https://configurator.loxone.com/api/deleteSavedButton',
                    })
                    .then(resp => {
                        delete this.configuration.saved_buttons[id];
                    });
                }
            },
            getFloaterClassName(data) {
                let className = '';

                if(data.icon) {
                    className += 'icon';
                }

                if(data.text) {
                    className += 'text';
                }

                return className;
            },
            closeOverlays() {
                if(this.suggestionsVisible) {
                    this.resetSuggestions();
                    this.suggestionsVisible = false;
                }

                if(this.$store.state.selectProductOverlayVisible) {
                    this.$store.state.selectProductOverlayVisible = false;
                }

                if(this.symbolsVisible) {
                    this.symbolsVisible = false;
                }

                if(this.layoutsVisible) {
                    this.layoutsVisible = false;
                }

                if(this.layoutsVisible) {
                    this.layoutsVisible = false;
                }
            },
            sendShareUrl() {
                if(this.shareUrlEmail) {
                    let configData = new FormData();
                    configData.append('configuration_id', this.configuration.id);
                    configData.append('email_address', this.shareUrlEmail);
                    configData.append('lang', this.$i18n.locale);

                    let test = document.querySelector('#sendurl_button');
                    test.textContent = 'Sending';
                    test.classList = ["btn"];

                    axios({
                        method: 'post',
                        crossDomain: true,
                        withCredentials: true,
                        data: configData,
                        url: 'https://configurator.loxone.com/api/sendShareUrl',
                    }).then(resp => {
                        if(resp.data.success){
                            setTimeout(() => {
                                test.textContent = 'Send';
                                test.classList = ["btn btn--dark"];
                            }, 1000);
                        }
                    });
                }
            },
            copyShareUrl() {
                let testingCodeToCopy = document.querySelector('#shareurl__input');
                testingCodeToCopy.select();

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                    console.log(msg);

                    let test = document.querySelector('#shareurl__button');
                    test.textContent = 'Copied';
                    test.classList = ["btn"];

                    setTimeout(() => {
                        test.textContent = 'Copy';
                    test.classList = ["btn btn--dark"];
                    }, 1000);

                } catch (err) {
                    console.error(err);
                }

                /* unselect the range */
                window.getSelection().removeAllRanges()
            },
            orderTouchFlex() {
                var productUrl = '';
                switch(this.configuration.sku) {
                    case 100507:
                        productUrl = '100507-touch-pure-flex-tree-white';
                    break;
                    case 100508:
                        productUrl = '100508-touch-pure-flex-tree-anthracite';
                    break;
                    case 100509:
                        productUrl = '100509-touch-pure-flex-battery-air-white';
                    break;
                    case 100510:
                        productUrl = '100510-touch-pure-flex-battery-air-anthracite';
                    break;
                    case 100608:
                        productUrl = '100608-touch-pure-flex-tree-white';
                    break;
                    case 100609:
                        productUrl = '100609-touch-pure-flex-tree-anthracite';
                    break;
                    case 100610:
                        productUrl = '100611-touch-pure-flex-24V-air-white';
                    break;
                    case 100611:
                        productUrl = '100611-touch-pure-flex-24V-air-anthracite';
                    break;
                    
                }
                let webshopUrl = 'https://shop.loxone.com//product/'+productUrl;
                return webshopUrl;
            },
            getShopInstance() {
                let checkNAVInstance = (this.$store.state.userData.content.account_nav_instance || this.$store.state.userData.content.contact_nav_instance);

                if(checkNAVInstance == 'CH') {
                    return 'dech';
                } else if(checkNAVInstance == 'UK') {
                    return 'enuk';
                } else if(checkNAVInstance == 'US') {
                    return 'enus';
                } else if(checkNAVInstance == 'AT') {
                    switch(this.$store.state.userData.content.account_country) {
                        case 'AT':
                            return 'deat';
                        case 'DE':
                            return 'dede';
                        case 'ES':
                        case 'CA':
                            return 'eses';
                        case 'FR':
                            return 'frfr';
                        case 'IT':
                            return 'itit';
                        case 'NL':
                            return 'nlnl';
                        case 'SK':
                            return 'sksk';
                        case 'PL':
                            return 'plpl';
                        case 'CZ':
                            return 'cscz';
                        default:
                            return 'enen';
                    }
                } else {
                    return 'enen';
                }
            },
            functionValidator(){
                if(this.current_touch_area.data.button_cmd) {
                    if(this.current_touch_area.data.button_cmd.toUpperCase().includes('VALUESELECT(') || this.current_touch_area.data.button_cmd.toUpperCase().includes('MENU(')) {
                        return true;
                    }
                }
                return false;
            },
            functionPlaceholderValidator() {
                if(this.functionValidator()) {
                    if(this.current_touch_area.data.button_cmd.toUpperCase().includes('VALUESELECT(') || this.current_touch_area.data.button_cmd.toUpperCase().includes('MENU(')) {
                        return 'Defined by API command';
                    }
                }
            },
            fillTouchArea(sugg) {
                this.current_touch_area.data.button_cmd = sugg.btn_command;
                this.current_touch_area.data.button_text = sugg.btn_display;
                this.current_touch_area.data.arrow_down_cmd = sugg.btn_down_command;
                this.current_touch_area.data.arrow_down_text = sugg.btn_down_display;
                this.current_touch_area.data.arrow_up_cmd = sugg.btn_up_command;
                this.current_touch_area.data.arrow_up_text = sugg.btn_up_display;

                this.current_touch_area.data.name = sugg.text;

            },
            openFunctionBlock(key) {
                this.functionLibrarySetting = 'function_blocks';
                this.currentSuggestions = this.getCurrentSuggestions();
            },
            updateLoadingData() {
                this.loadingInfo.progress = 0;
                let infoText = false;
                for (const [key, value] of Object.entries(this.loadingData.data)) {
                    if(value) {
                        this.loadingInfo.progress++;
                    } else if(!infoText) {
                        infoText = true;
                        this.loadingInfo.info = this.$t('loading.' + key);
                    }
                };

                if(this.loadingInfo.progress == Object.entries(this.loadingData.data).length) {
                    this.configuratorReady = true;
                }
            },
            resetApiCommandGenerator() {
                this.commandGeneratorData = {
                    value: '',
                    minValue: '',
                    maxValue: '',
                    stepSize: '',
                    unit: '',
                    t5: '',
                    startTime: '',
                    milliseconds: '',
                    menues: [
                        '',
                    ],
                };
                this.apiCommandGeneratorType= '';
                this.commandGeneratorAbbrevation= '';
                this.commandGeneratorAction= '';
                this.commandGeneratorCommand= '';

            },
            deleteMenueItem(i) {
                this.commandGeneratorData.menues.splice(i-1, 1);
            },
            getCurrentApiCommand() {
                let cAB = this.commandGeneratorAbbrevation;
                let cAC = this.commandGeneratorAction;
                let cCO = this.commandGeneratorCommand;
                let cDA = this.commandGeneratorData;
                let cmd = '';

                if(cCO == "SET") {
                    cmd = 'SET(';
                    if(cAB) {
                        cmd += cAB;
                    }
                    if(cAC) {
                        cmd += ';' + cAC;
                    }
                    if(cDA.value) {
                        cmd += ';' + cDA.value;
                    }
                    cmd += ')';
                } else if(cCO == "VALUESELECT") {
                    cmd = 'VALUESELECT(';
                        if(cAB) {
                            cmd += cAB;
                        }
                        if(cAC) {
                            cmd += ';'+cAC;
                        }
                        if(cDA.value || cDA.minValue || cDA.maxValue || cDA.stepSize || cDA.unit) {
                            cmd += ';'+cDA.value;
                        }
                        if(cDA.minValue || cDA.maxValue || cDA.stepSize || cDA.unit) {
                            cmd += ';'+cDA.minValue;
                        }
                        if(cDA.maxValue || cDA.stepSize || cDA.unit) {
                            cmd += ';'+cDA.maxValue;
                        }
                        if(cDA.stepSize || cDA.unit) {
                            cmd += ';'+cDA.stepSize;
                        }
                        if(cDA.unit) {
                            cmd += ';'+cDA.unit;
                        }
                    cmd += ')';
                } else if(cCO == "MENU") {
                    cmd = 'MENU(';
                    if(cAB) {
                        cmd += cAB;
                    }
                    if(cAC) {
                        cmd += ';' + cAC;
                    }
                    if(cDA.value) {
                        cmd += ';' + cDA.value;
                    }

                    for(const [key, value] of Object.entries(cDA.menues)) {
                        if(value.includes(':')) {
                            let data = value.split(':');
                            if(data[0] && data[1]) {
                                cmd += ';' + data[0] + ':';
                                if(data[1].charAt(0) !== '"') {
                                    cmd += '"';
                                }
                                    cmd+= data[1];
                                if(data[1].charAt(data[1].length-1) !== '"') {
                                    cmd += '"';
                                }
                            }
                        }
                    }

                    cmd += ')';
                } else if(cCO == "SETT5") {
                    cmd = 'SETT5(';
                    if(cAB) {
                        cmd += cAB;
                    }
                    if(cAC) {
                        cmd += ';' + cAC;
                    }
                    if(cDA.t5 || cDA.value) {
                        cmd += ';' + cDA.t5;
                    }
                    if(cDA.value) {
                        cmd += ';' + cDA.value;
                    }
                    cmd += ')';
                } else if(cCO == "TIMESELECT") {
                    cmd = 'TIMESELECT(';
                    if(cAB) {
                        cmd += cAB;
                    }
                    if(cAC) {
                        cmd += ';' + cAC;
                    }
                    if(cDA.startTime || cDA.stepSize) {
                        cmd += ';' + cDA.startTime;
                    }
                    if(cDA.stepSize) {
                        cmd += ';' + cDA.stepSize;
                    }
                    cmd += ')';
                } else if(cCO == "WAIT") {
                     cmd = 'WAIT(';
                    if(cDA.milliseconds) {
                        cmd += cDA.milliseconds;
                    }
                    cmd += ')';
                } else if(cCO == "ECHO") {
                    cmd = 'ECHO(';
                    if(cAB) {
                        cmd += cAB;
                    }
                    cmd += ')';
                } else if(cCO == "GETINPUT" || cCO == "GETOUTPUT") {
                    if(cCO == "GETINPUT") {
                        cmd = 'GETINPUT(';
                    } else {
                        cmd = 'GETOUTPUT(';
                    }
                    if(cAB) {
                        cmd += cAB;
                    }
                    if(cAC) {
                        cmd += ';' + cAC;
                    }

                    for(const [key, value] of Object.entries(cDA.menues)) {
                        if(value.includes(':')) {
                            let data = value.split(':');
                            if(data[0] && data[1]) {
                                cmd += ';' + data[0] + ':';
                                if(data[1].charAt(0) !== '"') {
                                    cmd += '"';
                                }
                                    cmd+= data[1];
                                if(data[1].charAt(data[1].length-1) !== '"') {
                                    cmd += '"';
                                }
                            }
                        }
                    }

                    cmd += ')';
                }

                return cmd;
            },
            getAvailableActions(abbrevation, input) {
                    let inputs = true;
                    let outputs = true;
                    let parameters = true;
                    
                    if(input == 'MENU'
                    || input == 'SET'
                    || input == 'VALUESELECT'
                    || input == 'SETT5'
                    || input == 'TIMESELECT') {
                        inputs = true;
                        outputs = false;
                        parameters = true;
                    } else if(input == 'GETINPUT') {
                        inputs = true;
                        outputs = false;
                        parameters = false;
                    } else if(input == 'GETOUTPUT') {
                        outputs = true;
                        inputs = false;
                        parameters = false;
                    }

                    for (const [key, value] of Object.entries(this.functionBlocks)) {
                        if(abbrevation == value.abbrevation) {
                            let arr = [];
                            if(inputs) {
                                for(const [key, value] of Object.entries(value.ios.Input)) {
                                    arr.push(value);
                                }
                                //arr = arr.concat(value.ios.Input);
                            }
                            if(outputs) {
                                //arr = arr.concat(value.ios.Output);
                                for(const [key, value] of Object.entries(value.ios.Output)) {
                                    arr.push(value);
                                }
                            }
                            if(parameters) {
                                //arr = arr.concat(value.ios.Parameter);
                                for(const [key, value] of Object.entries(value.ios.Parameter)) {
                                    arr.push(value);
                                }
                            }
                            return arr;
                        }
                    }
            },
            openApiCommandGenerator(text) {

                this.updateApiCommandGenerator(text);

                this.apiCommandGeneratorVisible = true;

                if(this.$store.state.selectProductOverlayVisible) {
                    this.$store.state.selectProductOverlayVisible = false;
                }

                if(this.symbolsVisible) {
                    this.symbolsVisible = false;
                }

                if(this.layoutsVisible) {
                    this.layoutsVisible = false;
                }

                if(this.suggestionsVisible) {
                    this.resetSuggestions();
                    this.suggestionsVisible = false;
                }
            },
            updateApiCommandGenerator(text) {
                this.commandGeneratorAbbrevation = '';
                this.commandGeneratorActio = '';
                this.commandGeneratorData = {
                    value: '',
                    minValue: '',
                    maxValue: '',
                    stepSize: '',
                    unit: '',
                    t5: '',
                    startTime: '',
                    milliseconds: '',
                    menues: [],
                }


                if(text) {
                    let cmd_found = '';

                    text.split('&').forEach(function(item) {
                        if(!cmd_found) {
                            if(item.includes('MENU(')) {
                                cmd_found = 'MENU';
                            } else if(item.includes('SET(')) {
                                cmd_found = 'SET';
                            } else if(item.includes('SETT5(')) {
                                cmd_found = 'SETT5';
                            } else if(item.includes('TIMESELECT(')) {
                                cmd_found = 'TIMESELECT';
                            } else if(item.includes('WAIT(')) {
                                cmd_found = 'WAIT';
                            } else if(item.includes('ECHO(')) {
                                cmd_found = 'ECHO';
                            } else if(item.includes('GETINPUT(')) {
                                cmd_found = 'GETINPUT';
                            } else if(item.includes('GETOUTPUT(')) {
                                cmd_found = 'GETOUTPUT';
                            } else if(item.includes('VALUESELECT(')) {
                                cmd_found = 'VALUESELECT';
                            }
                        }
                    });

                    let commandData = this.getSubstringBetweenTwoStrings(text, cmd_found).split(';');

                    if(commandData[0]) {
                        this.commandGeneratorAbbrevation = commandData[0];
                    }

                    if(commandData[1]) {
                        this.commandGeneratorAction = commandData[1];
                    }

                    console.log(commandData);


                    if(commandData.length > 0) {
                        console.log(this.commandGeneratorData);

                        console.log(cmd_found);


                        if(cmd_found == "MENU") {
                            this.commandGeneratorData.value = commandData[2];
                            for(let i = 3; i < commandData.length; i++) {
                                this.commandGeneratorData.menues.push(commandData[i]);
                            }
                        } else if(cmd_found == 'SET') {
                            this.commandGeneratorData.value = commandData[2];
                        } else if(cmd_found == 'SETT5') {
                            this.commandGeneratorData.t5 = commandData[2];
                            this.commandGeneratorData.value = commandData[3];
                        } else if(cmd_found == 'TIMESELECT') {
                            this.commandGeneratorData.startTime = commandData[2];
                            this.commandGeneratorData.stepSize = commandData[3];
                        } else if(cmd_found == 'WAIT') {
                            this.commandGeneratorData.milliseconds = commandData[0];
                        } else if(cmd_found == 'ECHO') {
                            this.commandGeneratorData.value = commandData[0];
                        } else if(cmd_found == 'GETINPUT') {
                            for(let i = 2; i < commandData.length; i++) {
                                this.commandGeneratorData.menues.push(commandData[i]);
                            }
                        } else if(cmd_found == 'GETOUTPUT') {
                            for(let i = 2; i < commandData.length; i++) {
                                this.commandGeneratorData.menues.push(commandData[i]);
                            }
                        } else if(cmd_found == 'VALUESELECT') {
                            this.commandGeneratorData.value = commandData[2];
                            this.commandGeneratorData.minValue = commandData[3];
                            this.commandGeneratorData.maxValue = commandData[4];
                            this.commandGeneratorData.stepSize = commandData[5];
                            this.commandGeneratorData.unit = commandData[6];
                        }
                    }

                    this.commandGeneratorCommand = cmd_found;
                    
                }

            },
            getSubstringBetweenTwoStrings(text, start_text) {
                let start = text.indexOf(start_text);
                let end = text.indexOf(')');
                if(start > -1 && end > -1) {
                    return text.substring(start, end).replace(start_text+'(', '');
                }
            },
            closeApiCommandGenerator(e) {
                if(e.target.className == "overlay__wrapper overlay__wrapper--generator") {
                    this.apiCommandGeneratorVisible = false;
                }
            },
            changeLayout(data) {
                var configData = new FormData();
                configData.append("configuration", JSON.stringify(this.configuration));
                configData.append("layout", JSON.stringify(data));
                if(!this.readOnlyMode && !this.orderedMode) {
                    axios({
                        method: 'post',
                        crossDomain: true,
                        withCredentials: true,
                        data: configData,
                        url: 'https://configurator.loxone.com/api/changeTouchFlexLayout',
                    })
                    .then(resp => {
                        var configData = new FormData();
                        configData.append('configuration_id', window.location.href.split('/')[4]);
                        configData.append('hash', window.location.href.split('/')[6]);
                        axios({
                            method: 'post',
                            crossDomain: true,
                            withCredentials: true,
                            data: configData,
                            url: 'https://configurator.loxone.com/api/loadConfigurationDetail',
                        })
                        .then(resp => {
                            if (resp.data) {
                                this.configuration = resp.data;
                                this.configurationLoaded = true;

                                if(this.configuration.touch_areas) {
                                    for (const [key, value] of Object.entries(this.configuration.touch_areas)) {
                                        
                                        this.current_touch_area = value;
                                        this.updateTouchArea();

                                    }
                                }
                            }
                        });
                    });
                }
                this.toggleLayouts();
            },
            triggerSuggestionUpdate() {
                this.currentSuggestions = this.getCurrentSuggestions();
                this.suggestionFilter();
            },
            toggleSuggestions() {
                this.suggestionsVisible = !this.suggestionsVisible;
                this.resetSuggestions();

                if(this.$store.state.selectProductOverlayVisible) {
                    this.$store.state.selectProductOverlayVisible = false;
                }

                if(this.layoutsVisible) {
                    this.layoutsVisible = false;
                }

                if(this.symbolsVisible) {
                    this.symbolsVisible = false;
                }
            },
            forceUpdate() {
                this.touchFlexLiveVersion++;
            },
            toggleSymbols() {
                if(this.readOnlyMode || this.orderedMode) {
                    this.symbolsVisible = false;
                    return;
                }

                this.symbolsVisible = !this.symbolsVisible;
                this.$nextTick(() => {
                    if(!this.readOnlyMode && !this.orderedMode) {
                        this.$refs.symbolSearchInput.focus();
                    }
                });

                if(this.$store.state.selectProductOverlayVisible) {
                    this.$store.state.selectProductOverlayVisible = false;
                }

                if(this.layoutsVisible) {
                    this.layoutsVisible = false;
                }

                if(this.suggestionsVisible) {
                    this.resetSuggestions();
                    this.suggestionsVisible = false;
                }
            },
            toggleVariants() {
                if(this.readOnlyMode || this.orderedMode) {
                    this.$store.state.selectProductOverlayVisible = false;
                    return;
                }

                this.$store.state.selectProductOverlayVisible = !this.$store.state.selectProductOverlayVisible;

                if(this.layoutsVisible) {
                    this.layoutsVisible = false;
                }

                if(this.symbolsVisible) {
                    this.symbolsVisible = false;
                }

                if(this.suggestionsVisible) {
                    this.resetSuggestions();
                    this.suggestionsVisible = false;
                }
            },
            toggleLayouts() {
                if(this.readOnlyMode || this.orderedMode) {
                    this.layoutsVisible = false;
                    return;
                }

                this.layoutsVisible = !this.layoutsVisible;

                if(this.$store.state.selectProductOverlayVisible) {
                    this.$store.state.selectProductOverlayVisible = false;
                }

                if(this.symbolsVisible) {
                    this.symbolsVisible = false;
                }

                if(this.suggestionsVisible) {
                    this.resetSuggestions();
                    this.suggestionsVisible = false;
                }
            },
            openGroup(group) {
                this.currentGroup = group;
            },
            closeGroup() {
                this.currentGroup = {};
            },
            openDetail(detail) {
                this.currentDetail = detail;
            },
            closeDetail() {
                this.currentDetail = {};
            },
            fillCurrentTouchArea(o) {                
                if(o.abbrevation && o.action) {


                    this.current_touch_area.data.name            = this.$t('config.' + o.abbrevation + '.ios.translations.' + o.action + '.ShortDescription');
                    this.current_touch_area.data.button_cmd      = 'SET(' + o.abbrevation + '; ' + o.action + ')';
                    this.current_touch_area.data.abbrevation = o.abbrevation;
                } else {
                    this.current_touch_area.data.abbrevation = '';
                    this.current_touch_area.data.name = '';
                    this.current_touch_area.data.button_cmd = '';
                }
                

                if(!!o.display_text) {
                    this.current_touch_area.data.button_text = o.display_text;
                } else {
                    this.current_touch_area.data.button_text = '';
                }


                if(o.btn_down_abbrevation && o.btn_down_action) {
                    this.current_touch_area.data.arrow_down_cmd  = 'SET(' + o.btn_down_abbrevation + '; ' + o.btn_down_action + ')';
                } else {
                    this.current_touch_area.data.arrow_down_cmd  = '';
                }

                if(o.btn_down_display_text) {
                    this.current_touch_area.data.arrow_down_text = o.btn_down_display_text;
                } else {
                    this.current_touch_area.data.arrow_down_text = '';
                }

                if(o.btn_up_abbrevation && o.btn_up_action) {
                    this.current_touch_area.data.arrow_up_cmd = 'SET(' + o.btn_up_abbrevation + '; ' + o.btn_up_action + ')';;
                } else {
                    this.current_touch_area.data.arrow_up_cmd = '';
                }
                
                if(o.btn_up_display_text) {
                    this.current_touch_area.data.arrow_up_text = o.btn_up_display_text;
                } else {
                    this.current_touch_area.data.arrow_up_text = '';
                }

                this.updateTouchArea();
                this.currentDetail = {};
                this.currentGroup = {};
                this.resetSuggestions();
                this.suggestionsVisible = false;
            },
            getCurrentSuggestions() {
                let res = {
                    suggestions: [],
                    groups: {}
                };
                
                for (const [key, value] of Object.entries(this.suggestions)) {
                    
                    
                    if(value.alternative_text) {
                        value.text = value.alternative_text;
                    } else {
                        if(this.$te('config.' + value.function_block + '.ios.Input.' + value.function + '.ShortDescription')) {
                            value.text = this.$t('config.' + value.function_block + '.ios.Input.' + value.function + '.ShortDescription').replace('$$BR$$', '\n\r');
                        } else if(this.$te('config.' + value.function_block + '.ios.Parameter.' + value.function + '.ShortDescription')) {
                            value.text = this.$t('config.' + value.function_block + '.ios.Parameter.' + value.function + '.ShortDescription').replace('$$BR$$', '\n\r');
                        } else if(this.$te('config.' + value.function_block + '.ios.Output.' + value.function + '.ShortDescription')) {
                            value.text = this.$t('config.' + value.function_block + '.ios.Output.' + value.function + '.ShortDescription').replace('$$BR$$', '\n\r');
                        } else {
                            value.text = this.$t('config.' + value.function_block + '.ios.translations.' + value.function + '.ShortDescription').replace('$$BR$$', '\n\r');
                        }
                    }

                    if(this.current_touch_area.data.icon) {
                        if(value.icon == this.current_touch_area.data.icon) {
                            value.hidden = false;
                            res.suggestions.push(value);
                        }
                    }

                    if(!res.groups[value.function_block]) {
                        if(!value.function_block) {
                            value.function_block = 'others';
                            res.groups[value.function_block] = {
                                'title':    'Others',
                                'entries':  []
                            };
                        } else {
                            res.groups[value.function_block] = {
                                'title':    this.$t('config.' + value.function_block + '.name'),
                                'entries':  []
                            };
                        }
                    }

                    if(!JSON.stringify(res.groups[value.function_block].entries).includes(value.btn_command)) {
                        res.groups[value.function_block].entries.push(value);
                    }
                }

                res.suggestions = this.alphabetical_sort_object_of_objects(res.suggestions, 'text');
                res.groups = this.alphabetical_sort_object_of_objects(res.groups, 'title');

                return res;
            },
            alphabetical_sort_object_of_objects(data, attr) {
                var arr = [];
                for (var prop in data) {
                    if (data.hasOwnProperty(prop)) {
                        var obj = {};
                        obj[prop] = data[prop];
                        obj.tempSortName = data[prop][attr].toLowerCase();
                        arr.push(obj);
                    }
                }

                arr.sort(function(a, b) {
                    var at = a.tempSortName,
                        bt = b.tempSortName;
                    return at > bt ? 1 : ( at < bt ? -1 : 0 );
                });

                var result = [];
                for (var i=0, l=arr.length; i<l; i++) {
                    var obj = arr[i];
                    delete obj.tempSortName;
                    for (var prop in obj) {
                        if (obj.hasOwnProperty(prop)) {
                            var id = prop;
                        }
                    }
                    var item = obj[id];
                    result.push(item);
                }
                return result;
            },
            handleConfiguratorEntryStyle() {
                var style = "";

                style += "transform: scale(" + this.scaleFactor + ");";

                style += "width:540px;height:540px;";


                return style;
            },
            handleTouchAreaStyle(data) {
                var style = 'width:100%;height:100%;white-space:pre;';

                if(data.text_size) {
                    var px2mm = this.FIXED_FONT_SIZE_MULTIPLIER;
                    
                    style += "font-size:"+data.text_size / px2mm+"px;line-height:"+data.text_size / px2mm+"px;";
                    
                }else {
                    style += "font-size:6mm;line-height:6mm;";
                }
                if(data.text_weight == "bold") {
                    style += "font-family:averta-extrabold;letter-spacing:-0.6px;";
                }
                if(data.text_align || data.text_valign) {
                    style += "display:flex;";
                }
                if(data.text_align) {
                    style += "justify-content:"+data.text_align+";text-align:"+data.text_align+";";
                }
                if(data.text_valign){
                    style += "align-items:"+data.text_valign+";";
                }

                return style; 
            },
            openTouchAreaInterface(area_data, action = '') {

                if(Object.keys(this.current_touch_area).length > 0) {
                    this.getCurrentSuggestions();
                    this.updateTouchArea();
                }

                this.current_touch_area = area_data;
                console.log(this.current_touch_area);
                this.settings = 'touch_area';

                this.suggestionSearchTerm = '';
                this.currentSuggestions = this.getCurrentSuggestions();
                this.suggestionFilter();

                setTimeout(() => {
                    if(!this.readOnlyMode && !this.orderedMode) {
                        this.$refs.textInput.focus();

                        if(action == 'functions') {
                            document.getElementById('touch__area--scroller').scrollTo(0, 300);
                        }

                    }
                    Array.prototype.forEach.call(document.getElementsByClassName('auto_grow'), function(e) {        
                        e.style.height = "5px";
                        e.style.height = (e.scrollHeight+5)+"px";
                    });
                }, 100);
            },
            closeTouchAreaInterface() {
                this.updateTouchArea();
                this.settings = 'global';
                this.current_touch_area = {};
            },
            zoom(type) {
                if(type == 'out') {
                    this.scaleFactor = this.scaleFactor - 0.5;
                } else {
                    this.scaleFactor = this.scaleFactor + 0.5;
                }
                if(this.scaleFactor > 1.5) {
                    this.scaleFactor = 1.5;
                }
                if(this.scaleFactor < 0.5) {
                    this.scaleFactor = 0.5;
                }
            },
            getTouchAreaLayout(area){
                var style = '';
                var scaler = 10;

                if(area.pos_y) {
                    style += 'top: ' + (area.pos_y * scaler) + 'px;';
                }

                if(area.pos_x) {
                    style += 'left: ' + (area.pos_x * scaler) + 'px;';
                }

                if(area.width) {
                    style += 'width: ' + (area.width * scaler) + 'px;';
                }

                if(area.height) {
                    style += 'height: ' + (area.height * scaler) + 'px;';
                }
                

                return style;
            },
            toggleGrid() {
                this.gridVisible = !this.gridVisible;
            },
            showGrid(status) {
                this.gridVisible = status;
            },
            activateBacklight(status) {
                this.backlightActive = status;
            },
            toggleUpDownArrows() {
                this.configuration.up_down_arrows = !this.configuration.up_down_arrows;
                this.updateConfiguration();
            },
            updateConfiguration() {
                this.validateConfiguration();
                if(!this.readOnlyMode && !this.orderedMode) {
                    var configData = new FormData();
                    configData.append("configuration", JSON.stringify(this.configuration));
                    this.$store.state.configuratorSaving = true;
                    axios({
                        method: 'post',
                        crossDomain: true,
                        withCredentials: true,
                        data: configData,
                        url: 'https://configurator.loxone.com/api/updateConfigurationData',
                    })
                    .then(resp => {
                        this.$store.state.configuratorSaving = false;
                        this.$store.state.configurationSku = this.configuration.sku;
                        //console.log("updateConfigurationData done");
                    });
                }
            },
            toggleIconSelector() {
                this.iconSelectorVisible = !this.iconSelectorVisible;
                this.iconSearchTerm = '';
            },
            validateConfiguration() {
                let forceUpdate = false;
                if(!this.configuration.icon_size) {
                    this.configuration.icon_size = 7;
                    forceUpdate = true;
                } else if(this.configuration.icon_size < 5) {
                    this.configuration.icon_size = 5;
                    forceUpdate = true;
                } else if(this.configuration.icon_size > 16) {

                    if(this.configuration.id != 'TFPLUVM') {
                        this.configuration.icon_size = 16;
                        forceUpdate = true;
                    } else if(this.configuration.icon_size > 40) {
                        this.configuration.icon_size = 40;
                        forceUpdate = true;
                    }
                }

                if(!this.configuration.text_size) {
                    this.configuration.text_size = 7;
                    forceUpdate = true;
                } else if(this.configuration.text_size < 7) {
                    this.configuration.text_size = 7;
                    forceUpdate = true;
                } else if(this.configuration.text_size > 18) {
                    this.configuration.text_size = 18;
                    forceUpdate = true;
                }

                for (const [key, value] of Object.entries(this.configuration.touch_areas)) {
                    if(value.data.text && !value.data.icon) {
                        let wrapperHeight = (value.height-this.FIXED_TOUCH_AREA_OFFSET) * 10;
                        let wrapperWidth = (value.width-this.FIXED_TOUCH_AREA_OFFSET) * 10;


                        
                        let textHeight = this.getTextSize('height', value.data.text, "normal normal normal " + (parseInt(this.configuration.text_size) / this.FIXED_FONT_SIZE_MULTIPLIER * 1.2) + "px averta-regular")
                        let textWidth = this.getTextSize('width', value.data.text, "normal normal normal " + (parseInt(this.configuration.text_size) / this.FIXED_FONT_SIZE_MULTIPLIER) + "px averta-regular")+2;

                        if(textHeight > wrapperHeight || textWidth > wrapperWidth) { 
                            let i =0;
                            let temp_text_size = this.configuration.text_size;

                            while((textHeight > wrapperHeight || textWidth > wrapperWidth) && i < 100 && temp_text_size > 7) {
                                temp_text_size -= 1;

                                textHeight = this.getTextSize('height', value.data.text, "normal normal normal " + (parseInt(temp_text_size) / this.FIXED_FONT_SIZE_MULTIPLIER * 1.2) + "px averta-regular")
                                textWidth = this.getTextSize('width', value.data.text, "normal normal normal " + (parseInt(temp_text_size) / this.FIXED_FONT_SIZE_MULTIPLIER) + "px averta-regular")+2;

                                i++;
                            }

                            if(this.configuration.text_size != temp_text_size) {
                                this.configuration.text_size = temp_text_size;
                                forceUpdate = true;
                            }
                        }
                        
                    } else if(!value.data.text && value.data.icon) {
                        let smallestTouchAreaSize = 999;

                        if(value.width < smallestTouchAreaSize) {
                            smallestTouchAreaSize = Math.floor(value.width-this.FIXED_TOUCH_AREA_OFFSET);
                        }
                        if(value.height < smallestTouchAreaSize) {
                            smallestTouchAreaSize = Math.floor(value.height-this.FIXED_TOUCH_AREA_OFFSET);
                        }

                        if(this.configuration.icon_size > smallestTouchAreaSize-this.FIXED_TOUCH_AREA_OFFSET) {
                            this.configuration.icon_size = smallestTouchAreaSize-this.FIXED_TOUCH_AREA_OFFSET;
                            forceUpdate = true;
                        }
                    } else if(value.data.text && value.data.icon) {
                        let wrapperHeight = (value.height-this.FIXED_TOUCH_AREA_OFFSET) * 3;
                        let wrapperWidth = (value.width-this.FIXED_TOUCH_AREA_OFFSET) * 10;
                        let smallestTouchAreaSize = 999;


                        let textHeight = this.getTextSize('height', value.data.text, "normal normal normal " + (parseInt(this.configuration.text_size) / this.FIXED_FONT_SIZE_MULTIPLIER * 1.2) + "px averta-regular")
                        let textWidth = this.getTextSize('width', value.data.text, "normal normal normal " + (parseInt(this.configuration.text_size) / this.FIXED_FONT_SIZE_MULTIPLIER) + "px averta-regular")

                        

                        if(textHeight > wrapperHeight || textWidth > wrapperWidth) { 
                            let i =0;
                            let temp_text_size = this.configuration.text_size;

                            while((textHeight > wrapperHeight || textWidth > wrapperWidth) && i < 100) {
                                temp_text_size -= 1;

                                textHeight = this.getTextSize('height', value.data.text, "normal normal normal " + (parseInt(temp_text_size) / this.FIXED_FONT_SIZE_MULTIPLIER * 1.2) + "px averta-regular")
                                textWidth = this.getTextSize('width', value.data.text, "normal normal normal " + (parseInt(temp_text_size) / this.FIXED_FONT_SIZE_MULTIPLIER) + "px averta-regular")
                                i++;
                            }
                            this.configuration.text_size = temp_text_size;
                            //forceUpdate = true;
                            const logData = [
                                ["calculatexTextHeight", textHeight / 10, "mm"],
                                ["wrapperHeight", wrapperHeight / 10, "mm"],
                                ["textWidth", textWidth / 10, "mm"],
                                ["wrapperWidth", wrapperWidth / 10, "mm"],
                                ["text_size", this.configuration.text_size, "px"]
                            ];
                            console.table(logData)
                        }

                        if(value.width < smallestTouchAreaSize) {
                            smallestTouchAreaSize = Math.floor(value.width-1);
                        }
                        if(value.height < smallestTouchAreaSize) {
                            smallestTouchAreaSize = Math.floor(value.height-1);
                        }

                        if(this.configuration.icon_size >  Math.floor(smallestTouchAreaSize * 0.7)) {
                            this.configuration.icon_size = Math.floor(smallestTouchAreaSize * 0.7);
                            forceUpdate = true;
                        }
                    }
                }

                if(this.configuration.text_size < 7) {
                    this.configuration.text_size = 7;
                    //forceUpdate = true;
                } else if(this.configuration.text_size > 18) {
                    this.configuration.text_size = 18;
                    forceUpdate = true;
                }

                if(this.configuration.icon_size < 5) {
                    this.configuration.icon_size = 5;
                    forceUpdate = true;
                } else if(this.configuration.icon_size > 16) {
                    if(this.configuration.id != 'TFPLUVM') {
                        this.configuration.icon_size = 16;
                        forceUpdate = true;
                    } else if(this.configuration.icon_size > 40) {
                        this.configuration.icon_size = 40;
                        forceUpdate = true;
                    }
                }


                if(forceUpdate) {
                    this.updateConfiguration();
                }

            },
            updateTouchArea(icon = this.current_touch_area.data.icon, icon_size = this.current_touch_area.data.icon_size, text = this.current_touch_area.data.text, text_size = this.current_touch_area.data.text_size, text_weight = this.current_touch_area.data.text_weight, text_align = this.current_touch_area.data.text_align, text_valign = this.current_touch_area.data.text_valign) {
                this.validateConfiguration();
                this.updateTimeStamps[this.current_touch_area.id] = new Date().getTime();

                var error = false;
                let allowed_characters = "!\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\]^_`abcdefghijklmnopqrstuvwxyz{|}~ ¡¢£¤¥¦§¨©ª«¬®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿĀāĂăĄąĆćĈĉĊċČčĎďĐđĒēĔĕĖėĘęĚěĜĝĞğĠġĢģĤĥĦħĨĩĪīĬĭĮįİıĲĳĴĵĶķĸĹĺĻļĽľĿŀŁłŃńŅņŇňŉŊŋŌōŎŏŐőŒœŔŕŖŗŘřŚśŜŝŞşŠšŢţŤťŦŧŨũŪūŬŭŮůŰűŲųŴŵŶŷŸŹźŻżŽžſƏƒƝƠơƯưǍǎǏǐǑǒǓǔǕǖǗǘǙǚǛǜǦǧǪǫǺǻǼǽǾǿȘșȚțȲȳȷɑəɡɲʻʼʾʿˆˇˈˉˊˋˌ˘˙˚˛˜ʹ͵;΄΅Ά·ΈΉΊΌΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώϗḌḍḎḏḠḡḤḥḪḫḰḱḶḷḸḹḺḻṂṃṄṅṆṇṈṉṚṛṜṝṞṟṠṡṢṣṬṭṮṯẀẁẂẃẄẅẎẏẒẓẗẞẠạẢảẤấẦầẨẩẪẫẬậẮắẰằẲẳẴẵẶặẸẹẺẻẼẽẾếỀềỂểỄễỆệỈỉỊịỌọỎỏỐốỒồỔổỖỗỘộỚớỜờỞởỠỡỢợỤụỦủỨứỪừỬửỮữỰựỲỳỴỵỶỷỸỹ ‐‒–—―‘’‚“”„†‡•…‰′″‹›‽⁂⁄⁑⁰⁴⁵⁶⁷⁸⁹⁺⁻⁼⁽⁾ⁿ₀₁₂₃₄₅₆₇₈₉₊₋₌₍₎ₐₑₒₓ₡₤₦₧₫€₮₱₲₴₵₸₹₺₼₽ℓ№℗℠™Ω℮⅛⅜⅝⅞←↑→↓↔↕↖↗↘↙∂∅∆∏∑−√∞∫∶≈≠≤≥□△▷▽◁◇◊○☆☐☑☒☜☝☞☟➀➁➂➃➄➅➆➇➈";

                let newString = '';
                
                if(text && icon) {
                    text = text.replace(/[\r\n]/gm, '');

                    for (var i = 0; i < text.length; i++) {
                        if(allowed_characters.includes(text.charAt(i))) {
                            newString += text.charAt(i);
                        }
                    }

                } else if(text && !icon) {
                    for (var i = 0; i < text.length; i++) {
                        if(allowed_characters.includes(text.charAt(i)) || text.charAt(i) == '\n') {
                            newString += text.charAt(i);
                        }
                    }
                }

                text = newString

                if(!icon_size) {
                    icon_size = 7;
                } else if(icon_size < 5) {
                    icon_size = 5;
                }else if(icon_size > 16) {
                    if(this.configuration.id != 'TFPLUVM') {
                        icon_size = 16;
                    } else if(icon_size > 40) {
                        icon_size = 40;
                    }
                }

                if(!text_size) {
                    text_size = 7;
                } else if(text_size < 7) {
                    text_size = 7;
                } else if(text_size > 18) {
                    text_size = 18;
                } 

                if(icon && !text) {
                    // ICON & NO TEXT
                    if(this.current_touch_area.width < this.current_touch_area.height) {
                        // Portrait
                        if(icon_size >= Math.floor(this.current_touch_area.width-this.FIXED_TOUCH_AREA_OFFSET)) {
                            icon_size = Math.floor(this.current_touch_area.width-this.FIXED_TOUCH_AREA_OFFSET);
                        }
                    } else if (this.current_touch_area.width > this.current_touch_area.height) {
                        //  Landscape
                        if(icon_size >= Math.floor(this.current_touch_area.height-this.FIXED_TOUCH_AREA_OFFSET)) {
                            icon_size = Math.floor(this.current_touch_area.height-this.FIXED_TOUCH_AREA_OFFSET);
                        }
                    } else if(this.current_touch_area.width == this.current_touch_area.height){
                        //Square
                        if(icon_size >= Math.floor(this.current_touch_area.height-this.FIXED_TOUCH_AREA_OFFSET)) {
                            icon_size = Math.floor(this.current_touch_area.height-this.FIXED_TOUCH_AREA_OFFSET);
                        }
                    }

                    if(icon_size < 4) {
                        icon_size = 4;
                    }
                } else if(!icon && text) {
                    let wrapperHeight = (this.current_touch_area.height-this.FIXED_TOUCH_AREA_OFFSET) * 10;
                    let wrapperWidth = (this.current_touch_area.width-this.FIXED_TOUCH_AREA_OFFSET) * 10;
                    console.log(wrapperWidth);

                    let textHeight = this.getTextSize('height', text, "normal normal normal " + (parseInt(this.current_touch_area.data.text_size) / this.FIXED_FONT_SIZE_MULTIPLIER * 1.2) + "px averta-regular")
                    let textWidth = this.getTextSize('width', text, "normal normal normal " + (parseInt(this.current_touch_area.data.text_size) / this.FIXED_FONT_SIZE_MULTIPLIER) + "px averta-regular")

                    if(textHeight > wrapperHeight || textWidth > wrapperWidth) {
                        let i =0;
                        let temp_text_size = this.current_touch_area.data.text_size;

                        while((textHeight > wrapperHeight || textWidth > wrapperWidth) && i < 100) {
                            temp_text_size -= 1;

                            textHeight = this.getTextSize('height', text, "normal normal normal " + (parseInt(temp_text_size) / this.FIXED_FONT_SIZE_MULTIPLIER * 1.2) + "px averta-regular")
                            textWidth = this.getTextSize('width', text, "normal normal normal " + (parseInt(temp_text_size) / this.FIXED_FONT_SIZE_MULTIPLIER) + "px averta-regular")
                            i++;
                        }


                        this.configuration.touch_areas[this.current_touch_area.id].data.text_size = temp_text_size;
                        this.current_touch_area.data.text_size = temp_text_size;
                        text_size = temp_text_size;
                    }
                    
                    if(text_size < 7) {
                        text_size = 7;
                    } else if(text_size > 18) {
                        text_size = 18;
                    }


                    textWidth = this.getTextSize('width', text, "normal normal normal " + (parseInt(text_size) / this.FIXED_FONT_SIZE_MULTIPLIER) + "px averta-regular")
                    textHeight = this.getTextSize('height', text, "normal normal normal " + (parseInt(text_size) / this.FIXED_FONT_SIZE_MULTIPLIER * 1.2) + "px averta-regular")


                    if(textWidth > wrapperWidth || textHeight > wrapperHeight) {
                        let i =0;
                        let temp_text = this.current_touch_area.data.text;

                        while((textHeight > wrapperHeight || textWidth > wrapperWidth) && i < 100) {
                            temp_text = temp_text.substr(0, temp_text.length - 1);
                            textHeight = this.getTextSize('height', temp_text, "normal normal normal " + (parseInt(text_size) / this.FIXED_FONT_SIZE_MULTIPLIER * 1.2) + "px averta-regular")
                            textWidth = this.getTextSize('width', temp_text, "normal normal normal " + (parseInt(text_size) / this.FIXED_FONT_SIZE_MULTIPLIER) + "px averta-regular")
                            i++;
                        }
                        text = temp_text;
                    }


                } else if(icon && text) {
                    let wrapperHeight = (this.current_touch_area.height - this.FIXED_TOUCH_AREA_OFFSET) * 3;
                    let wrapperWidth = (this.current_touch_area.width-this.FIXED_TOUCH_AREA_OFFSET) * 10;
                    
                    let textHeight = this.getTextSize('height', text, "normal normal normal " + (parseInt(this.current_touch_area.data.text_size) / this.FIXED_FONT_SIZE_MULTIPLIER * 1.2) + "px averta-regular")
                    let textWidth = this.getTextSize('width', text, "normal normal normal " + (parseInt(this.current_touch_area.data.text_size) / this.FIXED_FONT_SIZE_MULTIPLIER) + "px averta-regular")
                    
                    if(textHeight > wrapperHeight || textWidth > wrapperWidth) {
                        let i =0;
                        let temp_text_size = this.current_touch_area.data.text_size;

                        while((textHeight > wrapperHeight || textWidth > wrapperWidth) && i < 100) {
                            temp_text_size -= 1;

                            textHeight = this.getTextSize('height', text, "normal normal normal " + (parseInt(temp_text_size) / this.FIXED_FONT_SIZE_MULTIPLIER * 1.2) + "px averta-regular")
                            textWidth = this.getTextSize('width', text, "normal normal normal " + (parseInt(temp_text_size) / this.FIXED_FONT_SIZE_MULTIPLIER) + "px averta-regular")
                            i++;
                        }


                        this.configuration.touch_areas[this.current_touch_area.id].data.text_size = temp_text_size;
                        this.current_touch_area.data.text_size = temp_text_size;
                        text_size = temp_text_size;
                    }
                    
                    if(this.current_touch_area.data.icon_size > Math.floor((this.current_touch_area.width - 1) * 0.7)) {
                        icon_size = Math.floor((this.current_touch_area.width - 1) * 0.7);
                    }

                    if(this.current_touch_area.data.icon_size > Math.floor((this.current_touch_area.height -1) * 0.7)) {
                        icon_size = Math.floor((this.current_touch_area.height -1) * 0.7);
                    }
                    
                    if(text_size < 7) {
                        text_size = 7;
                    } else if(text_size > 18) {
                        text_size = 18;
                    }

                    textWidth = this.getTextSize('width', text, "normal normal normal " + (parseInt(text_size) / this.FIXED_FONT_SIZE_MULTIPLIER) + "px averta-regular")
                    if(textWidth > wrapperWidth) {
                        let i =0;
                        let temp_text = text;

                        while((textWidth > wrapperWidth) && i < 100) {
                            temp_text = temp_text.substr(0, temp_text.length - 1);
                            textWidth = this.getTextSize('width', temp_text, "normal normal normal " + (parseInt(text_size) / this.FIXED_FONT_SIZE_MULTIPLIER) + "px averta-regular")
                            i++;
                        }
                        text = temp_text;
                    }
                }

                let name = this.current_touch_area.data.name;
                let button_cmd = this.current_touch_area.data.button_cmd;
                let button_text = this.current_touch_area.data.button_text;
                let arrow_up_cmd = this.current_touch_area.data.arrow_up_cmd;
                let arrow_up_text = this.current_touch_area.data.arrow_up_text;
                let arrow_down_cmd = this.current_touch_area.data.arrow_down_cmd;
                let arrow_down_text = this.current_touch_area.data.arrow_down_text;
                let abbrevation = this.current_touch_area.data.abbrevation;
                let icon_custom = this.current_touch_area.data.icon_custom;
                let text_custom = this.current_touch_area.data.text_custom;

                this.configuration.touch_areas[this.current_touch_area.id].data = {
                    'name':             name,
                    'icon':             icon,
                    'icon_size':        icon_size,
                    'text':             text,
                    'text_size':        text_size,
                    'text_weight':      text_weight,
                    'text_align':       text_align,
                    'text_valign':      text_valign,
                    'button_cmd':       button_cmd,
                    'button_text':      button_text,
                    'arrow_up_cmd':     arrow_up_cmd,
                    'arrow_up_text':    arrow_up_text,
                    'arrow_down_cmd':   arrow_down_cmd,
                    'arrow_down_text':  arrow_down_text,
                    'abbrevation':      abbrevation,
                    'icon_custom':      icon_custom,
                    'text_custom':      text_custom
                };
                if(!error) {
                    var touchAreaData = new FormData();
                    touchAreaData.append('name', name ? name : '');
                    touchAreaData.append('icon', icon ? icon : '');
                    touchAreaData.append('icon_size', icon_size ? icon_size : 6);
                    touchAreaData.append('text', text ? text : '');
                    touchAreaData.append('text_size', text_size ? text_size : '');
                    touchAreaData.append('text_weight', text_weight ? text_weight : '');
                    touchAreaData.append('text_align',  text_align ? text_align : '');
                    touchAreaData.append('text_valign', text_valign ? text_valign : '');
                    touchAreaData.append('button_cmd', button_cmd ? button_cmd : '');
                    touchAreaData.append('button_text', button_text ? button_text : '');
                    touchAreaData.append('arrow_up_cmd', arrow_up_cmd ? arrow_up_cmd : '');
                    touchAreaData.append('arrow_up_text', arrow_up_text ? arrow_up_text : '');
                    touchAreaData.append('arrow_down_cmd', arrow_down_cmd ? arrow_down_cmd : '');
                    touchAreaData.append('arrow_down_text', arrow_down_text ? arrow_down_text : '');
                    touchAreaData.append('abbrevation', abbrevation ? abbrevation : '');
                    touchAreaData.append('icon_custom', icon_custom ? icon_custom : false);
                    touchAreaData.append('text_custom', text_custom ? text_custom : false);

                    touchAreaData.append('touch_area_id', this.current_touch_area.id);
                    touchAreaData.append('configuration_id', this.configuration.id);

                    
                    
                    if(this.current_touch_area.id == this.lastTouchAreaUpdateId) {
                        setTimeout(() => {
                            if((new Date().getTime() - this.updateTimeStamps[this.current_touch_area.id]) >= 500) {
                                this.updateTouchAreaRequest(touchAreaData);
                            }
                        }, 500);

                    } else {
                        this.updateTouchAreaRequest(touchAreaData);
                    }

                    this.lastTouchAreaUpdateId = this.current_touch_area.id;
                }
            },
            updateTouchAreaRequest(touchAreaData) {
                console.log("asdf");
                this.$store.state.configuratorSaving = true;
                if(!this.readOnlyMode && !this.orderedMode) {
                    axios({
                        method: 'post',
                        crossDomain: true,
                        withCredentials: true,
                        data: touchAreaData,
                        url: 'https://configurator.loxone.com/api/updateTouchArea',
                    })
                    .then(resp => {
                        this.$store.state.configuratorSaving = false;
                    });
                } else if(!this.readOnlyMode && this.orderedMode) {
                    axios({
                        method: 'post',
                        crossDomain: true,
                        withCredentials: true,
                        data: touchAreaData,
                        url: 'https://configurator.loxone.com/api/updateTouchAreaSoftware',
                    })
                    .then(resp => {
                        this.$store.state.configuratorSaving = false;
                    });
                }
            },
            getTextSize(type, text, font) {
                var div = document.createElement('div');
                div.style.position = 'absolute';
                div.style.left = '-9999px';
                div.style.top = '-9999px';
                div.style.whiteSpace = 'nowrap';  // to get correct width
                div.style.font = font;
                div.innerText = text;

                document.body.appendChild(div);
                var width = div.offsetWidth;
                var height = div.offsetHeight;
                document.body.removeChild(div);

                if(type === 'height') {
                    return height;
                } else if(type === 'width') {
                    return width;
                }

                var canvas = this.getTextSize.canvas || (this.getTextSize.canvas = document.createElement("canvas"));
                var context = canvas.getContext("2d");
                context.font = font;
                var metrics = context.measureText(text);

                return metrics;
            },
            findAncestor (el, cls) {
                if(el.classList.contains(cls)) {
                    return el;
                }
                while ((el = el.parentElement) && !el.classList.contains(cls));
                return el;
            },
            iconFilterLeft() {
                this.filteredIconsLeft = JSON.parse(JSON.stringify(this.availableIcons));
                this.filteredGroupsLeft = JSON.parse(JSON.stringify(this.filteredGroupsLeft));

                this.foundIconsLeft = 0;
                this.foundGroupsLeft = 0;

                let activeIcons = [];

                for (const [key, value] of Object.entries(this.filteredIconsLeft)) {
                    this.filteredIconsLeft[key].hidden = true;


                    if(value.name.toLowerCase().includes(this.iconSearchTerm.toLowerCase())) {
                        this.filteredIconsLeft[key].hidden = false;
                    }

                    for (const [tKey, tValue] of Object.entries(value.tags)) {
                        if(Array.isArray(tValue)) {
                            tValue.forEach(element => {
                                if(element.toLowerCase().includes(this.iconSearchTerm.toLowerCase())) {
                                    this.filteredIconsLeft[key].hidden = false;
                                }
                            });
                        } else if(tValue.toLowerCase().includes(this.iconSearchTerm.toLowerCase())) {
                            this.filteredIconsLeft[key].hidden = false;
                        }
                    }

                    if(!this.filteredIconsLeft[key].hidden) {
                        activeIcons.push(this.filteredIconsLeft[key].name);
                        this.foundIconsLeft++;
                    }
                }

                for(const [key, value] of Object.entries(this.filteredGroupsLeft)) {
                    this.filteredGroupsLeft[key].hidden = true;

                    if(JSON.parse(this.filteredGroupsLeft[key].icons).some(r=> activeIcons.includes(r))) {
                        this.filteredGroupsLeft[key].hidden = false;
                        this.foundGroupsLeft++;
                    }
                }
            },
            iconFilterRight() {
                this.filteredIconsRight = JSON.parse(JSON.stringify(this.availableIcons));
                this.foundIconsRight = 0;

                for (const [key, value] of Object.entries(this.filteredIconsRight)) {
                    this.filteredIconsRight[key].hidden = true;


                    if(value.name.includes(this.symbolSearchTerm.toLowerCase())) {
                        this.filteredIconsRight[key].hidden = false;
                    }

                    for (const [tKey, tValue] of Object.entries(value.tags)) {
                        if(tValue.includes(this.symbolSearchTerm.toLowerCase())) {
                            this.filteredIconsRight[key].hidden = false;
                        }
                    }

                    if(!this.filteredIconsRight[key].hidden) {
                        this.foundIconsRight++;
                    }
                }
                
            },
            triggerMove(data) {
                console.log("triggerMove");
                this.floatingElementData = data;
                this.floatingElementVisible = true;
            },
            triggerGroupMove(data) {
                console.log("triggerGroupMove");
                this.floatingGroupData = JSON.parse(data.icons);
                this.floatingGroupVisible = true;
            },
            suggestionFilter() {
                    this.foundSuggestions = 0;
                    this.foundGroups = 0;

                    for (const [key, value] of Object.entries(this.currentSuggestions.suggestions)) {
                        value.hidden = true;
                        if(this.suggestionSearchTerm && this.suggestionSearchTerm.length > 0) {
                            if(value.function_block.toLowerCase().includes(this.suggestionSearchTerm.toLowerCase())
                            || value.function.toLowerCase().includes(this.suggestionSearchTerm.toLowerCase())
                            || value.btn_command.toLowerCase().includes(this.suggestionSearchTerm.toLowerCase())
                            || value.btn_display.toLowerCase().includes(this.suggestionSearchTerm.toLowerCase())
                            || value.btn_down_command.toLowerCase().includes(this.suggestionSearchTerm.toLowerCase())
                            || value.btn_down_display.toLowerCase().includes(this.suggestionSearchTerm.toLowerCase())
                            || value.btn_up_command.toLowerCase().includes(this.suggestionSearchTerm.toLowerCase())
                            || value.btn_up_display.toLowerCase().includes(this.suggestionSearchTerm.toLowerCase())
                            || this.$t('config.' + value.function_block + '.name').toLowerCase().includes(this.suggestionSearchTerm.toLowerCase())
                            || this.$t('config.' + value.function_block + '.ios.Input.' + value.function + '.ShortDescription').toLowerCase().includes(this.suggestionSearchTerm.toLowerCase())
                            || this.$t('config.' + value.function_block + '.ios.Parameter.' + value.function + '.ShortDescription').toLowerCase().includes(this.suggestionSearchTerm.toLowerCase())) {
                                value.hidden = false;
                                this.foundSuggestions++;
                            } else {
                                value.hidden = true;
                            }
                        } else {
                            this.foundSuggestions++;
                            value.hidden = false;
                        }
                    }

                    for (const [key, value] of Object.entries(this.currentSuggestions.groups)) {
                        value.hidden = true;
                        if(value.title.toLowerCase().includes(this.suggestionSearchTerm.toLowerCase())) {
                            value.hidden = false;
                            this.foundGroups++;
                        }
                    }
            },
        },
        watch: {
            suggestionSearchTerm() {
                this.suggestionFilter();
            },
            'configuration.description': function() {
                if(this.configuration.description) {
                    this.configuration.description = this.configuration.description.substr(0, 50).replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '').replace(/[\r\n]/gm, '');
                }
            },
            'current_touch_area.data.button_cmd' : function(){
                if(this.current_touch_area.data && this.current_touch_area.data.button_cmd) {
                    this.current_touch_area.data.button_cmd = this.current_touch_area.data.button_cmd.replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '').replace(/[\r\n]/gm, '');
                }
            },
            'current_touch_area.data.button_text' : function(){
                if(this.current_touch_area.data && this.current_touch_area.data.button_text) {
                    this.current_touch_area.data.button_text = this.current_touch_area.data.button_text.replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '').replace(/[\r\n]/gm, '');
                }
            },
            'current_touch_area.data.arrow_up_cmd' : function(){
                if(this.current_touch_area.data && this.current_touch_area.data.arrow_up_cmd) {
                    this.current_touch_area.data.arrow_up_cmd = this.current_touch_area.data.arrow_up_cmd.replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '').replace(/[\r\n]/gm, '');
                }
            },
            'current_touch_area.data.arrow_up_text' : function(){
                if(this.current_touch_area.data && this.current_touch_area.data.arrow_up_text) {
                    this.current_touch_area.data.arrow_up_text = this.current_touch_area.data.arrow_up_text.replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '').replace(/[\r\n]/gm, '');
                }
            },
            'current_touch_area.data.arrow_down_cmd' : function(){
                if(this.current_touch_area.data && this.current_touch_area.data.arrow_down_cmd) {
                    this.current_touch_area.data.arrow_down_cmd = this.current_touch_area.data.arrow_down_cmd.replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '').replace(/[\r\n]/gm, '');
                }
            },
            'current_touch_area.data.arrow_down_text' : function(){
                if(this.current_touch_area.data && this.current_touch_area.data.arrow_down_text) {
                    this.current_touch_area.data.arrow_down_text = this.current_touch_area.data.arrow_down_text.replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '').replace(/[\r\n]/gm, '');
                }
            },
            orderAmmount() {
                if(this.orderAmmount < 1) {
                    this.orderAmmount = 1;
                }
                if(this.orderAmmount > 999) {
                    this.orderAmmount = 999;
                }
                if(!Number.isInteger(this.orderAmmount)) {
                    this.orderAmmount = this.orderAmmount.replace(/\D/g, '');
                }
            },
            loadingData: {
                deep: true,
                handler() {
                    this.updateLoadingData();
                }
            },
            commandGeneratorAction: {
                deep: false,
                handler() {
                    if(!this.commandGeneratorCommand) {
                        for (const [key, value] of Object.entries(this.functionBlocks)) {
                            if(this.commandGeneratorAbbrevation == value.abbrevation) {
                                for (const [keyI, valueI] of Object.entries(value.ios.Input)) {
                                    if(this.commandGeneratorAction == valueI.ShortName) {
                                        this.commandGeneratorCommand =  valueI.DefaultAPICmd;
                                    }
                                }
                                for (const [keyI, valueI] of Object.entries(value.ios.Output)) {
                                    if(this.commandGeneratorAction == valueI.ShortName) {
                                        this.commandGeneratorCommand =  valueI.DefaultAPICmd;
                                    }
                                }
                                for (const [keyI, valueI] of Object.entries(value.ios.Parameter)) {
                                    if(this.commandGeneratorAction == valueI.ShortName) {
                                        this.commandGeneratorCommand =  valueI.DefaultAPICmd;
                                    }
                                }
                            }
                        }
                    }
                }
            },
            iconSearchTerm: {
                handler() {
                    this.iconFilterLeft();
                }
            },
            symbolSearchTerm: {
                handler() {
                    this.iconFilterRight();
                }
            }
        },
        async created () {
            document.body.classList.add('configurator');

            var configData = new FormData();
            configData.append('configuration_id', window.location.href.split('/')[4]);
            configData.append('page', window.location.href.split('/')[5]);
            configData.append('hash', window.location.href.split('/')[6]);
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                data: configData,
                url: 'https://configurator.loxone.com/api/loadConfigurationDetail',
            })
            .then(resp => {
                if (resp.data) {
                    console.log(resp.data);
                    if(resp.data.error) {
                        if(resp.data.message == 'ERROR.CONFIGURATION.DELTED' || resp.data.message == 'ERROR.CONFIGURATION.NOT_SHARED' || resp.data.message == 'ERROR.CONFIGURATION.HASH_CHECK_FAILED' || resp.data.message == 'ERROR.CONFIGURATION.NOT_SHARED') {
                            this.$router.push({
                                path: '/'
                            });
                        }
                    } else {
                        this.configuration = resp.data;
                        this.configurationLoaded = true;
                        this.loadingData.data.configuration = true;

                        this.$store.state.configurationType = resp.data.readonly ? 'read_only' : 'edit';
                        this.readOnlyMode = resp.data.readonly;
                        this.orderedMode = resp.data.ordered;
                        this.$store.state.configurationName = resp.data.description;
                        this.$store.state.configurationId = resp.data.id;
                        this.$store.state.configurationSku = resp.data.sku;

                        const glowingPossible = [
                            '100507',
                            '100508',
                            '100509',
                            '100510',
                        ];

                        if(glowingPossible.includes(resp.data.sku)) {
                            this.$store.state.configurationGlowing = resp.data.glow;
                        } else {
                            this.$store.state.configurationGlowing = false;
                        }

                        if(window.location.href.split('/')[5] == 'preview') {
                            console.log(window.location.href.split('/')[5]);
                            this.readOnlyMode = true;
                            this.$store.state.configurationType = 'read_only';


                            if(resp.data.sendToEditMode) {
                                location.href = location.origin + '/configurator/' + resp.data.id + '/edit/' + resp.data.editModeHash;
                            }
                        }
                    }
                }
            });

            var langData = new FormData();
            langData.append('lang', this.$i18n.locale);

            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                data: langData,
                url: 'https://configurator.loxone.com/api/loadAvailableIcons',
            })
            .then(resp => {
                if (resp.data) {
                    this.availableIcons = resp.data;
                    this.filteredIconsLeft = resp.data;
                    this.filteredIconsRight = resp.data;
                    this.loadingData.data.symbols = true;
                }
            });

            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://configurator.loxone.com/api/loadAvailableSymbolGroupsWithKeys',
            })
            .then(resp => {
                if (resp.data) {
                    this.availableGroups = resp.data;
                    this.filteredGroupsLeft = resp.data;
                    this.loadingData.data.symbolGroups = true;
                }
            });

            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://configurator.loxone.com/api/loadTdcFunctions',
            })
            .then(resp => {
                if (resp.data) {
                    this.functionBlocks = resp.data;
                    this.loadingData.data.functionBlocks = true;
                }
            });

            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://configurator.loxone.com/api/loadPredefinedButtons',
            })
            .then(resp => {
                if (resp.data) {
                    this.suggestions = resp.data;
                    this.loadingData.data.suggestions = true;
                }
            });

            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://configurator.loxone.com/api/loadTemplates',
            })
            .then(resp => {
                if (resp.data) {
                    this.availableLayouts = resp.data;
                    this.loadingData.data.layouts = true;
                }
            });


            
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                data: configData,
                url: 'https://configurator.loxone.com/api/getShareUrl',
            }).then(resp => {
                this.shareUrl = resp.data.url;
            });

            setTimeout(() => {
                this.loadingData.data.header = true;
            }, (500));


            // if(window.location.href.includes('/order')) {
            //     this.$store.state.buyOverlayVisible = true;
            // }
            // if(window.location.href.includes('/overlay')) {
            //     this.$store.state.showLaserOverlay = true;
            // }
        },
        mounted() {
            document.addEventListener("mouseup", e => {
                    if(this.floatingElementVisible && e.target.closest(".touch__area") && !this.draggable.touch_area_id_1) {
                        let touch_area_id = e.target.closest(".touch__area").getAttribute('data-id');


                        if(this.floatingElementData.type && this.floatingElementData.type == 'icon_only') {
                            this.configuration.touch_areas[touch_area_id].data.icon = this.floatingElementData.icon;
                        } else {
                            this.configuration.touch_areas[touch_area_id].data = this.floatingElementData;
                        }



                        if(this.floatingElementData.additional) {
                            this.deleteSavedButton(this.floatingElementData.additional);
                        }

                        this.openTouchAreaInterface(this.configuration.touch_areas[touch_area_id]);
                        this.currentSuggestions = this.getCurrentSuggestions();
                        this.suggestionFilter();
                        if(this.currentSuggestions && this.currentSuggestions.suggestions && this.currentSuggestions.suggestions.length > 0) {
                            this.currentSuggestions.suggestions.forEach(suggestion => {                        
                                if(suggestion.favourite == 1 && !this.current_touch_area.data.button_cmd) {

                                    let tmp_text = this.$t('config.' + suggestion.function_block + '.ios.translations.' + suggestion.function + '.ShortDescription').replace('$$BR$$', '\n\r');

                                    if(this.$te('config.' + suggestion.function_block + '.ios.Input.' + suggestion.function + '.ShortDescription')) {
                                        tmp_text = this.$t('config.' + suggestion.function_block + '.ios.Input.' + suggestion.function + '.ShortDescription').replace('$$BR$$', '\n\r');
                                    } else if(this.$te('config.' + suggestion.function_block + '.ios.Parameter.' + suggestion.function + '.ShortDescription')) {
                                        tmp_text = this.$t('config.' + suggestion.function_block + '.ios.Parameter.' + suggestion.function + '.ShortDescription').replace('$$BR$$', '\n\r');
                                    }

                                    if(suggestion.alternative_text) {
                                        tmp_text = suggestion.alternative_text;
                                    }
                                    this.current_touch_area.data.name = tmp_text;
                                    this.current_touch_area.data.button_cmd = suggestion.btn_command;
                                    this.current_touch_area.data.button_text = suggestion.btn_display;
                                    this.current_touch_area.data.arrow_up_cmd = suggestion.btn_up_command;
                                    this.current_touch_area.data.arrow_up_text = suggestion.btn_up_display;
                                    this.current_touch_area.data.arrow_down_cmd = suggestion.btn_down_command;
                                    this.current_touch_area.data.arrow_down_text = suggestion.btn_down_display;
                                }
                            });
                        }
                        this.updateTouchArea();
                    } else if(e.target.className == "configurator__inner" || e.target.className == "configurator__inner grid--visible") {
                        if(this.floatingElementVisible && this.current_touch_area && this.current_touch_area.data) {
                            this.current_touch_area.data = {};
                            this.updateTouchArea();
                        }
                    } else if(this.floatingElementVisible && e.target.closest(".touch__area") && this.draggable.touch_area_id_1) {
                        let touch_area_id = e.target.closest(".touch__area").getAttribute('data-id');
                        this.draggable.touch_area_id_2 = touch_area_id;

                        if(this.draggable.touch_area_id_1 !== this.draggable.touch_area_id_2) {
                            const temp_1 = JSON.parse(JSON.stringify(this.configuration.touch_areas[this.draggable.touch_area_id_1]));
                            const temp_2 = JSON.parse(JSON.stringify(this.configuration.touch_areas[this.draggable.touch_area_id_2]));

                            this.configuration.touch_areas[this.draggable.touch_area_id_1].data = temp_2.data;
                            this.current_touch_area = this.configuration.touch_areas[this.draggable.touch_area_id_1];
                            this.updateTouchArea();

                            this.configuration.touch_areas[this.draggable.touch_area_id_2].data = temp_1.data;
                            this.current_touch_area = this.configuration.touch_areas[this.draggable.touch_area_id_2];

                            this.updateTouchArea();

                            this.forceUpdate();
                        }
                    }
                    this.draggable = {
                        touch_area_id_1: null,
                        touch_area_id_2: null,
                    };
                    this.floatingElementVisible = false;



                    if(this.floatingGroupVisible && e.target.closest(".touch__area")) {
                        let touch_area_id = e.target.closest(".touch__area").getAttribute('data-id');
                        
                                        
                        let current_icon = this.floatingGroupData[Object.keys(this.floatingGroupData)[0]];
                        this.configuration.touch_areas[touch_area_id].data.icon = current_icon;
                        

                        this.current_touch_area = this.configuration.touch_areas[touch_area_id];
                        this.currentSuggestions = this.getCurrentSuggestions();
                        this.suggestionFilter();
                        if(this.currentSuggestions && this.currentSuggestions.suggestions && this.currentSuggestions.suggestions.length > 0) {
                            this.currentSuggestions.suggestions.forEach(suggestion => {                        
                                if(suggestion.favourite == 1 && !this.current_touch_area.data.button_cmd) {

                                    let tmp_text = this.$t('config.' + suggestion.function_block + '.ios.translations.' + suggestion.function + '.ShortDescription').replace('$$BR$$', '\n\r');

                                    if(this.$te('config.' + suggestion.function_block + '.ios.Input.' + suggestion.function + '.ShortDescription')) {
                                        tmp_text = this.$t('config.' + suggestion.function_block + '.ios.Input.' + suggestion.function + '.ShortDescription').replace('$$BR$$', '\n\r');
                                    } else if(this.$te('config.' + suggestion.function_block + '.ios.Parameter.' + suggestion.function + '.ShortDescription')) {
                                        tmp_text = this.$t('config.' + suggestion.function_block + '.ios.Parameter.' + suggestion.function + '.ShortDescription').replace('$$BR$$', '\n\r');
                                    }

                                    if(suggestion.alternative_text) {
                                        tmp_text = suggestion.alternative_text;
                                    }
                                    this.current_touch_area.data.name = tmp_text;
                                    this.current_touch_area.data.button_cmd = suggestion.btn_command;
                                    this.current_touch_area.data.button_text = suggestion.btn_display;
                                    this.current_touch_area.data.arrow_up_cmd = suggestion.btn_up_command;
                                    this.current_touch_area.data.arrow_up_text = suggestion.btn_up_display;
                                    this.current_touch_area.data.arrow_down_cmd = suggestion.btn_down_command;
                                    this.current_touch_area.data.arrow_down_text = suggestion.btn_down_display;
                                }
                            });
                        }

                        this.updateTouchArea();
                        this.floatingGroupData.shift();
                        
                        if(this.floatingGroupData.length == 0) {
                            this.floatingGroupData = {};
                            this.floatingGroupVisible = false;
                        }

                    } else if(this.floatingGroupVisible) {
                        this.floatingGroupData = {};
                        this.floatingGroupVisible = false;
                    }

                    if(this.moveWorkSurface) {
                        this.moveWorkSurface = false;
                    }
            });

            document.addEventListener("mousemove", e => {
                    if(this.floatingElementVisible) {
                        if(document.getElementById('floater')) {
                            document.getElementById('floater').style.top = ''+(e.clientY - 40)+'px';
                            document.getElementById('floater').style.left = ''+(e.clientX - 40)+'px';
                        }
                    }
                    if(this.floatingGroupVisible) {
                        if(document.getElementById('floater__group')) {
                            document.getElementById('floater__group').style.top = ''+(e.clientY - 40)+'px';
                            document.getElementById('floater__group').style.left = ''+(e.clientX - 40)+'px';
                        }
                    }
                    if(this.moveWorkSurface) {
                        //document.getElementById('workSurface').style.transform = 'translate('+(e.clientX-600)+'px,'+(e.clientY-400)+'px)';
                    }
            });

            document.addEventListener("mousedown", e => {

                /*if(this.settings == "touch_area") {
                    if(!this.findAncestor(e.target, "touch__area") && (this.findAncestor(e.target, "configurator__entry") || this.findAncestor(e.target, "configurator__inner"))) {
                        
                    }
                }*/

                if(e.target.className == "configurator__inner" || e.target.className == "configurator__inner grid--visible"){
                    this.moveWorkSurface = true;

                    if(this.current_touch_area && this.current_touch_area.data) {
                        this.closeOverlays();
                        this.closeTouchAreaInterface();
                        this.updateConfiguration();
                    }
                }

                if(!this.readOnlyMode && !this.orderedMode) {
                    console.log("mousedown triggered");
                    if(e.target.closest('.symbol__group--entry')) {
                        console.log("a");
                        let index = (e.target.closest(".symbol__group--entry").getAttribute('data-group'));
                        this.triggerGroupMove(this.availableGroups['symb-'+index]);
                    }

                    if(e.target.closest(".touch__area") && !e.target.closest(".touch__flex--template")) {
                        console.log("b");
                        let touch_area_id_1 = e.target.closest(".touch__area").getAttribute('data-id');
                        this.draggable.touch_area_id_1 = touch_area_id_1;

                        let content = this.configuration.touch_areas[touch_area_id_1].data;

                        this.triggerMove(content);
                    }

                    if(e.target.closest('.additional__buttons--entry')){
                        console.log("c");
                        let id_1 = e.target.closest(".additional__buttons--entry").getAttribute('data-id');
                        let content = this.configuration.saved_buttons[id_1].data;

                        content.additional = this.configuration.saved_buttons[id_1].id;

                        this.triggerMove(content);
                    }

                    if(e.target.closest(".symbol__library--draggable")) {
                        console.log("d");
                        let content = {
                            icon: e.target.closest(".symbol__library--draggable").getAttribute('data-icon'),
                            type: 'icon_only',
                        };

                        this.triggerMove(content);
                    }
                }
            });

            document.addEventListener("keydown", e => {
                if(e.key == "Escape") {
                    if(this.apiCommandGeneratorVisible) {
                        this.apiCommandGeneratorVisible = false;
                    } else if(this.$store.state.buyOverlayVisible) {
                        this.$store.state.buyOverlayVisible = false;
                    } else if(this.$store.state.shareOverlayVisible) {
                        this.$store.state.shareOverlayVisible = false;
                    } else if(this.$store.state.selectProductOverlayVisible) {
                        this.$store.state.selectProductOverlayVisible = false;
                    } else if(this.layoutsVisible) {
                        this.layoutsVisible = false;
                    } else if(this.symbolsVisible) {
                        this.symbolsVisible = false;
                    } else if(this.suggestionsVisible) {
                        this.resetSuggestions();
                        this.suggestionsVisible = false;
                    } else if(this.current_touch_area && this.current_touch_area.data) {
                        this.closeTouchAreaInterface();
                    }
                }
            });
        },
        unmounted() {
            document.removeEventListener("mousedown", null);
            document.removeEventListener("mouseup", null);
            document.removeEventListener("mousemove", null);
            document.removeEventListener("keydown", null);
        },
    }
</script>

<style lang="scss">
    html{
        background-color: #f5f5f5;
        border-radius: 5px;
    }
    .configurator__inner{
        .touch__area:hover{
            outline: 1px solid red !important;
            cursor: pointer;
        }

        .function--wrapper,
        .orientation__light,
        .status__led,
        .display__info{
            display: none;
        }

        &.grid--visible{
            .touch__area{
                outline: 1px solid rgba(128, 128, 128, 0.25);
                outline-offset: -2px;

                &.custom{
                    outline: 1px solid rgba(255, 255, 0, 1);
                }
                &.active{
                    outline: 1px solid red;
                }
            }

            .function--wrapper,
            .orientation__light,
            .status__led,
            .display__info{
                display: block;
            }            
        }
    }
</style>

<style lang="scss" scoped>
    /*.ta_w--text{
        background-color: rgba(255, 0, 0, 0.2);
    }*/
    
    .draggable--faker{
        position: fixed;
        z-index: 9999;
        background-color: white;
        width: 245px;
        box-shadow: 2px 2px 5px 0 rgba(0,0,0,0.7);
        border-radius: 1px;
    }
    .icon__interface{
        .interface__icon{
            padding: 0 15px 0 15px;
            position: relative;

            .interface__icon--active{
                cursor: pointer;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                background-color: #EDEDED;
                border: 1px solid #D9D9D9;
                border-radius: 1px;
                padding: 12px 15px;

                .icon--none{
                    color: #666666;
                }

                img{
                    margin-right: 10px;
                }
            }

            .icon__selector{
                z-index: 100;
                position: absolute;
                top: 10px;
                right: 0;
                left: 0;
                border: 1px solid #CFCFCF;
                border-radius: 1px;
                background-color: white;

                .icon__selector--grid{
                    display: grid;
                    grid-template-columns: repeat(5, 1fr);
                    padding: 12px;
                    grid-column-gap: 7px;
                    grid-row-gap: 7px;
                    max-height: 338px;
                    overflow-y: auto;
                    
                    .icon__selector--entry{
                        width: 40px;
                        height: 40px;
                        background-color: #EDEDED;
                        border: 2px solid #EDEDED;
                        box-sizing: border-box;
                        border-radius: 2px;
                        padding: 6px;
                        cursor: pointer;

                        &.active, &:hover{
                            border: 2px solid #E73246;
                        }
                    }
                }
            }
        }
        .interface__size{
            padding: 0 15px 0 15px;
            display: grid;
            grid-template-columns: 160px auto;
            grid-column-gap: 10px;

            .size__change--wrapper{
                display: flex;
            }

            .change--size{
                width: 50%;
                text-align: center;
                background-color: #EDEDED;
                border: 1px solid #D9D9D9;
                line-height: 28px;
                display: inline-block;
                cursor: pointer;
                user-select: none;
    
                &:first-child{
                    border-radius: 0 0 1px 1px;
                    border-right: none;
                }

                &:last-child{
                    border-radius: 1px 1px 0 0;
                }

            }
            .size--info{
                text-align: center;
                background-color: #EDEDED;
                border: 1px solid #D9D9D9;
                line-height: 28px;
                display: inline-block;
                cursor: pointer;                
            }
        }
    }

    .text__interface{
        padding: 0 15px 0 15px;

        textarea{
            outline: none;
            border-radius: 1px;
            background-color: #EDEDED;
            border: 1px solid #D9D9D9;
            line-height: 1.2em;
            padding: 5px;
            font-size: 14px;
            width: 100%;
            font-family: 'averta-regular', Arial, Helvetica, sans-serif;
            box-sizing: border-box;
            padding: 0 5px;
            resize: none;
        }
    }
    .interface__text--style{
        padding: 0 15px 0 15px;
        display: grid;
        grid-template-columns: 160px auto;
        grid-column-gap: 10px;

        .font_style--wrapper{
            display: flex;
        }

        .change--style{
            width: 50%;
            text-align: center;
            background-color: #EDEDED;
            border: 1px solid #D9D9D9;
            line-height: 28px;
            display: inline-block;
            cursor: pointer;
            user-select: none;

            &:first-child{
                border-radius: 0 0 1px 1px;
                border-right: none;
            }

            &:last-child{
                border-radius: 1px 1px 0 0;
            }

            &:hover, &.active{
                background-color: #E73245;
                color: white;
            }

        }
        .size--info{
            text-align: center;
            background-color: #EDEDED;
            border: 1px solid #D9D9D9;
            line-height: 28px;
            display: inline-block;
            cursor: pointer;                
        }
    }

    .interface__text--align,
    .interface__text--valign{
        padding: 0 15px 0 15px;
        display: grid;
        grid-template-columns: repeat(3, 1fr);

        div{
            text-align: center;
            background-color: #EDEDED;
            border: 1px solid #D9D9D9;
            height: 28px;
            display: inline-block;
            cursor: pointer;
            user-select: none;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover, &.active{
                background-color: #E73245;

                svg{
                    *.fill{
                        fill: white;
                    }

                    *.stroke{
                        stroke: white;
                    }
                }
            }
        }
    }

    .fake__checkbox{
        width: 14px;
        height: 14px;
        background-color: #E73245;
        border-radius: 3px;
        border: 1px solid #E73245;
        box-sizing: border-box;
        vertical-align: top;
        display: inline-block;
        cursor: pointer;
    }

    .search__wrapper{
        border-bottom: 1px solid #CFCFCF;
        padding: 12px;
        position: relative;

        svg{
            width: 16px;
            height: 16px;
            position: absolute;
            left: 12px;
            top: 16px;
        }

        input{
            width: 100%;
            outline: none;
            border: none;
            font-size: 12px;
            line-height: 16px;
            font-family: 'averta-regular', Arial, Helvetica, sans-serif;
            padding-left: 22px;
            box-sizing: border-box;
        }
    }

    .group__wrapper{
        padding: 12px;

        .group--headline{
            font-family: 'averta-extrabold', Arial, Helvetica, sans-serif;
            cursor: pointer;
            font-size: 12px;
            text-transform: uppercase;
            position: relative;

            svg{
                position: absolute;
                right: 0;
                top: 0;
            }
        }

        .group__entry--wrapper{
            display: grid;
            user-select: none;
            cursor: pointer;
            grid-template-columns: 40px auto;
            grid-column-gap: 8px;
            margin: 8px 0 8px 0;

            .group__entry--icon{
                width: 40px;
                height: 40px;
                background-color: rgba(0,0,0,0.1);
                padding: 8px;
                box-sizing: border-box;
            }
        }
        .group__entry--text{
            .entry--name{
                font-size: 14px;
                line-height: 25px;
            }
            .entry--description{
                font-size: 12px;
                line-height: 15px;
                color: #575C61;
            }
        }
    }

    .configurator__main{
        user-select: none;
        overflow: hidden;
        position: relative;

        &.white{
            .configurator__entry{
                color: #000000;
                background-image: url('../assets/images/touch_flex_white.png');
                background-repeat: no-repeat;
                background-size: cover;
                .configurator__positioner{
                    opacity: 0.7;
                }
            }

            .touch__area.display{
                background-color: #000000;
            }

            .touch__area.logo{
                svg path{
                    fill: #000000;
                }
                
            }

            .touch__area.bullet{
                background-color: #000000;
            }
        }

        &.anthracite{
            .configurator__entry{
                color: #FFFFFF;
                background-image: url('../assets/images/touch_flex_anthracite.png');
                background-repeat: no-repeat;
                background-size: cover;
                .configurator__positioner{
                    opacity: 0.4;
                }
                img{
                    filter: invert(1);
                }

            }

            .touch__area.display{
                background-color: #FFFFFF;
            }

            .touch__area.logo{
                svg path{
                    fill: #FFFFFF;
                }
                
            }

            .touch__area.bullet{
                background-color: #FFFFFF;
            }

        }

        .interactive__buttons{
            position: absolute;
            bottom: 10px;
            top: auto;
            display: flex;
            left: 0;
            right: 0;
            justify-content: center;

            .zoom__wrapper,
            .grid__wrapper{
                user-select: none;
                background-color: #FFFFFF;
                border: 1px solid #CCCCCC;
                margin-right: 10px;

                &:last-child{
                    margin-right: 0;
                }
            }

            .zoom__wrapper{
                
                .zoom--out,
                .zoom--in{
                    cursor: pointer;
                    line-height: 40px;
                    padding: 0 20px;
                    text-align: center;
                }

                .zoom--data{
                    width: 50px;
                    text-align: center;
                }
            }

            .grid__wrapper{
                display: flex;
                align-items: center;
                cursor: pointer;
                padding: 0px 20px;
                border-radius: 3px;
                line-height: 40px;
                svg{
                    margin-right: 10px;
                }
            }
        }

        .configurator__inner{
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            
            .configurator__entry{
                transition: transform 0.2s ease-out;
                width: 900px;
                height: 900px;
                position: absolute;
                box-shadow: 2px 2px 5px 0 rgba(0,0,0,0.7);

                .configurator__positioner{
                    position: relative;
                    width: 90px;
                    height: 90px;

                    .touch__area{
                        overflow: hidden;
                        position: absolute;
                        box-sizing: border-box;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        &.interactive{
                            cursor: pointer;

                            &:hover, &.active{
                                outline: 1px solid #E73246;
                            }
                        }

                    }
                }
            }
            .touch__area{
                &.bullet{
                    display: block;
                    border-radius: 50%;
                }
            }
            &.grid--visible{
                .touch__area{
                    border: 1px solid #b7b9b7;

                    &.no--outline{
                        border: none !important;
                    }
                }
            }
        }
    }
    hr{
        height: 1px;
        background-color: #CFCFCF;
        border: none;
        outline: none;
        margin: 15px 0;
    }
    .text__input{
        padding: 0 15px;

        label{
            display: block;
            font-size: 12px;
            color: #575C61;
            margin: 5px 0;
        }
        input{
            display: block;
            width: 100%;
            box-sizing: border-box;
            background-color: #EDEDED;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 12px;
            line-height: 24px;
            padding: 0 5px;
        }
    }

    .suggestion__wrapper{
        position: relative;

        .suggestion__selection{
            padding: 7px;
            margin: 0 15px;
            cursor: pointer;
            border: 1px solid #D9D9D9;
            background-color: #EDEDED;

            .suggestion--title{
                    font-size: 14px;
                }

                .suggestion--desc{
                    font-size: 12px;
                    color: #8F8F8F;
                }
        }

        .suggestion__list {
            position: absolute;
            top: 60px;
            right: 0;
            left: 0;
            background-color: white;
            border: 1px solid #CFCFCF;

            .suggestion__list--headline{
                font-size: 14px;
                font-family: 'averta-extrabold', Arial, Helvetica, sans-serif;
                margin: 12px 15px 0 15px;
            }

            .suggestion__list--wrapper{
                padding: 0 15px 15px 15px; 
                border-bottom: 1px solid #CFCFCF
            }

            .suggestion__search{

            }

            .category__list--wrapper{
                padding: 15px;

                .category_title{
                    position: relative;

                    svg{
                        right: 0;
                        top: 5px;
                        position: absolute;
                    }
                }
                .group_title{
                    font-family: 'averta-extrabold';
                }
            }

            .suggestion__entry{
                padding: 10px 0;
                cursor: pointer;

                .suggestion__entry--title{
                    font-size: 14px;
                }

                .suggestion__entry--desc{
                    font-size: 12px;
                    color: #8F8F8F;
                }
            }
        }
    }
</style>